(function() {
	'use strict';

	angular
		.module('pds', [
			'ngAnimate', 
			'ngCookies', 
			'ngTouch', 
			'ngSanitize', 
			'ngMessages', 
			'ngAria', 
			'ngResource', 
			'ui.router', 
			'ui.bootstrap',

			'datatables',
			'datatables.buttons',
			'ngStorage',
			'ui.select',
			'cp.ngConfirm',
			'daterangepicker',

			'pds.factories',
			'pds.services',
			'pds.directives',
			'pds.controllers',
			'pds.filters',
			'pds.config',
			'cgNotify',
			'ng.deviceDetector',
			'ngIdle'
		]);

	//Init
	angular.module('pds.factories', []);
	angular.module('pds.services', []);
	angular.module('pds.directives', []);
	angular.module('pds.controllers', []);
	angular.module('pds.filters', []);
})();

'use strict';

angular.module('pds.controllers')
	.controller('RootController', function (AppConst, StorageService, ItemFactory, $timeout) {
		var vm = this;
		vm.isLoading = true;

		$timeout(function() {
			vm.isLoading = false;
		}, 3000);
	})
	.controller('TopbarController', function (AccountService, StringConst, StorageService, $rootScope, $state) {

		var vm = this;
		vm.version = StorageService.get("app_version");

        vm.isUserLoggedOn = vm.userInfo = AccountService.userInfo();

		vm.logout = function() {
            AccountService.logout("On demand");
            $state.go(StringConst.Routing.State.Login, {}, {reload: true});
		}
		
		vm.showLogin = function() {
			var show = !vm.userInfo;
			if($state.current.name === StringConst.Routing.State.Login) { show = false }
			return show;
		}

		vm.advancedSearchCheckboxClicked = function() {
			$rootScope.advancedSearch = vm.advancedSearch;
		}
	})
	.controller('NavigationController', function (AccountService, StringConst, MenuItemConst, 
			PermissionService, $state) {
		var vm = this;

		vm.isUserLoggedOn = vm.userInfo = AccountService.userInfo();
		vm.menuItems = MenuItemConst.MenuItems;

		vm.showLogin = function() {
			var show = !vm.userInfo;
			if($state.current.name === StringConst.Routing.State.Login) { show = false }
			return show;
		}

		vm.showMenuItem = function(menuItemCode) {
			if(vm.isUserLoggedOn) {
				return PermissionService.checkPermission(vm.userInfo.userAccountTypeCode, menuItemCode);
			}
			else {
				return PermissionService.checkPermission(StringConst.Code.UserAccountType.Public, menuItemCode);
			}
		}
	});

'use strict';

angular.module('pds.controllers')
	.controller('ListController', function (AppConst, DTOptionsBuilder, DTColumnBuilder, 
			CommonService, DataService, ErrorHandlingService, ItemFactory, LocalDataService, 
			PermissionService, StringConst, StorageService, $filter, 
			$location, $rootScope, $scope, $state, $stateParams) {
		var vm = this;

		vm.isLoading = true;
		vm.linkId = $stateParams.id;
		vm.menuItem = LocalDataService.getMenuItemByLink(vm.linkId);

		vm.levelInfo = AppConst.Entity.LevelInfo[vm.menuItem.menuItemCode];
		if(vm.levelInfo) {
			vm.currentLevel = 1;
		}

		if(vm.menuItem.apiUrl == '') {
			$state.go("error", { "type": "UnderConstruction" });
		}

		var token = StorageService.get(AppConst.StorageKeys.Token);

		vm.columnsSearchKey = [];
		vm.visibleColumns = [];

		vm.dtInstance = {};

		vm.setLevel = function setLevel(level) {
			vm.currentLevel = level;
			vm.dtInstance.reloadData();
		}

		vm.exportExcel = function() {
			DataService.ExportExcel(vm.menuItem);
		}

		DataService.LoadColumnInfo(vm.menuItem, success, StringConst.ColumnInfoType.FlatInfo);

		function success(flatColumnInfo) {
			vm.columnInfo = flatColumnInfo;
			contructDataTable();
			loadFilteringData();
			vm.isLoading = false;

			for (var index = 0; index < vm.columnInfo.length; index++) {
				if(vm.columnInfo[index].IsVisible) {
					vm.columnsSearchKey[index] = " ";
				}

				if(vm.columnInfo[index].Name == "IsActive") {
					vm.columnsSearchKey[index] = true;
				}

				if(vm.columnInfo[index].Name == "IsFacility") {
					vm.columnsSearchKey[index] = false;
				}
			}
		}

		function contructDataTable() {
			vm.dtOptions = DTOptionsBuilder.newOptions()
				.withOption('ajax', {
					url: CommonService.buildUrl(vm.menuItem.apiUrl + '/List'),
					type: 'Post',
					beforeSend: function (xhr) {   //Include the bearer token in header
						var token = StorageService.get(AppConst.StorageKeys.Token);
						if(token) {
							xhr.setRequestHeader("Authorization", 'Bearer '+ token.access_token);
						}
					},
					data: function(data, dtInstance) {
						// Modify the data object properties here before being passed to the server 
						data["search[regex]"] = false;
						includeFilter(data);

						if(data.order[0].column == 0){
							setDefaultColumnOrder(data);
						}
					},
					dataSrc : function(response){
						response.recordsTotal = response.RecordsTotal;
						response.recordsFiltered = response.RecordsFiltered;
						response.data = response.Data;
						response.draw = response.Draw;

						return response.data;
					},
					error : function(error) {
						ErrorHandlingService.requestFailed(error, $location.path());
					} 
				})
				.withOption('fnRowCallback', function (row, data, dataIndex) {
					if(AppConst.Entity.PageWithFormatting.includes(vm.menuItem.menuItemCode) && data.Color !== null) {
						var rowStyle = "background:" + data.Color;
						angular.element(row).attr("style", rowStyle);
					}
				})
				.withOption('serverSide', true)
				.withOption('processing', true)
				.withDataProp('data')
				.withOption('pageLength', 50)
				.withOption('lengthMenu', [10, 50, 100, 200, 400, 500])
				.withOption('searchHighlight', true)

				.withOption("stateSave", true)
				.withOption('language', AppConst.UIConfig.DataTable.Language)
				.withDOM(AppConst.UIConfig.DataTable.DOM.All);

			vm.dtColumns = getDtColumns();
		}
		
		function getDtColumns() {
			var dtColumns = [];
			vm.columnInfo = $filter('orderBy')(vm.columnInfo, 'Order');

			dtColumns.push(constructLineNoColumn());

			_.each(vm.columnInfo, function(column) {
				if(column.IsVisible) {
					dtColumns.push(constructVisibleColumn(column));
				}			
			});

			return dtColumns;
		}

		function constructLineNoColumn() {
			var lineNumberCol = DTColumnBuilder.newColumn("LineNo").withOption('defaultContent', ' ');
			lineNumberCol.withTitle("Line No");		
			lineNumberCol.notSortable();
			lineNumberCol.withOption('width', '7%');
			lineNumberCol.renderWith(function(data, type, row, meta) {
				var lineNo = meta.row + meta.settings._iDisplayStart + 1;
				return '<a title="Show Detail">' + lineNo +  '</a>';
			});

			return lineNumberCol;
		}

		function constructVisibleColumn(column) {
			var col = DTColumnBuilder.newColumn(column.Name)
					.withTitle(!_.isNull(column.DisplayName) ? column.DisplayName.replace("Is ", "") : column.Name);
			vm.visibleColumns.push(column.Name);

			col.renderWith(function(data, type, full, meta) {
				return renderColumn(column, data, full)
			});

			var columnWidth = calculateWidth(column.Name);
			if(columnWidth != "-1%") {					
				col.withOption('width', columnWidth);
			}

			if(AppConst.Entity.BlackListedColumnOnListPage.includes(column.Name)
					|| column.DataType == 'ICollection`1') {
				col.withClass('none');
			}
			return col;
		}

		function renderColumn(column, data, full) {
			var formatedColumnData;
						
			//TODO write a separate method that style columns
			// build string to style for Boolean column
			var isActiveColumnClass = "";
			if(column.DataType == 'Boolean' && data == true) 
				isActiveColumnClass = 'style="color: green; font-size: 1.2em; font-weight: bolder; text-align: center;"';
			else if (column.DataType == 'Boolean' && data == false)
				isActiveColumnClass = 'style="color: red; font-size: 1.2em; font-weight: bolder; text-align: center;"';

			if(!_.isNull(column.Dependency)) {
				if(typeof full[column.Name.replace("ID", "")] == "string") {
					formatedColumnData =  full[column.Name.replace("ID", "")];
				}
				else {
					formatedColumnData =  $filter('customFormat')(full[column.Name.replace("ID", "")]);
				}
			}
			else {
				formatedColumnData = $filter('customFormat')(data, column.DataType, column.Name == 'SOH');											
			}

			var content = '<a ' + isActiveColumnClass;
			if(!(_.isUndefined(token) || 
					AppConst.Entity.ReportPage.includes(vm.menuItem.menuItemCode))) {
				content += ' href="/detail/' + vm.linkId + '/' + full.ID 
						+ '" title="' + (full.Name || full.FullItemName || "show detail") + '">';
			}
			else {							
				content += ' title="' + ( full.Name || full.FullItemName ) + '">';
			}
			
			content += formatedColumnData + '</a>';
			return content;
		}

		function includeFilter(data) {
			var index = 0;
			_.each(data.columns, function(column){
				if(AppConst.UIConfig.DataTable.NonSearchableColumns.includes(column.data)) {
					column.searchable = false;
				}
				else {
					column.search.value = (vm.columnsSearchKey[index] + ' ').trim();
					index += 1;
				}

				if(column.data == "Level" && vm.currentLevel) {
					column.search.value = vm.currentLevel;
				}
			});

			if($rootScope.advancedSearch) {
				data.columns[0].name = "AdvancedSearch";
			}
		}

		function setDefaultColumnOrder(data) {
			var primaryColumnIndex = getPrimaryColumn(data.columns);
			var isActveColumnIndex = getIsActiveColumn(data.columns);

			if(primaryColumnIndex != -1) {
				data.order[0].column = primaryColumnIndex;
				data.order[0].dir = "asc";
			}
			
			if(isActveColumnIndex != -1) {						
				data.order[1] = {};
				data.order[1].column = isActveColumnIndex;
				data.order[1].dir = "desc";
			}		
			
			if(vm.menuItem.menuItemCode == "LogChangeTracking") {
				data.order[0].dir = "desc";
			}
		}

		function getPrimaryColumn(columns) {
			var columnIndex = -1;
			columns.forEach(function(column, index) {
				if(AppConst.UIConfig.DataTable.PrimarySortColumn.includes(column.data)
						&& vm.menuItem.menuItemCode != "Item") {
					columnIndex = index;
				}
				else if(vm.menuItem.menuItemCode == "LogChangeTracking" && column.data == "ID") {
					columnIndex = index;
				}
			});
			return columnIndex;
		}

		function getIsActiveColumn(columns) {
			var isActveColumnIndex = -1;
			columns.forEach(function(column, index) {
				if(column.data == "IsActive") {
					isActveColumnIndex = index;
				}
			});
			return isActveColumnIndex;
		}

		function calculateWidth(columnIdentifier) {
			var width = -1;
			if(vm.columnInfo.Dependency !== null) {
				columnIdentifier = columnIdentifier.replace("ID", "");
			}

			if(AppConst.UIConfig.DataTable.XSmallWidthColumns.includes(columnIdentifier)) {
				columnIdentifier = "XSmall";
			}

			else if(AppConst.UIConfig.DataTable.SmallWidthColumns.includes(columnIdentifier)) {
				columnIdentifier = "Small";
			}

			else if(AppConst.UIConfig.DataTable.MediumWidthColumns.includes(columnIdentifier)) {
				columnIdentifier = "Medium";
			}

			switch(columnIdentifier){
				case "XSmall":
					width = 8;
					break;
				case "Small":
					width = 11;
					break;
				case "Medium":
					width = 18;
					break;
			}
			return width + "%";
		}

		function loadFilteringData() {
			vm.columnInfo.forEach(function(column) {
				if(column.Dependency && column.Dependency != StringConst.MenuItemCode.Item) {
					ItemFactory.itemResourceAll(column.Dependency).query(function(data){
						if(data.length > 0){
							vm['ChoiceList' + column.Dependency] = data;
						}
					});
				}
			});
		}

		// 
		vm.allowAction = function(actionIdentifier) {
			var checkActionValidity = !AppConst.Entity.HasNoAddPage.includes(vm.menuItem.menuItemCode);
			if(actionIdentifier == StringConst.Action.Export 
					&& AppConst.Entity.ReportPage.includes(vm.menuItem.menuItemCode)){
				checkActionValidity = true;
			}

			if(vm.menuItem.menuItemCode == "VolumeMetricsDataEntry" && actionIdentifier == "Export") {
				checkActionValidity = true;
			}

			if(vm.menuItem.menuItemCode == "LogChangeTracking" && actionIdentifier == "Export") {
				checkActionValidity = false;
			}
			
			try {
				if(actionIdentifier == StringConst.Action.Add 
					&& vm.menuItem.menuItemCode == StringConst.MenuItemCode.Item
					&& StorageService.get(AppConst.StorageKeys.UserInfo).userAccountTypeCode 
					== StringConst.Code.UserAccountType.ItemEditor) {
				checkActionValidity = false;
			}
			} catch (error) { }

			return checkActionValidity && PermissionService.allowAction(actionIdentifier);
		}

		vm.clearColumnsSearchKey = function() {
			for (var index = 0; index < vm.columnInfo.length; index++) {
				if(vm.columnInfo[index].IsVisible) {
					vm.columnsSearchKey[index] = " ";
				}
			}
			vm.dtInstance.reloadData();
		}
		
		$scope.$watch("vm.columnsSearchKey", function(newValue, oldValue){
			if(vm.columnInfo){				
				if(oldValue != null  && newValue != oldValue && vm.dtInstance.reloadData) {
					vm.dtInstance.reloadData();
				}
				
				vm.columnInfo.forEach(function(column) {
					if(column.FilterDependency) {
						var filterIndex = vm.visibleColumns.indexOf(column.FilterDependency + 'ID');
						vm['choiceFilter' + column.FilterDependency] = { };
						vm['choiceFilter' + column.FilterDependency][column.FilterDependency + 'ID'] =
											vm.columnsSearchKey[filterIndex];
					}
				});
			}
			
		}, true);
	});

'use strict';

angular.module('pds.controllers')
	.controller('EditController', function(AccountService, AppConst, DataService, ErrorHandlingService, FeedBackConst,
			ItemFactory, ItemService, LocalDataService, NotificationService, StorageService, StringConst, ValidationService, 
			$location, $scope, $state, $stateParams, $timeout) {
		var vm = this;

		vm.editMappedItemWarning = FeedBackConst.Warning.EditMappedItem;

		StorageService.set("Mode", 'Edit');
		vm.userInfo = AccountService.userInfo();
		vm.isLoading = true;
		vm.linkId = $stateParams.id;
		vm.objectId =  $stateParams.objectId;
		vm.objectModel = [];
		vm.successMessage = [];
		vm.warningMessage = [];
		vm.errorMessage = [];
		
		vm.menuItem = LocalDataService.getMenuItemByLink(vm.linkId);

		vm.hasDetailPage = AppConst.Entity.HasNoDetailPage.includes(vm.menuItem.menuItemCode);

		var rejectEdit = AppConst.Entity.NonEditableEntities.includes(vm.menuItem.menuItemCode);
		
		if(rejectEdit){
			$location.path('/list/Item');
		}

		DataService.LoadEditEntityData(vm.menuItem, success, loadDataFailed);

		function success(columnInfo) {
			vm.columnInfo = columnInfo;
			columnInfoLoaded();
		}

		function loadDataFailed() { 
			$state.go("error");
		}

		function columnInfoLoaded() {
			// intialize watcher for dependent properties
			intializeWatchers();
			vm.columnInfo.CurrentEntityCode = vm.menuItem.menuItemCode;
			ItemFactory.getSingle(vm.menuItem.apiUrl, vm.objectId).get(vm.objectId, function(data){
				vm.isLoading = false;

				vm.entity = data;
				StorageService.set("currentEntityOnEdit", vm.entity);
				var index = 0;
				for (var property in vm.entity) {
					if (vm.entity.hasOwnProperty(property)) {
						vm.objectModel[index] = vm.entity[property];
					}
					index++;
				}

				fixDateFormatForEditForm();

				// enforce a constraint item relationships cannot be removed once added
				$timeout(function() {
					if(vm.menuItem.menuItemCode == StringConst.MenuItemCode.Item
							|| vm.menuItem.menuItemCode == StringConst.MenuItemCode.Accessory) {
						var multiSelects = document.querySelectorAll('.ui-select-multiple');
						_.each(multiSelects, function(multiSelect){
							// remove ui-selcet-match-close button for item collection
							// execept for Category and Program
							if(!allowDelete(multiSelect)) {
								var selectedItems = multiSelect.querySelectorAll('.ui-select-match-close');
								_.each(selectedItems, function(button){
									button.parentNode.removeChild(button);
								});
							}
						});
					}
				}, 1000);

				function allowDelete(multiSelect) {
					switch (multiSelect.id) {
						case StringConst.MenuItemCode.ItemCategory:
							return true;
						case StringConst.MenuItemCode.ItemProgramt:
							return vm.userInfo.userAccountTypeCode == StringConst.Code.UserAccountType.Admin;
						default:
							return false;
					}

					return allowDelete;
				}
				
			}, function(error) {
				ErrorHandlingService.requestFailed(error, $location.path());
			});
		}

		vm.resetForm = function() {
			if(vm.edit.$dirty){
				vm.entity = StorageService.get("currentEntityOnEdit");
			}
		}

		vm.editItem = function() {
			if(vm.edit.$dirty && vm.errorMessage.length == 0 && !vm.checkingError) {
				var validation = ValidationService.validateEntity(vm.entity, vm.menuItem);
				if(validation.isValid) {
					vm.isLoading = true;
					StorageService.set(StringConst.StorageKey.TempExistingEntity, vm.entity);
					ItemService.edit(vm.menuItem, vm.columnInfo, vm.entity, 
							editSuccess, editFailed);
				}
				else {
					$timeout(function() {
						vm.errorMessage[0] = validation.message;
					}, 0);
				}
			}
		}
		
		function editSuccess(data) {
			if(data.Success) {
				NotificationService.notify(vm.menuItem.label + ' Edited Successfully!', 'alert-success');
				if(AppConst.Entity.HasNoDetailPage.includes(vm.menuItem.menuItemCode)) {
					vm.successMessage = data.Info;
					vm.warningMessage = data.Warning;
					vm.isLoading = false;

					if(vm.menuItem.menuItemCode != StringConst.MenuItemCode.ItemUnitOfIssueMapping) {
						$location.path('/detail/' + vm.menuItem.menuItemCode + "/" + vm.objectId);
					}
				}
				else {
					$location.path('/detail/' + vm.menuItem.menuItemCode + "/" + vm.objectId);
				}
			}
			else {
				editFailed(data);
				vm.entity =StorageService.get(StringConst.StorageKey.TempExistingEntity);
				$timeout(function() {
					vm.errorMessage = data.Error;
					vm.isLoading = false;
					ItemService.fixOverflowOnBlockingMode(false);
				}, 1000);
			}
		}

		function editFailed() {
			NotificationService.notify(vm.menuItem.label + ' Edit Failed!', 'alert-danger');
			vm.isLoading = false;
		}

		vm.showInput = function(columnInfo){
			return columnInfo.IsVisible && 
					(!columnInfo.IsAutoGenerated || columnInfo.Name =='StockCode'
					|| columnInfo.Name =='Name') &&
					(columnInfo.DataType != 'ICollection`1' || columnInfo.Name == 'Category')
		}

		vm.checkForError = function() {
			switch(vm.menuItem.menuItemCode) {
				case StringConst.MenuItemCode.ItemUnitOfIssue:
					if(vm.entity.ItemUnitOfIssueID != null){
						return FeedBackConst.Error.ItemUnitOfIssueHasAlternate;
					}
					break;
				default: 
					break;
			}
		}

		vm.inputClass = {'col-sm-6': vm.menuItem.menuItemCode != StringConst.MenuItemCode.Item
				&& vm.menuItem.menuItemCode != StringConst.MenuItemCode.ItemUnitOfIssue
				&& vm.menuItem.menuItemCode != StringConst.MenuItemCode.ItemUnitOfIssueMapping};
		
		vm.editClass = {'col-sm-6': vm.menuItem.menuItemCode == 'Item' 
				|| vm.menuItem.menuItemCode == 'Manufacturer'
				|| vm.menuItem.menuItemCode == 'Supplier'
				|| vm.menuItem.menuItemCode == 'Institution'
				|| vm.menuItem.menuItemCode == 'MenuItemInfo'
				|| AppConst.Entity.RelatedMetaData[vm.menuItem.menuItemCode]}

		function fixDateFormatForEditForm() {
			_.each(vm.columnInfo, function(columnInfo){
				if (columnInfo.DataType == 'DateTime') {
					vm.entity[columnInfo.Name] =  new Date(vm.entity[columnInfo.Name]);
				}
			})
		}

		$scope.$watch("vm.entity", function(newValue, oldValue) {
			$timeout(function(){
				if(oldValue != null && vm.edit != undefined && vm.edit.$valid) {	
					validateEntity();
				}
			}, 0);
			
		}, true);

		function validateEntity() {
			vm.checkingError = true;
			StorageService.set("EntityValidationModel", vm.entity);
			ItemService.validateEntity(vm.menuItem, StorageService.get("EntityValidationModel"), 
					changeErrorStatus, function(){});
		}

		function changeErrorStatus(data) {
			vm.checkingError = false;
			if(data) {
				vm.errorMessage = data.Error;
				vm.warningMessage = data.Warning;
			}
		}

		function intializeWatchers() {
			switch (vm.menuItem.menuItemCode) {
				case StringConst.MenuItemCode.Item:
					vm.generateStockCode = function() {
						if(vm.entity.Category.length > 0){
							ItemService.itemCategoryChanged(vm.entity);
						}
					}
	
					vm.showGenerateStockCode = function() {
						return !vm.entity.IsReceived && !vm.entity.IsConfirmed;
					}
	
					$scope.$watch("vm.entity.CommodityTypeID", function(newValue, oldValue){
						if(newValue != oldValue) {
							var currentCommodityType = _.find(StorageService.get("CommodityType"), function(commodityType){
								return commodityType.ID == vm.entity.CommodityTypeID;});
							StorageService.set("CurrentCommodityType", currentCommodityType);
							// vm.entity.ProductID = null;
							// vm.entity.Category = [];
						}
					}, true);
					break;
				default:
				vm.columnInfo.forEach(function(info) {
					if(info.FilterDependency) {
						var parentInput = "vm.entity." + info.FilterDependency + "ID";
							$scope.$watch(parentInput, function(newValue, oldValue){
								if(oldValue != null && newValue != oldValue) {
									vm.entity[info.Name] = null;
									vm.entity[info.Name.replace("ID", "")] = null;
								}
							}, true);
						}
					});
					break;
			}

			$scope.$watch("vm.entity", function(newValue, oldValue){
				if(newValue != oldValue) {
					vm.errorMessage = [];
					vm.successMessage = [];
					vm.warningMessage = [];
				}
			}, true);
		}
		
	});

'use strict';

angular.module('pds.controllers')
	.controller('DetailController', function(AppConst, DataService, ErrorHandlingService, ItemFactory, ItemService, 
			LocalDataService, NotificationService, PermissionService, StorageService, StringConst,
			$filter, $location, $ngConfirm, $scope, $state, $stateParams) {
		var vm = this;

		vm.isLoading = true;
		vm.linkId = $stateParams.id;
		vm.objectId = $stateParams.objectId;

		vm.menuItem = LocalDataService.getMenuItemByLink(vm.linkId);

		if(AppConst.Entity.HasNoDetailPage.includes(vm.menuItem.menuItemCode)){
			$location.path('/edit/' + vm.menuItem.menuItemCode + "/" + vm.objectId);
		}

		else {
			vm.entityDependency = [];
			vm.entityDependencyColumnInfo = [];

			var token = StorageService.get(AppConst.StorageKeys.Token);
			var user = StorageService.get(AppConst.StorageKeys.UserInfo);

			vm.isItemPage = vm.menuItem.menuItemCode == StringConst.MenuItemCode.Item;

			vm.openConfirmationModal = function(actionIdentifier, actionTitle) {
				vm.actionConfirmationTerms = getActionConfirmationTerms(actionIdentifier);
				openModal(actionIdentifier, actionTitle);
			}

			vm.showContent = function(columnInfo) {
				var dynamicVisibility = columnInfo.DynamicVisibility;
				var isVisible = columnInfo.IsVisible && columnInfo.DataType != 'ICollection`1';
				if(dynamicVisibility !== null) {
					var currentValue = dynamicVisibility.Dependency !== null
							? vm.entity[dynamicVisibility.Dependency][dynamicVisibility.PropertyName]
							: vm.entity[dynamicVisibility.PropertyName];
	
					isVisible = dynamicVisibility.InterstingValues.includes(currentValue);
				}
				return isVisible;
			}

			function openModal(actionIdentifier, actionTitle) {
				vm.confirmModal = $ngConfirm({
					title: actionTitle + " " + (vm.entity.Name || vm.entity.FullName 
							|| getItemFullName()),
					content: AppConst.NgConfirm.DefaultMessage + 
							'<modal-content></modal-content>',
					scope: $scope,
					closeIcon: true,
					type: 'red',
					onScopeReady: function(scope){
						// when the scope is ready/created
						if(vm.actionConfirmationTerms) {
							if(vm.actionConfirmationTerms.RequireFeedBack) {
								this.buttons.Confirm.disabled = true;
								vm.popUpScope = this;
								scope.$watch("vm.acceptTerms", function(newValue, oldValue){
									if(newValue != oldValue) {
										var termAccepted = vm.acceptTerms.length 
												== vm.actionConfirmationTerms.Value.length
												&& vm.acceptTerms.every(function(isChecked){
													return isChecked === true;
												})
												&& Object.values(vm.acceptTerms).length === vm.acceptTerms.length;
										vm.confirmModal.buttons.Confirm.setDisabled(!termAccepted);
									}
								}, true);
							}
						}						
					},
					buttons: {
						Confirm: {
							text: "Yes",
							btnClass: 'btn-warning',
							action: function() {
								switch (actionIdentifier) {
									case StringConst.Action.Activate:								
										activateItem();
										break;
									case StringConst.Action.Confirm:
										confirm();
										break;
									default:
										break;
								}
							}
						},
						Cancel: {
							text: "No"
						}
					}
				});
			}

			function getActionConfirmationTerms(actionIdentifier) { 
				switch (actionIdentifier) {
					case StringConst.Action.Activate:
						if(vm.menuItem.menuItemCode == StringConst.MenuItemCode.Item){
							if(vm.entity.IsActive) {
								vm.acceptTerms = [];
								return AppConst.Terms.ItemDeactivate;
							}
							else if(!vm.entity.IsActive && vm.entity.IsFacility) {
								vm.acceptTerms = [];
								return AppConst.Terms.FacilityItemActivate;
							}
							else if(!vm.entity.IsActive && vm.entity.IsMapped) {
								vm.acceptTerms = [];
								return AppConst.Terms.ItemActivate;
							}
						}
						break;
				
					default:
						break;
				}
			}

			vm.getPropertyName = function(columnInfo) {
				var Name = columnInfo.Name;
				if(!_.isNull(columnInfo.Dependency)){
					Name = columnInfo.Name.replace("ID", "");
				}
				return Name;
			}

			// 
			vm.allowAction = function(actionIdentifier) {		
				if(vm.entity == undefined)
					return false;
				var permissionCheck = PermissionService.allowAction(actionIdentifier);
				var statusCheck = true;
				var allowEdit = true;

				if(actionIdentifier == StringConst.Action.Edit)
					allowEdit = !AppConst.Entity.NonEditableEntities.includes(vm.menuItem.menuItemCode);
				
				if(actionIdentifier == StringConst.Action.Confirm) {
					statusCheck = vm.entity.IsConfirmed != undefined 
							&& (vm.entity.CreatedBy != user.ID
							|| user.userAccountTypeCode == StringConst.Code.UserAccountType.Admin)
							&& vm.entity.IsActive;
					statusCheck = statusCheck;
				}

				if(actionIdentifier == StringConst.Action.Activate
						&& vm.menuItem.menuItemCode == StringConst.MenuItemCode.Item) {
					statusCheck = user.userAccountTypeCode != StringConst.Code.UserAccountType.Editor;
				}

				if(actionIdentifier == StringConst.Action.Activate
						&& vm.menuItem.menuItemCode == "InstitutionEnhancement") {
					statusCheck = false;
				}
				return permissionCheck && statusCheck && allowEdit;
			
			}

			DataService.LoadColumnInfo(vm.menuItem, success);

			function success(columnInfo) {
				vm.columnInfo = columnInfo;
				columnInfoLoaded();
			}

			function columnInfoLoaded() {
				ItemFactory.getSingle(vm.menuItem.apiUrl, vm.objectId).get(vm.objectId, function(data) {
					vm.entity = data;	
					if(!vm.entity.IsConfirmed) vm.confirmActionTitle = StringConst.Action.Confirm;
					else vm.confirmActionTitle = StringConst.Action.Revoke;	
					intializeEntityDependency();		
					vm.isLoading = false;
				}, function(error){
					ErrorHandlingService.requestFailed(error, $location.path());
				});
			}

			function confirm() {
				vm.entity.IsConfirmed = !vm.entity.IsConfirmed;
				StorageService.set("TempEntity", vm.entity);
				vm.entity.IsConfirmed = !vm.entity.IsConfirmed;
				ItemService.edit(vm.menuItem, vm.columnInfo, null, confirmSuccess, confirmFailed);
			}

			function confirmSuccess(data) {
				if(data.Success){
					NotificationService.notify('Operation Succeed!', 'alert-success');
					vm.entity.IsConfirmed = !vm.entity.IsConfirmed;
				}
				else {
					NotificationService.notify('Operation Failed! Please try again.', 'alert-danger');
				}
			}

			function confirmFailed() {
				NotificationService.notify('Operation Failed!', 'alert-danger');
			}

			function activateItem() {
				vm.entity.IsActive = !vm.entity.IsActive;
				if(!vm.entity.IsActive && vm.entity.IsConfirmed != undefined){
					vm.entity.IsConfirmed = false;
				}
				StorageService.set("TempEntity", vm.entity);
				vm.entity.IsActive = !vm.entity.IsActive;
				ItemService.edit(vm.menuItem, vm.columnInfo, null, activateSuccess, activateFailed);
			}

			function activateSuccess(data) {
				if(data.Success){
					NotificationService.notify('Operation Succeed!', 'alert-success');
					$state.go('detail', {id: vm.menuItem.menuItemCode, objectId: vm.entity.ID}, {reload: true});
				}
				else {
					NotificationService.notify('Operation Failed! Please try again.', 'alert-danger');
				}
				
			}

			function activateFailed() {
				NotificationService.notify('Operation Failed!', 'alert-danger');
			}

			function intializeEntityDependency() {

				for (var property in vm.columnInfo) {
					if (vm.columnInfo.hasOwnProperty(property)) {
						var propertyValue = vm.columnInfo[property];
						if((propertyValue.Dependency !== undefined && propertyValue.Dependency !== null) 
								|| propertyValue.DataType === "ICollection`1"){
							var dependency = {};

							dependency.code = propertyValue.Name.replace('ID','');
							dependency.name = $filter('formatCamelCase')(dependency.code);
							dependency.data = vm.entity[dependency.code];
							dependency.isArray = angular.isArray(dependency.data);
							dependency.showHeader = AppConst.Entity.Item.DependencyWithHeader.includes(dependency.code)
									&& dependency.data.length > 0;
							dependency.order = propertyValue.Order;
							vm.entityDependency.push(dependency);
						}
					}
				}
			}

			function getItemFullName(){
				try {
					var itemFullName = ""
					if(vm.entity.Product !== null){ itemFullName += vm.entity.Product.Name }
					if(vm.entity.Strength !== null){ itemFullName += vm.entity.Strength.Name }
					if(vm.entity.DosageForm !== null){ itemFullName += vm.entity.DosageForm.Name }
					if(itemFullName.length > 40) { itemFullName = itemFullName.substring(0, 40)  + "..." }
					return itemFullName;
				} catch (error) {
					return vm.menuItem.menuItemCode;
				}
			}

			$scope.$watch("vm.entity.IsConfirmed", function(newValue, oldValue){
				if(newValue != oldValue) {
					if(vm.entity.IsConfirmed) vm.confirmActionTitle = StringConst.Action.Revoke;
					else vm.confirmActionTitle = StringConst.Action.Confirm;
				}
			}, true);

			$scope.$watch("vm.entity.IsActive", function(newValue, oldValue){
				if(newValue != oldValue) {
					if(vm.entity.IsActive) vm.activateActionTitle = StringConst.Action.Deactivate;
					else vm.activateActionTitle = StringConst.Action.Activate;
				}
			}, true);
		}
	});
'use strict';

angular.module('pds.controllers')
	.controller('AddController', function(DataService, DefaultEntityService, ItemService, LocalDataService, 
			NotificationService, StorageService, StringConst, ValidationService, 
			$location, $scope, $state, $stateParams, $timeout) {
		var vm = this;

		StorageService.set("Mode", 'Add');

		vm.errors = [];
		vm.isLoading = true;
		vm.linkId = $stateParams.id;
		vm.menuItem = LocalDataService.getMenuItemByLink(vm.linkId);
		
		DataService.LoadAddEntityData(vm.menuItem, loadDataSuccess, loadDataFailed);

		function loadDataSuccess(columnInfo, defaultEntity) {
			vm.columnInfo = columnInfo;
			
			vm.entity = defaultEntity;
			
			// intialize watcher for dependent properties
			intializeWatchers();

			if(vm.menuItem.menuItemCode == StringConst.MenuItemCode.Item) {	
				StorageService.set("CurrentCommodityType", vm.entity.CommodityType);		
			}

			vm.isLoading = false;
		}

		function loadDataFailed() { 
			$state.go("error");
		}

		vm.resetForm = function() {
			vm.entity = DefaultEntityService.GetDefaultEntity(vm.menuItem.menuItemCode, 
					StorageService.get("CommodityType"));
			
			StorageService.set("CurrentCommodityType", vm.entity.CommodityType);
		}

		vm.addItem = function() {
			if(vm.errors.length == 0 && !vm.checkingError){	
				var validation = ValidationService.validateEntity(vm.entity, vm.menuItem);
				if(validation.isValid) {
					vm.isLoading = true;	
					StorageService.set(StringConst.StorageKey.TempNewEntity, vm.entity);
					ItemService.add(vm.menuItem, vm.columnInfo, vm.entity, addSuccess, addFailed);
				}
				else {
					$timeout(function() {
						vm.errors[0] = validation.message;
					}, 0);
				}
			}
		}

		function addSuccess(data) {
			if(data.ID && data.ID != -1) {				
				NotificationService.notify(vm.menuItem.label + ' Added Successfully!', 'alert-success');
				$location.path('/detail/' + vm.menuItem.menuItemCode + "/" + data.ID);
			}
			else if(data.ID == -1) {	
				addFailed();
			}
			else {
				vm.entity = StorageService.get(StringConst.StorageKey.TempNewEntity);
				$timeout(function(){
					vm.errors = data.Error;
					addFailed();
				}, 100);
			}
		}

		function addFailed() {			
			vm.isLoading = false;
			NotificationService.notify(vm.menuItem.label + ' Add Failed!', 'alert-danger');
			ItemService.fixOverflowOnBlockingMode(false);
		}

		function intializeWatchers() {
			var currentCommodityType;
			switch (vm.menuItem.menuItemCode) {
				case StringConst.MenuItemCode.Item:
					$scope.$watch("vm.entity.CommodityTypeID", function(newValue, oldValue){
						if(newValue != oldValue) {
							if(vm.entity.CommodityTypeID) {
								currentCommodityType = _.find(StorageService.get("CommodityType"), function(commodityType){
									return commodityType.ID == vm.entity.CommodityTypeID;});
							}
							else {
								currentCommodityType = _.find(StorageService.get("CommodityType"), function(commodityType){
									return commodityType.CommodityTypeCode 
											== StringConst.Code.CommodityType.Pharmaceutical;
								});
							}

							vm.entity = DefaultEntityService.GetDefaultEntity(vm.menuItem.menuItemCode, 
										currentCommodityType);
							StorageService.set("CurrentCommodityType", vm.entity.CommodityType);	
						}
					}, true);

					$scope.$watch("vm.entity.ProductID", function(newValue, oldValue){
						if(newValue != oldValue) {
							vm.entity.ProductBasecodeID = null;
							vm.entity.SuggestedBasecode = null;
							vm.entity.BasecodeName = null;
						}
					}, true);

					$scope.$watch("vm.entity.ShowAllBasecodes", function(newValue, oldValue) {
						if(newValue != oldValue) {
							StorageService.set("ShowAllBasecodes", vm.entity.ShowAllBasecodes)
						}
					}, true);

					$scope.$watch("vm.entity", function(newValue, oldValue) {
						$timeout(function(){
							if(vm.add.$valid) {	
								validateItem();
							}
						}, 0);
						
					}, true);

					function validateItem(){
						vm.checkingError = true;
						ItemService.validateItem(vm.menuItem, vm.entity, changeErrorStatus, function(){});
					}

					function changeErrorStatus(data){
						vm.errors = data.errors;
						vm.checkingError = false;
					}

					// generate stock code based on the selected category
					$scope.$watch("vm.entity.Category", function(newValue, oldValue){
						if(newValue && newValue != oldValue) {
							ItemService.itemCategoryChanged(vm.entity);
						}
					}, true);

					$scope.$watch("vm.entity.ProductBasecodeID", function(newValue, oldValue){
						if(newValue && newValue != oldValue) {
							vm.entity.BasecodeName = null;
							vm.entity.SuggestedBasecode = null;
							try {
								if(vm.entity.CommodityType.CommodityTypeCode !== 'MEDE'
										&& vm.entity.ProductBasecodeID == -1) {
									ItemService.getSuggestedBasecode(vm.menuItem, vm.entity, 
											function(result){
												vm.entity.SuggestedBasecode = result.suggestedBasecode;
											}, function(){});
								}
								else if(vm.entity.ProductBasecodeID > 1) {
									vm.entity.BasecodeName = _.find(StorageService.get(StringConst.MenuItemCode.ProductBasecode), function(basecode) {
										return basecode.ID == vm.entity.ProductBasecodeID;
									  }).Basecode;
									  console.log();
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, true);
					break;
				
				case StringConst.MenuItemCode.Institution:
					$scope.$watch("vm.entity.OwnershipTypeID", function(newValue, oldValue) {
						$timeout(function(){
							vm.entity.OwnershipType = _.find(StorageService.get("OwnershipType"), function(OwnershipType){
								return OwnershipType.ID == vm.entity.OwnershipTypeID;});
						}, 0);					
					}, true);

					
					$scope.$watch("vm.entity.ExistingInstitutionID", function(newValue, oldValue) {
						$timeout(function() {
							if(newValue != 0) {
								vm.entity.ExistingInstitutionID = null;
							}
						}, 0);
					}, true);
					
				default:
					// Find dependent property
					// When parent propety value changes, reset dependent property
					vm.columnInfo.forEach(function(info) {
						if(info.FilterDependency){
							var parentInput = "vm.entity." + info.FilterDependency + "ID";
							$scope.$watch(parentInput, function(newValue, oldValue){
								if(newValue != oldValue) {
									vm.entity[info.Name] = null;
									vm.entity[info.Name.replace("ID", "")] = null;
								}
							}, true);
						}
					});

					$scope.$watch("vm.entity", function(newValue, oldValue) {
						$timeout(function(){
							vm.errors = [];
						}, 0);					
					}, true);
					break;
			}
		}
	});

'use strict';

angular.module('pds.services')
	.factory('ValidationService', function( FeedBackConst, StringConst ) {
        var ValidationService = {};

        ValidationService.validateEntity = function(entity, menuItem) {
			switch (menuItem.menuItemCode) {
                case StringConst.MenuItemCode.Item:
                    return validateItem(entity);
                case StringConst.MenuItemCode.Institution:
                    return validateInstition(entity);
                default:
                    return { isValid : true };
            }
        };

        function validateItem(item) {
            var itemValidation = { isValid : true };

            try {
                if(item.BasecodeName && !item.BasecodeName.match(/^[a-zA-Z0-9]{4}[-]{1}[0-9]{2,3}/)) {
                    itemValidation.message = FeedBackConst.Validation.Item.InvalidBasecode;
                    itemValidation.isValid = false;
                }
                
                else if(item.UnitOfIssue.length > 0) {
                    var defaultRRFFound = false;
                    
                    item.UnitOfIssue.forEach(function(unit) {
                        if(unit.IsDefaultRRF) {
                            defaultRRFFound = true;
                        }
                    });
                    
                    if(!defaultRRFFound) {
                        itemValidation.message = FeedBackConst.Validation.Item.DefaultRRFUnitNotSelected;
                        itemValidation.isValid = false;
                    }
                }
                
            } catch (error) {
                itemValidation.isValid = false;
            }

            return itemValidation;
        };
        
        function validateInstition(instition) {
            try {
                var institionValidation = {};
                var isAddMode = instition.ID === undefined;
                if(instition.Name.match(/[\(\)\[\]\{\}]+/) && isAddMode) {
                    institionValidation.message = FeedBackConst.Validation.Institution.BracketNotAllowed;
                    institionValidation.isValid = false;
                }

                else if(instition.Name.match(/[\u1200-\u137F]+/) && isAddMode) {
                    institionValidation.message = FeedBackConst.Validation.Institution.AmharicCharacterNotAllowed;
                    institionValidation.isValid = false;
                }

                else if(instition.Name.match(/^\d+$/) && isAddMode) {
                    institionValidation.message = FeedBackConst.Validation.Institution.NumberOnlyNotAllowed;
                    institionValidation.isValid = false;
                }

                else if(!instition.Name.match(/^[a-zA-Z0-9]/) && isAddMode) {
                    institionValidation.message = FeedBackConst.Validation.Institution.AllowedIntial;
                    institionValidation.isValid = false;
                }

                else if (instition.OwnershipType.OwnershipTypeCode != 'PUB' && !instition.TinNo) {
                    institionValidation.message = FeedBackConst.Validation.Institution.EmptyTinNo;
                    institionValidation.isValid = false;
                }

                else {
                    institionValidation.isValid = true;
                }               
            } catch (error) {
                institionValidation = false;
            }

            return institionValidation;
        }

        return ValidationService;
    });

'use strict';

angular.module('pds.services')
    .factory('StorageService', function($localStorage) {
        var storageService = {};

        //read value from localStorage by a key
        storageService.get = function(key) {
            if ($localStorage[key] != undefined) return angular.fromJson($localStorage[key]);
            return undefined;
        };

        //store any value in localStorage by a given key
        storageService.set = function(key, value) {
            if(value != null) {
                $localStorage[key] = angular.toJson(value);
            }
        };

        storageService.removeAll = function() {
            delete $localStorage.$reset();
        };

        storageService.remove = function(key) {
            delete $localStorage[key];
        };

        return storageService;
    });
'use strict';

angular.module('pds.services')
	.factory('PermissionService', function(AppConst, StringConst, StorageService) {
		var permissionService = {};
		
		permissionService.allowAction = function(actionIdentifier) {
            var token = StorageService.get(AppConst.StorageKeys.Token);
			var user = StorageService.get(AppConst.StorageKeys.UserInfo);

			if(actionIdentifier == StringConst.Action.Export) {
				return true;
			}

			if (token == undefined || user == undefined) { 
				return false; 
			}

			else if(actionIdentifier == "Detail" || user.userAccountTypeCode == "ADM") {
				return true;
			}
			
			else {
				var actions = permissionService.getActionList();
				return actions.includes(actionIdentifier);
			}		
		}

        permissionService.checkPermission = function(userTypeCode, menuItemIdentifier) {
			if(userTypeCode == StringConst.Code.UserAccountType.Admin) { 
				return true 
			}
			var userPermission = permissionService.getMenuItemsList();
			return userPermission.includes(menuItemIdentifier);
		}
		
		permissionService.getMenuItemsList = function() {
			try {
				var user = StorageService.get(AppConst.StorageKeys.UserInfo);
				var menuItems = [];
				user.menuItems.forEach(function(menuItem) {
					if(menuItem.IsActive) {
						menuItems.push(menuItem.PDSPermissionMenuItem.Code);
					}
				});
				return menuItems;
			} catch (error) {
				return AppConst.Permission[StringConst.Code.UserAccountType.Public];
			}
		}
		
		permissionService.getActionList = function() {
			try {
				var user = StorageService.get(AppConst.StorageKeys.UserInfo);
				var actions = [];
				user.role.Operation.forEach(function(operation) {
					if(operation.IsActive) {
						switch (operation.Operation.Name) {
							case "Create":
								actions.push("Add");
								break;
							case "Update":
								actions.push("Edit");
								break;
							default:
								actions.push(operation.Operation.Name);
								break;
						}
					}
				});
				return actions;
			} catch (error) {
				return [];
			}
		}

		return permissionService;
	});
'use strict';

angular.module('pds.services')
    .service('NotificationService', function(notify) {

        var NotificationService = {};

        NotificationService.notify = function(message, cls, duration) {
            notify({
                message: message,
                classes: cls,
                templateUrl: "app/common/templates/layout/notify.html",
                position: 'right',
                duration: duration
            });
        };

        return NotificationService;
    });

'use strict';

angular.module('pds.services')
	.factory('LocalDataService', function(MenuItemConst) {
		var localDataService = {};

		localDataService.getMenuItemByLink = function(link){
			var found;
			_.each(MenuItemConst.MenuItems, function(menuItem) {
				if(angular.isUndefined(found)){
					found = _.find(menuItem.subMenu, function(subMenu){
						var currentLink = 'list({ id: "' + link + '"})';
						return subMenu.link === currentLink;
					});
				}
			})

			return found;
		}

		return localDataService;
	});
'use strict';

angular.module('pds.services')
    .factory('httpInterceptor', function($window, $q, $location, StorageService, AppConst,$cacheFactory) {
        var http_ttl_cache = {};
        return {
            responseError: function(response) {
                if ($window.location.href.indexOf("localhost") <=
                    -1 ) {
                    if (response != null && response.data != null)
                        var errorDesc = "Status Code:- " + response.status + ", " +
                            "Status Text:- " + response.statusText + ", " +
                            "Url causing error:- " + response.config.url + ", " +
                            "Status Message:- " + response.data.Message;
                    else if (response != null)
                        errorDesc = "Status Code: " + response.status + ", " +
                        "Status Text:- " + response.statusText + ", " +
                        "Url causing error:- " + response.config.url;
                    try {
                        $window.ga('set', 'dimension5', "Status Code: " + response.status);
                        $window.ga('send', 'exception', {
                            'exDescription': errorDesc,
                            'exFatal': true
                        });
                    } catch (error) { }
                }

                if($window.location.href.indexOf("/reset/")>-1){
                    return $q.resolve(response)
                }

                else if (response.status === 401) {                     
                    StorageService.remove(AppConst.StorageKeys.UserInfo);
                    StorageService.remove(AppConst.StorageKeys.Token);
                    $window.location.reload();
                }
                
                else if (response.status === 403) {
                    $location.path('/error');
                    return $q.reject(response);
                } 
                
                else {
                    return $q.reject(response);
                }
            },
            request: function(config) {
                var token = StorageService.get(AppConst.StorageKeys.Token);

                if (!_.isUndefined(token)) {
                    config.headers['Authorization'] = 'Bearer ' + token.access_token;
                }

                removeExpiredCache(config);

                return config;
            }
        };

        function removeExpiredCache(config) {
            var timeToLive;
            if(config.timeToLive) {
                config.cache = true;
                timeToLive = config.timeToLive;
                delete config.timeToLive;
                
                if(new Date().getTime() - (http_ttl_cache[config.url] || 0) > timeToLive) {
                    $cacheFactory.get('$http').remove(config.url);
                    http_ttl_cache[config.url] = new Date().getTime();
                }
            }
        }
    });

'use strict';

angular.module('pds.services')
    .service('DtRequestService', function(AppConst, StringConst, $rootScope) {
        var DtRequestService = { };
        
        DtRequestService.buildDefaultPageRequestParam = function (menuItemCode, dependency, inputMetaData) {
            var requestParam = angular.copy(AppConst.UIConfig.UISelect.PageRequestTemplate);
            requestParam.columns[0] = angular.copy(AppConst.UIConfig.UISelect.DefaultSearchColumn);
            requestParam.order[0] = angular.copy(AppConst.UIConfig.UISelect.DefaultSortColumn);
            requestParam.search = angular.copy(AppConst.UIConfig.UISelect.DefaultSearch);

            switch (dependency) {
                case StringConst.MenuItemCode.FiscalYear:
                    requestParam.order[0].dir = 'desc';
                    break;
                case StringConst.MenuItemCode.Product:
                    requestParam.columns[1] = getSecondarySearchColumn("CommodityTypeID", true);
                    break;
                case StringConst.MenuItemCode.Category:
                    requestParam.length = 200;
                    requestParam.columns[1] = getSecondarySearchColumn("Level", true);
                    requestParam.columns[1].search.value = 3;
                    break;
                case StringConst.MenuItemCode.ItemUnitOfIssue:
                    if(menuItemCode == "VolumeMetrics") {
                        requestParam.columns[1] = getSecondarySearchColumn("ItemID", true);
                        requestParam.columns[0].data = "UnitOfIssue";
                        requestParam.search.regex = false;
                    }
                    else {
                        requestParam.search.regex = false;
                        var inc = 1;
                        var filterColumns = AppConst.Entity.FilterColumns.ItemUnitOfIssue;

                        if(menuItemCode == StringConst.MenuItemCode.ItemUnitOfIssueMapping) {
                            inc = 2;
                            requestParam.columns[1] = getSecondarySearchColumn("CommodityTypeID", true);
                            filterColumns = _.without(filterColumns, "ID");
                        }
                        addFilteringColumns(filterColumns, inc, requestParam);
                    }
                    break;
                case StringConst.MenuItemCode.ItemManufacturer:
                    if(menuItemCode == "VolumeMetrics") {
                        requestParam.columns[0].data = "Manufacturer";
                        requestParam.search.regex = false;
                        requestParam.columns[1] = getSecondarySearchColumn("ItemID", true);
                    }
                    break;
                case StringConst.MenuItemCode.Environment:
                    if(menuItemCode == "LSI" || menuItemCode == "EnvironmentDemographicEstimate" 
                            || menuItemCode == "Institution") {
                        requestParam.columns[1] = getSecondarySearchColumn("EnvironmentTypeCode", true);
                        requestParam.columns[1].search.value = "PFSAH";
                    }
                    break;
                case StringConst.MenuItemCode.Institution:			
					if(menuItemCode == StringConst.MenuItemCode.Institution) {
                        requestParam.search.regex = false;
                    }
                default: 
                    if(inputMetaData.FilterDependency) {
                        requestParam.columns[1] = getSecondarySearchColumn(inputMetaData.FilterDependency + "ID", false);
                    }
                    break;
            }
            return requestParam;
        }

        DtRequestService.formatDtRequestParameter = function(request) {
            var dtRequest = { };
            dtRequest.AdditionalParameters = request.additionalParameters;
            dtRequest.Draw = request.draw;	
            dtRequest.Length = request.length;
            dtRequest.Start = request.start;

            for(var colIndex = 0; colIndex < request.columns.length; ++colIndex) {
                dtRequest['columns[' + colIndex + '][data]'] = request.columns[colIndex].data;
                dtRequest['columns[' + colIndex + '][searchable]'] = request.columns[colIndex].searchable;
                dtRequest['columns[' + colIndex + '][orderable]'] =  request.columns[colIndex].orderable;
                dtRequest['columns[' + colIndex + '][search][value]'] = request.columns[colIndex].search.value;
                dtRequest['columns[' + colIndex + '][search][regex]'] = request.columns[colIndex].search.regex;
            }

            for(var sortingColIndex = 0; sortingColIndex < request.order.length; ++sortingColIndex) {
                dtRequest['order[' + sortingColIndex + '][column]'] = request.order[sortingColIndex].column;
                dtRequest['order[' + sortingColIndex + '][dir]'] = request.order[sortingColIndex].dir;
            }

            dtRequest['search[regex]'] = request.search.regex;
            dtRequest['search[value]'] = request.search.value;

            if($rootScope.advancedSearch) {
				dtRequest['columns[' + 0 + '][name]'] = "AdvancedSearch";
			}

            return dtRequest;
        }

        var getSecondarySearchColumn = function(columnName, regex) {
            var column = angular.copy(AppConst.UIConfig.UISelect.DefaultSearchColumn);
            column.data = columnName;
            column.search.regex = regex;
            return column;
        }

        var addFilteringColumns = function(filterColumns, inc, request) {
			for (var index = 0; index < filterColumns.length; index++) {
                request.columns[index + inc] = getSecondarySearchColumn(filterColumns[index], false);
			}
		}

        return DtRequestService;
    });
'use strict';

angular.module('pds.services')
    .factory('DefaultEntityService', function(AppConst, StorageService, StringConst){
        var DefaultEntityService = { };

        var ItemDefaults = AppConst.Entity.Item.DefaultItem;

        DefaultEntityService.GetDefaultEntity = function(menuItemCode, status) {
            switch (menuItemCode) {
                case StringConst.MenuItemCode.Item:
                    return getDefaultItem(status);
                case StringConst.MenuItemCode.Institution:
                    return getDefaultInstitution();
                default:
                    return {};
            }
        }

        function getCommodityType(commodityTypes) {
            var commodityType = _.find(commodityTypes, function(type) {
                return type.CommodityTypeCode == StringConst.Code.CommodityType.Pharmaceutical;
            });

            return commodityType != null ? commodityType : commodityTypes[0];
        }

        function getDefaultItem(status) {
            var entity = { };
            var commodityType = status.length ? getCommodityType(status) : status;
            var isPharmaceutical = commodityType.CommodityTypeCode == StringConst.Code.CommodityType.Pharmaceutical;

            entity.CommodityType = commodityType;
            entity.CommodityTypeID = commodityType.ID;
            entity.Category = [];

			//default value for pharmaceutical properties
			if(isPharmaceutical){
				entity.Ven = _.find(StorageService.get("VEN"), function(Ven){
					return Ven.Vencode == ItemDefaults.Pharmaceutical.Vencode;
				});
				entity.NearExpiryTrigger = ItemDefaults.Pharmaceutical.NearExpiry;
				entity.NearExpiryTrigger_RDF = ItemDefaults.Pharmaceutical.NearExpiryRDF;
				entity.NeedBatch = ItemDefaults.Pharmaceutical.NeedBatch;
				entity.NeedExpiry = ItemDefaults.Pharmaceutical.NeedExpiry;
			}

			//default value for NON pharmaceutical properties
			else{
				entity.Ven = _.find(StorageService.get("VEN"), function(Ven){
					return Ven.Vencode == ItemDefaults.NonPharmaceutical.Vencode;
                });
                entity.NearExpiryTrigger_RDF = ItemDefaults.NonPharmaceutical.NearExpiryRDF;
			}

			//default value for common properties
			entity.Abc = _.find(StorageService.get("ABC"), function(Abc){
				return Abc.Abccode == ItemDefaults.Common.Abccode;
			});

			entity.AbcID = entity.Abc.ID;
            entity.VenID = entity.Ven.ID;
            return entity;
        }
        
        function getDefaultInstitution() {
            return {
                Latitude: 0,
                Longitude: 0
            }
        }

        return DefaultEntityService;
    });
'user strict';

angular.module('pds.services')
    .factory('DataService', function(AppConst, CommonService, DefaultEntityService, ErrorHandlingService, ItemFactory, 
                StringConst, StorageService, $http, $q, $location, $sce) {
        var DataService = {};
        
        var relatedEntities = AppConst.Entity.Item.DefaultItemData;
        var relatedMetaDataCodeLists = AppConst.Entity.RelatedMetaData;
        
        DataService.LoadAddEntityData = function(menuItem, success, failure) {   
            var promises = { }; 

            promises.columnInfo = promiseColumnInfo(menuItem);
            promises = Object.assign(promises, promiseAddEntityRelatedData(menuItem.menuItemCode));
            promises = Object.assign(promises, promiseRelatedMetaData(menuItem.menuItemCode));

            $q.all(promises).then(function(data) {    
                var relatedMetaDataCodeList = relatedMetaDataCodeLists[menuItem.menuItemCode] || [];
                
                relatedEntities.forEach(function(entityCode) {
                    StorageService.set(entityCode, data[entityCode]);
                }); 

                relatedMetaDataCodeList.forEach(function(entityCode) {
                    StorageService.set("MetaData" + entityCode, data["MetaData" + entityCode]);
                });

                var defaultEntity = getDefaultEntity(menuItem.menuItemCode, data.CommodityType);
                success(data.columnInfo, defaultEntity);
            }, function() {
                failure();
            });
        }

        DataService.LoadEditEntityData = function(menuItem, success, failure) {   
            var promises = { }; 
            var relatedMetaDataCodeList = relatedMetaDataCodeLists[menuItem.menuItemCode] || [];

            promises.columnInfo = promiseColumnInfo(menuItem);
            promises = Object.assign(promises, promiseRelatedMetaData(menuItem.menuItemCode));
            promises.CommodityType = 
                    ItemFactory.cachedRequestWithTimeOut(StringConst.MenuItemCode.CommodityType).query().$promise;

            $q.all(promises).then(function(data) { 
                relatedEntities.forEach(function(entityCode) {
                    StorageService.set(entityCode, data[entityCode]);
                }); 
                
                relatedMetaDataCodeList.forEach(function(entityCode) {
                    StorageService.set("MetaData" + entityCode, data["MetaData" + entityCode]);
                });

                StorageService.set(StringConst.MenuItemCode.CommodityType, data[StringConst.MenuItemCode.CommodityType]);
                success(data.columnInfo);
            }, function() { 
                failure();
            });
        }

        DataService.LoadColumnInfo = function(menuItem, success, type) {            
            var promises = { };

            if(type === undefined) {
                type = StringConst.ColumnInfoType.Info;
            }

            switch (type) {
                case StringConst.ColumnInfoType.Info:
                    promises.columnInfo = promiseColumnInfo(menuItem);
                    break;
                case StringConst.ColumnInfoType.FlatInfo:
                    promises.columnInfo = promiseFlatColumnInfo(menuItem);
                    break;
                default:
                    break;
            }

            $q.all(promises).then(function(data) {
                success(data.columnInfo);
            }, function(error) {
                ErrorHandlingService.requestFailed(error, $location.path());
            });
        }

        DataService.ExportExcel = function(menuItem) {
            var a = document.createElement("a");
			document.body.appendChild(a);

			$http.post(CommonService.buildUrl(menuItem.apiUrl + "/ExportExcel"), {}, {
                responseType: 'arraybuffer'
            }).success(function(data, status, headers, config) {
                var file = new Blob([data], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				});
				a.href = $sce.trustAsResourceUrl(URL.createObjectURL(file));
				a.download = menuItem.menuItemCode;
				a.click();
            }).error(function(data, status, headers, config) {
                alert('Sorry, something went wrong');
            });
        }

        function promiseColumnInfo(menuItem) {
            return ItemFactory.columnInfo(menuItem.apiUrl).query().$promise;
        }

        function promiseFlatColumnInfo(menuItem) {
            return ItemFactory.columnInfoFlat(menuItem.apiUrl).query().$promise;
        }

        function promiseAddEntityRelatedData(menuItemCode) {
            var promises = { };
            relatedEntities.forEach(function(entityCode) {
                promises[entityCode] = ItemFactory.cachedRequestWithTimeOut(entityCode).query().$promise;
            });
            return promises;
        }

        function promiseRelatedMetaData(menuItemCode) {
            var promises = { };
            try {
                relatedMetaDataCodeLists[menuItemCode].forEach(function(relatedEntityCode) {
                    promises["MetaData" + relatedEntityCode] = ItemFactory.columnInfoFlat(relatedEntityCode).query().$promise;
                });
            } catch (error) {
                
            }
            
            return promises;
        }

        function getDefaultEntity(menuItemCode, defaultValue) {
            return DefaultEntityService.GetDefaultEntity(menuItemCode, defaultValue);
        }

        return DataService;
    });
'use strict';

angular.module('pds.services')
	.service('CommonService', function(AppConst, StorageService, EnvironmentConfig) {
		var commonService = {};

		commonService.buildUrl = function(resourceUrl, id) {
			var rootApiUrl = EnvironmentConfig.RootAPIURL;
			if (!_.isUndefined(id)) {
				resourceUrl = resourceUrl.replace(':id', id);
      }

      if (!_.isUndefined(resourceUrl)) {
        if (!resourceUrl.includes("InstitutionParentType") && !resourceUrl.includes("PurchaseOrderParentType")) {
          resourceUrl = resourceUrl.replace('Parent', '');
        }
      }
			return rootApiUrl + resourceUrl;
		};

    commonService.setReturnUrl = function(url){
    //Do not set login as a return url.
      if(url.indexOf('/login')>0){
        return;
      }
      StorageService.set(AppConst.StorageKeys.ReturnUrl,url);
    }

    commonService.getReturnUrl = function(){
      return  StorageService.get(AppConst.StorageKeys.ReturnUrl);
    }

    commonService.getUserDefaultPage = function (user) {
      var defaultMenuItemCode = '';

      try {
        if(_.find(user.menuItems, function(menuItem) {
          return menuItem.PDSPermissionMenuItem.Code == "Item";
        })) {
          return "Item";
        }
        var defaultMenuItem = _.find(user.menuItems, function(menuItem) {
          return menuItem.PDSPermissionMenuItem.ParentPDSPermissionMenuItem != null;
        });
        defaultMenuItemCode = defaultMenuItem.PDSPermissionMenuItem.Code;
        
      } catch (error) {
        defaultMenuItemCode = "Item";
      }

      return defaultMenuItemCode;
    }

    commonService.resetReturnUrl = function(){
      return  StorageService.remove(AppConst.StorageKeys.ReturnUrl);
    }

		commonService.SearchAndPaginate = function(vm,SearchAPI, dataM, pageNo, pageSize) {

      var APIFactory = SearchAPI;
      pageNo = pageNo!=undefined?pageNo:0;
      pageSize = pageSize!=undefined?pageSize:50;
      var temp;
      var modelName = dataM;
      dataM = dataM.split('.');
      var VM = vm;
      var dataModel = vm;
      while(dataM.length>0){
        var current = dataM[0];
        if(current=='vm' || current=='scope' || current=='$scope'){
          //skip vm.,  scope.  or $scope.
        }else{
          temp=dataModel[current];
          //If model is not inialized(or defined, initialize it to empty array).
          if(temp==undefined){
            dataModel[current]=[];
          }else{
            dataModel = temp;
          }
        }
        dataM.shift();
      }

      return function(keyWords,$event){
        if (keyWords == "") keyWords = " ";
        if (!$event) {
          pageNo = 0;
        } else {
          $event.stopPropagation();
          $event.preventDefault();
          pageNo++;
        }

        APIFactory.save({ query: keyWords, pageNumber: pageNo, pageSize: pageSize }, function(data) {
          var vmModel = data.data;
          var concat = false;
          if ($event) {
            concat = true;
          }
          commonService.setInternalVMObject(VM,modelName,vmModel,concat);

        });
      }

  };

		return commonService;
	});


'use strict'
angular.module('pds.filters')
	.filter('customFormat', function($filter) {
		return function(data, type, formatNumber) {
			switch (type) {
				case 'DateTime':
					data = $filter('date')(data, "MMM d,y", "UTC");
					break;
				case 'Boolean':
					if (data === true) {data = '\u2713'}
					else if (data === false) {data = '\u2715'}
					else {data = '-'}
					break;
				case 'Int32':
					if(formatNumber){
						data = $filter('number')(data);
					}
			}

			// Until better filter is constucted
			if(data === null || data === undefined) { data = '-' }
			else if(data.Name !== undefined) { data = data.Name; }
			if(data.length > 80) {
				data = data.substr(0, 80) + "...";
			}
			return data;
		}
	})

	//Adds space between words in camel case
	//Input string CamelCase
	//Output string Camel Case
	.filter('formatCamelCase', function() {
		return function(camelCaseString){
			return camelCaseString.replace(/([a-z])([A-Z])/g, '$1 $2');
		}
	})

	.filter('customizeString', function() {
		return function(text, maxLength) {
			if(text.length > maxLength) {
				return text.substring(0, maxLength - 5) + " ...";
			}
			return text;
		}
	})

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('pds')
	.directive('sideNavigation', function ($timeout) {
		return {
			restrict: 'A',
			link: function (scope, element) {
				// Call metsi to build when user signup
				scope.$watch('authentication.user', function() {
					$timeout(function() {
						element.metisMenu();
					});
				});

			}
		};
	})
	.directive('minimalizaSidebar', function ($timeout) {
		return {
			restrict: 'A',
			template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
			controller: function ($scope) {
				$scope.minimalize = function () {
					angular.element('body').toggleClass('mini-navbar');
					if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
						// Hide menu in order to smoothly turn on when maximize menu
						angular.element('#side-menu').hide();
						// For smoothly turn on menu
						$timeout(function () {
							angular.element('#side-menu').fadeIn(400);
						}, 200);
					} else {
						// Remove all inline style from jquery fadeIn function to reset menu state
						angular.element('#side-menu').removeAttr('style');
					}
				};
			}
		};
	})
	.directive('dynamicInput', function() {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				inputProperty: '=inputProperty',
				inputModel: '=inputModel',
				inputData: '=inputData',
				inputClass: '=inputClass',
				menuItem: '=menuItem'
			},
			transclude: true,
			templateUrl: 'app/common/templates/input/dynamic_input.html',
			controller: 'DynamicInputController',
			controllerAs: 'inputController'
		}
	})

	.directive('dynamicUiSelect', function() {
		return {
			restrict: 'E',
			replace: false,
			scope: {
				model: '=model',
				index: '=index',
				choiceList: '=choiceList',
				choiceFilter: '=choiceFilter'
			},
			transclude: true,
			templateUrl: 'app/common/templates/input/dynamic_ui_select.html'
		}
	})

	.directive('simpleDynamicInput', function() {
		return {
			restrict: 'E',
			scope: {
				model: '=model',
				propertyInfo: '=propertyInfo'
			},
			templateUrl: 'app/common/templates/input/simple_dynamic_input.html'
		}
	})

	.directive('processing', function(){
		return {
		restrict: 'E',
		replace: 'true',
		scope: {
		isContentLoading: '=isContentLoading'
		},
		templateUrl: 'app/common/templates/processing.html'
	}
	})

	.directive('errorTemplate', function() {
		return {
		restrict: 'E',
		replace: 'true',
		scope: false,
		templateUrl: 'app/common/templates/error.html',
		controller: 'ErrorController',
		controllerAs: 'errorController'
	}
	})

	.directive('uiSelectCustomEventHandler', function(AppConst, StorageService, $timeout) {
		return {
		require: 'uiSelect',
		link: function($scope, $element, attrs, $select) {
			var selectScope = $scope.$parent.$parent;
			var searchInput = $element.querySelectorAll('input.ui-select-search');
			
			if(searchInput.length !== 1) throw Error("Element Not Found");
				searchInput.on('focus', function() {
					if(selectScope.inputProperty.Dependency == "Category"){
						var categoryFilter = "";
						var commodityType = StorageService.get("CurrentCommodityType");
						if(commodityType.CommodityTypeCode == "PHAR"){ 
							categoryFilter = "PH" }
						else { 
							categoryFilter = "NP" }
						selectScope.inputController.dropDownFilter = 
								{ ParentCategory: { ParentCategory: { CategoryCode: categoryFilter }}};
					}

					if(selectScope.inputProperty.Dependency.replace("Parent", "") == "StorageType") {
						selectScope.inputController.dropDownFilter = { ParentStorageType: null };
					}

					if(AppConst.Entity.HasFilterInput.includes(selectScope.inputProperty.Dependency)
							|| selectScope.inputProperty.FilterDependency) {
						selectScope.inputController.dropDownData[selectScope.inputProperty.Dependency] = [];
						selectScope.inputController.resetInput();
					}

					var choice = $element.querySelectorAll('ul.ui-select-choices');
					formOverFlowFix('add-edit-entity-form-wrapper', 'content-wrapper-in' + ' overflow-hidden');

					choice.on('scroll', function() {
						loadNextPageOnEndOfScrolling(choice, selectScope, $select.search);
					});
				});	

				searchInput.on('blur', function() {
					formOverFlowFix('add-edit-entity-form-wrapper', 'content-wrapper-in');
				});

				searchInput.on('input', function() {
					selectScope.inputController.filterChoices($select.search);
				});

				searchInput.on('keydown', function(){
					if($select.search == "") { $select.search = " "; }
				});
			}
		}

		function loadNextPageOnEndOfScrolling(choice, selectScope, searchKey) {
			var scrollpercent = (document.body.scrollTop + choice[0].scrollTop) / 
					(choice[0].scrollHeight - choice[0].clientHeight);

			if(scrollpercent == 1) { 
				selectScope.inputController.goToNextPage(choice, searchKey);
				var loadingRows =  choice.querySelectorAll('.ui-select-choices-row-custom');
				if(loadingRows.length == 0 && !selectScope.inputController.allPageLoaded) {
					var loadingRow = AppConst.UIConfig.UISelect.LoadingRowTemplate;
					choice.append(loadingRow);
				}
			}
		}

		function formOverFlowFix(elementId, className) {
			$timeout(function() {				
				document.getElementById(elementId).className = className;
			}, 250);
		}
	})

	.directive('topbar', function(){
		return {
		restrict: 'E',
		replace: 'false',
		templateUrl: 'app/common/templates/layout/topbarflex.html'
	}
	})

	// Modal directives
	.directive('modalContent', function() {
		return {
		restrict: 'E',
		replace: 'true',
		templateUrl: 'app/common/templates/modal/modal_content.html'
	}
	})

	.directive('activateItem', function() {
		return {
		restrict: 'E',
		replace: 'true',
		templateUrl: 'app/common/templates/modal/activate_item.html'
	}
	})

	.directive('deactivateItem', function() {
		return {
		restrict: 'E',
		replace: 'true',
		templateUrl: 'app/common/templates/modal/deactivate_item.html'
	}
	});

'use strict';

angular.module('pds')
	.constant('StringConst', {
		Action: {
			Add: "Add",
			Activate: "Activate",
			Confirm: "Confirm",
			Deactivate: "Deactivate",
			Edit: "Edit",
			Export: "Export",
			Revoke: "Revoke"
		},
		Code:{
			UserAccountType: {
				Admin: "ADM",
				DataCleanUpClerk: "DC",
				Editor: "ED",
				ItemEditor: "ItmED",
				Public: "Public",
				READER: "RD"

			},
			CommodityType: {
				Pharmaceutical: "PHAR"
			}
		},
		ColumnInfoType: {
			Info: "Info",
			FlatInfo: "FlatInfo"
		},
        MenuItemCode: {
			Account: "Account",
			Accessory: "Accessory",
			Activity: "Activity",
			Category: "Category",
			CommodityType: "CommodityType",
			Environment: "Environment",
			EnvironmentDemographicEstimate: "EnvironmentDemographicEstimate",
			FiscalYear: "FiscalYear",
			Institution: "Institution",
			InstitutionType: "InstitutionType",
			Item: "Item",
			ItemCategory: "ItemCategory",
			ItemManufacturer: "ItemManufacturer",
			ItemProgramt: "ItemProgramt",
			ItemUnitOfIssue: "ItemUnitOfIssue",
			ItemUnitOfIssueMapping: "ItemUnitOfIssueMapping",
			LSI: "LSI",
			MappedItem: "MappedItem",
			MenuItem: "MenuItem",
			ParentMenuItem: "ParentMenuItem",
			Period: "Period",
			Product: "Product",
			SubAccount: "SubAccount",
			Woreda: "Woreda",
			Zone: "Zone",
			ProductBasecode: "ProductBasecode"
		},
		Routing: {
			State: {
				Login: "login"
			}
		},
		StorageKey: {
			TempNewEntity: "TempNewEntity",
			TempExistingEntity: "TempExistingEntity"
		},
		UserAccountType: {
			Children: {
				Editor: [ "EDC", "EDP", "EDME", "EDMS" ]
			}
		}
	});
'use strict';

angular.module('pds')
	.constant('MenuItemConst', {
		MenuItems: 
		[
			{
				menuItemCode: 'ProductAndItem',
				label: 'Products and Items',
				link: 'placeholder',
				title: 'Products and Items',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'PPLItemGroup',
						apiUrl: 'PPLItemGroup',
						label: 'PPL Item Group',
						link: 'list({ id: "PPLItemGroup"})',
						title: 'PPL Item Group',
						icon: ''
					},
					{
						menuItemCode: 'DefaultItemUnitofIssuePPL',
						apiUrl: 'DefaultItemUnitofIssuePPL',
						label: 'Default PPL Item',
						link: 'list({ id: "DefaultItemUnitofIssuePPL"})',
						title: 'Default PPL Item',
						icon: ''
					},
					{
						menuItemCode: 'ItemUnitofIssuePPL',
						apiUrl: 'ItemUnitofIssuePPL',
						label: 'Items',
						link: 'list({ id: "ItemUnitofIssuePPL"})',
						title: 'Items',
						icon: ''
					},
					{
						menuItemCode: 'ItemUnitofIssueSOH',
						apiUrl: 'ItemUnitofIssueSOH',
						label: 'Items with SOH',
						link: 'list({ id: "ItemUnitofIssueSOH"})',
						title: 'Items with SOH',
						icon: ''
					},
					{
						menuItemCode: 'AnticancerItem',
						apiUrl: 'AnticancerItem',
						label: 'Anticancer',
						link: 'list({ id: "AnticancerItem"})',
						title: 'Anticancer Item',
						icon: ''
					},
					{
						menuItemCode: 'Item',
						apiUrl: 'Item',
						label: 'All Items',
						link: 'list({ id: "Item"})',
						title: 'All Items',
						icon: ''
					},
					{
						menuItemCode: 'Product',
						apiUrl: 'Product',
						label: 'Products',
						link: 'list({ id: "Product"})',
						title: 'Commodity Products',
						icon: ''
					},
					{
						menuItemCode: 'DosageForm',
						apiUrl: 'DosageForm',
						label: 'Dosage Forms',
						link: 'list({ id: "DosageForm"})',
						title: 'Commodity Dosage Forms',
						icon: ''
					},
					{
						menuItemCode: 'Manufacturer',
						apiUrl: 'Manufacturer',
						label: 'Manufacturer',
						link: 'list({ id: "Manufacturer"})',
						title: 'Commodity Manufacturer',
						icon: ''
					},
					{
						menuItemCode: 'Supplier',
						apiUrl: 'Supplier',
						label: 'Suppliers',
						link: 'list({ id: "Supplier"})',
						title: 'Commodity Suppliers',
						icon: ''
					},
					{
						menuItemCode: 'UnitOfIssue',
						apiUrl: 'UnitOfIssue',
						label: 'Unit of Issue',
						link: 'list({ id: "UnitOfIssue"})',
						title: 'Commodity Unit of Issue',
						icon: ''
					},
					{
						menuItemCode: 'Strength',
						apiUrl: 'Strength',
						label: 'Strength',
						link: 'list({ id: "Strength"})',
						title: 'Commodity Strength',
						icon: ''
					},
					{
						menuItemCode: 'ProductDescription',
						apiUrl: 'ProductDescription',
						label: 'Product Description',
						link: 'list({ id: "ProductDescription"})',
						title: 'Product Description',
						icon: ''
					},
					{
						menuItemCode: 'ProductModel',
						apiUrl: 'ProductModel',
						label: 'Product Model',
						link: 'list({ id: "ProductModel"})',
						title: 'Product Model',
						icon: ''
					},
					{
						menuItemCode: 'ProductSeries',
						apiUrl: 'ProductSeries',
						label: 'Product Series',
						link: 'list({ id: "ProductSeries"})',
						title: 'Product Series',
						icon: ''
					},
					{
						menuItemCode: 'Accessory',
						apiUrl: 'Accessory',
						label: 'Accessory',
						link: 'list({ id: "Accessory"})',
						title: 'Accessory',
						icon: ''
					},
					{
						menuItemCode: 'ItemUnitOfIssue',
						apiUrl: 'ItemUnitOfIssue',
						label: 'Item Unit Of Issue',
						link: 'list({ id: "ItemUnitOfIssue"})',
						title: 'Item Unit Of Issue',
						icon: ''
					},
					{
						menuItemCode: 'ItemUnitOfIssueMapping',
						apiUrl: 'ItemUnitOfIssueMapping',
						label: 'Item Mapping',
						link: 'list({ id: "ItemUnitOfIssueMapping"})',
						title: 'Commodity ItemMapping',
						icon: ''
					},
					{
						menuItemCode: 'ItemUnitDoseWasteFactor',
						apiUrl: 'ItemUnitDoseWasteFactor',
						label: 'ItemUnitDoseWasteFactor',
						link: 'list({ id: "ItemUnitDoseWasteFactor"})',
						title: 'ItemUnitDoseWasteFactor',
						icon: ''
					},
					{
						menuItemCode: 'MappedItem',
						apiUrl: 'MappedItem',
						label: 'Mapped Items',
						link: 'list({ id: "MappedItem"})',
						title: 'Mapped Items',
						icon: ''
					},
					{
						menuItemCode: 'DefaultAlternateItemUnitOfIssue',
						apiUrl: 'DefaultAlternateItemUnitOfIssue',
						label: 'Alternate Item',
						link: 'list({ id: "DefaultAlternateItemUnitOfIssue"})',
						title: 'Default Alternate Item Unit of Issue',
						icon: ''
					},
					{
						menuItemCode: 'VolumeMetricsDataEntry',
						apiUrl: 'VolumeMetricsDataEntry',
						label: 'Volume Metrics',
						link: 'list({ id: "VolumeMetricsDataEntry"})',
						title: 'Volume Metrics',
						icon: ''
					},
					{
						menuItemCode: 'Basecode',
						apiUrl: 'Basecode',
						label: 'Basecode',
						link: 'list({ id: "Basecode"})',
						title: 'Basecode',
						icon: ''
					},
					{
						menuItemCode: 'ItemUnitOfIssueFacility',
						apiUrl: 'ItemUnitOfIssueFacility',
						label: 'ItemUnitOfIssueFacility',
						link: 'list({ id: "ItemUnitOfIssueFacility"})',
						title: 'ItemUnitOfIssueFacility',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'AccountParent',
				label: 'Account',
				link: 'placeholder',
				title: 'Account',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'Mode',
						apiUrl: 'Mode',
						label: 'Mode',
						link: 'list({ id: "Mode"})',
						title: 'Mode',
						icon: ''
					},
					{
						menuItemCode: 'Account',
						apiUrl: 'Account',
						label: 'Account',
						link: 'list({ id: "Account"})',
						title: 'Account',
						icon: ''
					},
					{
						menuItemCode: 'SubAccount',
						apiUrl: 'SubAccount',
						label: 'Sub Account',
						link: 'list({ id: "SubAccount"})',
						title: 'Sub Account',
						icon: ''
					},
					{
						menuItemCode: 'Activity',
						apiUrl: 'Activity',
						label: 'Activity',
						link: 'list({ id: "Activity"})',
						title: 'Activity',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'Commodity',
				label: 'Commodity',
				link: 'list({ id: "UnderConstruction"})',
				title: 'Commodity',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'ABC',
						apiUrl: 'ABC',
						label: 'ABC',
						link: 'list({ id: "ABC"})',
						title: 'ABC',
						icon: ''
					},
					{
						menuItemCode: 'Category',
						apiUrl: 'Category',
						label: 'Categories',
						link: 'list({ id: "Category"})',
						title: 'Categories',
						icon: ''
					},
					{
						menuItemCode: 'CommodityType',
						apiUrl: 'CommodityType',
						label: 'Types',
						link: 'list({ id: "CommodityType"})',
						title: 'Commodity Types',
						icon: ''
					},
					{
						menuItemCode: 'CommodityValue',
						apiUrl: 'CommodityValue',
						label: 'Values',
						link: 'list({ id: "CommodityValue"})',
						title: 'Commodity Values',
						icon: ''
					},
					{
						menuItemCode: 'Country',
						apiUrl: 'Country',
						label: 'Countries',
						link: 'list({ id: "Country"})',
						title: 'Countries',
						icon: ''
					},
					{
						menuItemCode: 'Program',
						apiUrl: 'Programt',
						label: 'Programs',
						link: 'list({ id: "Program"})',
						title: 'Programs',
						icon: ''
					},
					{
						menuItemCode: 'RRGroup',
						apiUrl: 'RRGroup',
						label: 'RR Groups',
						link: 'list({ id: "RRGroup"})',
						title: 'RR Groups',
						icon: ''
					},
					{
						menuItemCode: 'SupplierType',
						apiUrl: 'SupplierType',
						label: 'Supplier Types',
						link: 'list({ id: "SupplierType"})',
						title: 'Supplier Types',
						icon: ''
					},
					{
						menuItemCode: 'ShippingContainerType',
						apiUrl: 'ShippingContainerType',
						label: 'Container Types',
						link: 'list({ id: "ShippingContainerType"})',
						title: 'Shipping Container Types',
						icon: ''
					},
					{
						menuItemCode: 'VEN',
						apiUrl: 'VEN',
						label: 'VEN',
						link: 'list({ id: "VEN"})',
						title: 'VEN',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'InventoryManagement',
				label: 'Inventory Management',
				link: 'list({ id: "UnderConstruction"})',
				title: 'Inventory Management',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'BinType',
						apiUrl: 'BinType',
						label: 'Bin Type',
						link: 'list({ id: "BinType"})',
						title: 'Bin Type',
						icon: ''
					},
					{
						menuItemCode: 'FiscalYear',
						apiUrl: 'FiscalYear',
						label: 'Fiscal Years',
						link: 'list({ id: "FiscalYear"})',
						title: 'Fiscal Years',
						icon: ''
					},
					{
						menuItemCode: 'InventoryStatus',
						apiUrl: 'InventoryStatus',
						label: 'Inventory Status',
						link: 'list({ id: "InventoryStatus"})',
						title: 'Inventory Status',
						icon: ''
					},
					{
						menuItemCode: 'LossAndAdjustmentReason',
						apiUrl: 'LossAndAdjustmentReason',
						label: 'Loss and Adjustment',
						link: 'list({ id: "LossAndAdjustmentReason"})',
						title: 'Loss and Adjustment Reasons',
						icon: ''
					},
					{
						menuItemCode: 'OrderStatus',
						apiUrl: 'OrderStatus',
						label: 'Order Status',
						link: 'list({ id: "OrderStatus"})',
						title: 'Order Status',
						icon: ''
					},
					{
						menuItemCode: 'ReceiptConfirmationStatus',
						apiUrl: 'ReceiptConfirmationStatus',
						label: 'Receipt Confirmation',
						link: 'list({ id: "ReceiptConfirmationStatus"})',
						title: 'Receipt Confirmation Status',
						icon: ''
					},
					{
						menuItemCode: 'ReceiptType',
						apiUrl: 'ReceiptType',
						label: 'Receipt Types',
						link: 'list({ id: "ReceiptType"})',
						title: 'Receipt Types',
						icon: ''
					},
					{
						menuItemCode: 'SectionUnitType',
						apiUrl: 'SectionUnitType',
						label: 'Section Unit Type',
						link: 'list({ id: "SectionUnitType"})',
						title: 'Section Unit Type',
						icon: ''
					},
					{
						menuItemCode: 'StorageType',
						apiUrl: 'StorageType',
						label: 'Storage Types',
						link: 'list({ id: "StorageType"})',
						title: 'Storage Types',
						icon: ''
					},
					{
						menuItemCode: 'TransferType',
						apiUrl: 'TransferType',
						label: 'Transfer Types',
						link: 'list({ id: "TransferType"})',
						title: 'Transfer Types',
						icon: ''
					},
					{
						menuItemCode: 'ShortageReason',
						apiUrl: 'ShortageReason',
						label: 'Shortage Reasons',
						link: 'list({ id: "ShortageReason"})',
						title: 'Shortage Reasons',
						icon: ''

					}
				]
			},
			{
				menuItemCode: 'Finance',
				label: 'Finance',
				link: 'placeholder',
				title: 'Finance',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'CostingMethod',
						apiUrl: 'CostingMethod',
						label: 'Costing Methods',
						link: 'list({ id: "CostingMethod"})',
						title: 'Costing Methods',
						icon: ''
					},
					{
						menuItemCode: 'Financier',
						apiUrl: 'Financier',
						label: 'Financier',
						link: 'list({ id: "Financier"})',
						title: 'Financier',
						icon: ''
					},
					{
						menuItemCode: 'Currency',
						apiUrl: 'Currency',
						label: 'Currencies',
						link: 'list({ id: "Currency"})',
						title: 'Currencies',
						icon: ''
					},
					{
						menuItemCode: 'InvoiceType',
						apiUrl: 'InvoiceType',
						label: 'Invoice Types',
						link: 'list({ id: "InvoiceType"})',
						title: 'Invoice Types',
						icon: ''
					},
					{
						menuItemCode: 'MovingAverageGroup',
						apiUrl: 'MovingAverageGroup',
						label: 'MAG',
						link: 'list({ id: "MovingAverageGroup"})',
						title: 'Moving Ave. Groups',
						icon: ''
					},
					{
						menuItemCode: 'PaymentTerm',
						apiUrl: 'PaymentTerm',
						label: 'Payment Terms',
						link: 'list({ id: "PaymentTerm"})',
						title: 'Payment Terms',
						icon: ''
					},
					{
						menuItemCode: 'PaymentType',
						apiUrl: 'PaymentType',
						label: 'Payment Types',
						link: 'list({ id: "PaymentType"})',
						title: 'Payment Types',
						icon: ''
					},
					{
						menuItemCode: 'PriceChangeType',
						apiUrl: 'PriceChangeType',
						label: 'Price Change Types',
						link: 'list({ id: "PriceChangeType"})',
						title: 'Price Change Types',
						icon: ''
					},
					{
						menuItemCode: 'TermsAndCondtions',
						apiUrl: 'TermsAndCondtions',
						label: 'Terms and Condtions',
						link: 'list({ id: "TermsAndCondtions"})',
						title: 'Terms and Condtions',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'Institution',
				label: 'Institution',
				link: 'placeholder',
				title: 'Institution',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'ClinicalService',
						apiUrl: 'ClinicalService',
						label: 'Clinical Services',
						link: 'list({ id: "ClinicalService"})',
						title: 'Institution Clinical Services',
						icon: ''
					},
					{
						menuItemCode: 'InstitutionCatchmentArea',
						apiUrl: 'InstitutionCatchmentArea',
						label: 'Catchment Areas',
						link: 'list({ id: "InstitutionCatchmentArea"})',
						title: 'Institution Catchment Areas',
						icon: ''
					},
					{
						menuItemCode: 'InstitutionIType',
						apiUrl: 'InstitutionIType',
						label: 'InstitutionI Type',
						link: 'list({ id: "InstitutionIType"})',
						title: 'InstitutionI Types',
						icon: ''
					},
					{
						menuItemCode: 'InstitutionParentType',
						apiUrl: 'InstitutionParentType',
						label: 'Institution Parent Type',
						link: 'list({ id: "InstitutionParentType"})',
						title: 'Institution Parent Types',
						icon: ''
					},
					{
						menuItemCode: 'InstitutionType',
						apiUrl: 'InstitutionType',
						label: 'Institution Type',
						link: 'list({ id: "InstitutionType"})',
						title: 'Institution Types',
						icon: ''
					},
					{
						menuItemCode: 'Institution',
						apiUrl: 'Institution',
						label: 'Institutions',
						link: 'list({ id: "Institution"})',
						title: 'Institutions',
						icon: ''
					},
					{
						menuItemCode: 'OwnershipType',
						apiUrl: 'OwnershipType',
						label: 'Ownership Types',
						link: 'list({ id: "OwnershipType"})',
						title: 'Ownership Types',
						icon: ''
					},
					{
						menuItemCode: 'InstitutionEnhancement',
						apiUrl: 'InstitutionEnhancement',
						label: 'Institution Enhancement',
						link: 'list({ id: "InstitutionEnhancement"})',
						title: 'Institution Enhancement',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'AdministrativeUnit',
				label: 'Administrative Unit',
				link: 'placeholder',
				title: 'Administrative Unit',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'Region',
						apiUrl: 'Region',
						label: 'Region',
						link: 'list({ id: "Region"})',
						title: 'Region',
						icon: ''
					},
					{
						menuItemCode: 'Zone',
						apiUrl: 'Zone',
						label: 'Zone',
						link: 'list({ id: "Zone"})',
						title: 'Zone',
						icon: ''
					},
					{
						menuItemCode: 'Woreda',
						apiUrl: 'Woreda',
						label: 'Woreda',
						link: 'list({ id: "Woreda"})',
						title: 'Woreda',
						icon: ''
					},
                    {
                        menuItemCode: 'Kebele',
                        apiUrl: 'Kebele',
                        label: 'Kebele',
                        link: 'list({ id: "Kebele"})',
                        title: 'Kebele',
                        icon: ''
                    },
					{
						menuItemCode: 'DemographicEstimate',
						apiUrl: 'DemographicEstimate',
						label: 'Estimates',
						link: 'list({ id: "DemographicEstimate"})',
						title: 'Demographic Estimates',
						icon: ''
					},
					{
						menuItemCode: 'DemographicIndicator',
						apiUrl: 'DemographicIndicator',
						label: 'Indicators',
						link: 'list({ id: "DemographicIndicator"})',
						title: 'Demographic Indicators',
						icon: ''
					},
					{
						menuItemCode: 'Population',
						apiUrl: 'Population',
						label: 'Population',
						link: 'list({ id: "Population"})',
						title: 'Population',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'UserManagement',
				label: 'User Management',
				link: 'placeholder',
				title: 'User Management',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'Department',
						apiUrl: 'Department',
						label: 'Departments',
						link: 'list({ id: "Department"})',
						title: 'Departments',
						icon: ''
					},
					{
						menuItemCode: 'UserGroup',
						apiUrl: 'UserGroup',
						label: 'User Groups',
						link: 'list({ id: "UserGroup"})',
						title: 'User Groups',
						icon: ''
					},
					{
						menuItemCode: 'JobTitle',
						apiUrl: 'JobTitle',
						label: 'Job Titles',
						link: 'list({ id: "JobTitle"})',
						title: 'Job Titles',
						icon: ''
					},
					{
						menuItemCode: 'MenuItem',
						apiUrl: 'MenuItem',
						label: 'Menu Items',
						link: 'list({ id: "MenuItem"})',
						title: 'Menu Items',
						icon: ''
					},
					{
						menuItemCode: 'ResourceType',
						apiUrl: 'ResourceType',
						label: 'Resource Types',
						link: 'list({ id: "ResourceType"})',
						title: 'Resource Types',
						icon: ''
					},
					{
						menuItemCode: 'MenuItemInfo',
						apiUrl: 'MenuItemInfo',
						label: 'Menu Item Info',
						link: 'list({ id: "MenuItemInfo"})',
						title: 'Menu Item Info',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'Requisition',
				label: 'Requisition',
				link: 'placeholder',
				title: 'Requisition',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'OrderType',
						apiUrl: 'OrderType',
						label: 'Order Types',
						link: 'list({ id: "OrderType"})',
						title: 'Order Types',
						icon: ''
					},
					{
						menuItemCode: 'RequisitionPriority',
						apiUrl: 'RequisitionPriority',
						label: 'Priority',
						link: 'list({ id: "RequisitionPriority"})',
						title: 'Requisition Priority',
						icon: ''

					},
					{
						menuItemCode: 'RequisitionStatus',
						apiUrl: 'RequisitionStatus',
						label: 'Status',
						link: 'list({ id: "RequisitionStatus"})',
						title: 'Requisition Status',
						icon: ''

					},
					{
						menuItemCode: 'RequisitionType',
						apiUrl: 'RequisitionType',
						label: 'Types',
						link: 'list({ id: "RequisitionType"})',
						title: 'Requisition Types',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'Documentation',
				label: 'Documentation',
				link: 'placeholder',
				title: 'Documentation',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'Column',
						apiUrl: 'Column',
						label: 'Column',
						link: 'list({ id: "Column"})',
						title: 'Column',
						icon: ''
					},
					{
						menuItemCode: 'Filter',
						apiUrl: 'Filter',
						label: 'Filter',
						link: 'list({ id: "Filter"})',
						title: 'Filter',
						icon: ''
					},
					{
						menuItemCode: 'Report',
						apiUrl: 'Report',
						label: 'Report',
						link: 'list({ id: "Report"})',
						title: 'Report',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'USM',
				label: 'USM',
				link: 'placeholder',
				title: 'USM',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'Database',
						apiUrl: 'Database',
						label: 'Database',
						link: 'list({ id: "Database"})',
						title: 'Database',
						icon: ''
					},
					{
						menuItemCode: 'DatabaseType',
						apiUrl: 'DatabaseType',
						label: 'Database Type',
						link: 'list({ id: "DatabaseType"})',
						title: 'Database Type',
						icon: ''
					},
					{
						menuItemCode: 'DBUserAccountType',
						apiUrl: 'DBUserAccountType',
						label: 'Account Type',
						link: 'list({ id: "DBUserAccountType"})',
						title: 'DB User Account Type',
						icon: ''
					},
					{
						menuItemCode: 'Environment',
						apiUrl: 'Environment',
						label: 'Environment',
						link: 'list({ id: "Environment"})',
						title: 'Environment',
						icon: ''
					},
					{
						menuItemCode: 'EnvironmentGroup',
						apiUrl: 'EnvironmentGroup',
						label: 'Environment Group',
						link: 'list({ id: "EnvironmentGroup"})',
						title: 'Environment Group',
						icon: ''
					},
					{
						menuItemCode: 'EnvironmentType',
						apiUrl: 'EnvironmentType',
						label: 'Environment Type',
						link: 'list({ id: "EnvironmentType"})',
						title: 'Environment Type',
						icon: ''
					},
					{
						menuItemCode: 'Machine',
						apiUrl: 'Machine',
						label: 'Machine',
						link: 'list({ id: "Machine"})',
						title: 'Machine',
						icon: ''
					},
					{
						menuItemCode: 'MachineRole',
						apiUrl: 'MachineRole',
						label: 'Machine Role',
						link: 'list({ id: "MachineRole"})',
						title: 'Machine Role',
						icon: ''
					},
					{
						menuItemCode: 'MachineMachineRole',
						apiUrl: 'MachineMachineRole',
						label: 'Machine MachineRole',
						link: 'list({ id: "MachineMachineRole"})',
						title: 'Machine MachineRole',
						icon: ''
					},
					{
						menuItemCode: 'Package',
						apiUrl: 'Package',
						label: 'Package',
						link: 'list({ id: "Package"})',
						title: 'Package',
						icon: ''
					},
					{
						menuItemCode: 'PackageDatabaseType',
						apiUrl: 'PackageDatabaseType',
						label: 'Package DatabaseType',
						link: 'list({ id: "PackageDatabaseType"})',
						title: 'Package DatabaseType',
						icon: ''
					},
					{
						menuItemCode: 'PackageExecutionStatus',
						apiUrl: 'PackageExecutionStatus',
						label: 'Execution Status',
						link: 'list({ id: "PackageExecutionStatus"})',
						title: 'Package Execution Status',
						icon: ''
					},
					{
						menuItemCode: 'PackageDetail',
						apiUrl: 'PackageDetail',
						label: 'Package Detail',
						link: 'list({ id: "PackageDetail"})',
						title: 'Package Detail',
						icon: ''
					},
					{
						menuItemCode: 'PackageGroup',
						apiUrl: 'PackageGroup',
						label: 'Package Group',
						link: 'list({ id: "PackageGroup"})',
						title: 'Package Group',
						icon: ''
					},
					{
						menuItemCode: 'Project',
						apiUrl: 'Project',
						label: 'Project',
						link: 'list({ id: "Project"})',
						title: 'Project',
						icon: ''
					},
					{
						menuItemCode: 'ProjectGroup',
						apiUrl: 'ProjectGroup',
						label: 'Project Group',
						link: 'list({ id: "ProjectGroup"})',
						title: 'Project Group',
						icon: ''
					},
					{
						menuItemCode: 'ProjectGroupEnvironment',
						apiUrl: 'ProjectGroupEnvironment',
						label: 'ProjectGroup Environment',
						link: 'list({ id: "ProjectGroupEnvironment"})',
						title: 'ProjectGroup Environment',
						icon: ''
					},
					{
						menuItemCode: 'Vehicle',
						apiUrl: 'Vehicle',
						label: 'Vehicle',
						link: 'list({ id: "Vehicle"})',
						title: 'Vehicle',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'KPI',
				label: 'KPI',
				link: 'placeholder',
				title: 'KPI',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'Indicator',
						apiUrl: 'Indicator',
						label: 'Indicator',
						link: 'list({ id: "Indicator"})',
						title: 'Indicator',
						icon: ''
					},
					{
						menuItemCode: 'IndicatorQuery',
						apiUrl: 'IndicatorQuery',
						label: 'Indicator Query',
						link: 'list({ id: "IndicatorQuery"})',
						title: 'Indicator Query',
						icon: ''
					},
					{
						menuItemCode: 'Source',
						apiUrl: 'Source',
						label: 'Source',
						link: 'list({ id: "Source"})',
						title: 'Source',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'MBrana',
				label: 'MBrana',
				link: 'placeholder',
				title: 'MBrana',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'UnitConversion',
						apiUrl: 'UnitConversion',
						label: 'Item Unit Conversion',
						link: 'list({ id: "UnitConversion"})',
						title: 'Item Unit Conversion',
						icon: ''
					},
					{
						menuItemCode: 'MBranaItemUnit',
						apiUrl: 'MBranaItemUnit',
						label: 'MBrana Item Unit',
						link: 'list({ id: "MBranaItemUnit"})',
						title: 'MBrana Item Unit',
						icon: ''
					},
					{
						menuItemCode: 'MBranaToHCMISUnit',
						apiUrl: 'MBranaToHCMISUnit',
						label: 'mBrana Mapping',
						link: 'list({ id: "MBranaToHCMISUnit"})',
						title: 'MBrana to HCMIS Mapping',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'PDSPermission',
				label: 'PDS Permission',
				link: 'placeholder',
				title: 'PDS Permission',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'PDSPermissionMenuItem',
						apiUrl: 'PDSPermissionMenuItem',
						label: 'MenuItem',
						link: 'list({ id: "PDSPermissionMenuItem"})',
						title: 'PDS Permission MenuItem',
						icon: ''
					},
					{
						menuItemCode: 'Operation',
						apiUrl: 'Operation',
						label: 'Operation',
						link: 'list({ id: "Operation"})',
						title: 'PDS Permission Operation',
						icon: ''
					},
					{
						menuItemCode: 'UserRole',
						apiUrl: 'UserRole',
						label: 'User Role',
						link: 'list({ id: "UserRole"})',
						title: 'User Role',
						icon: ''
					},
					{
						menuItemCode: 'AccessControlList',
						apiUrl: 'AccessControlList',
						label: 'Access Control List',
						link: 'list({ id: "AccessControlList"})',
						title: 'Access Control List',
						icon: ''
					},
				]
			},
			{
				menuItemCode: 'Others',
				label: 'Others',
				link: 'placeholder',
				title: 'Others',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'DocumentType',
						apiUrl: 'DocumentType',
						label: 'Document Types',
						link: 'list({ id: "DocumentType"})',
						title: 'Messaging Document Types',
						icon: ''
					},
					{
						menuItemCode: 'Period',
						apiUrl: 'Period',
						label: 'RRF Periods',
						link: 'list({ id: "Period"})',
						title: 'RRF Periods',
						icon: ''
					},
					{
						menuItemCode: 'LSI',
						apiUrl: 'LSI',
						label: 'LSI',
						link: 'list({ id: "LSI"})',
						title: 'LSI',
						icon: ''
					},
					{
						menuItemCode: 'EnvironmentDemographicEstimate',
						apiUrl: 'EnvironmentDemographicEstimate',
						label: 'Env. Demographic Estimate',
						link: 'list({ id: "EnvironmentDemographicEstimate"})',
						title: 'Environment Demographic Estimate',
						icon: ''
					},
					{
						menuItemCode: 'SoftwareSettingCategory',
						apiUrl: 'SoftwareSettingCategory',
						label: 'Software Setting Category',
						link: 'list({ id: "SoftwareSettingCategory"})',
						title: 'Software Setting Category',
						icon: ''
					},
					{
						menuItemCode: 'SoftwareSetting',
						apiUrl: 'SoftwareSetting',
						label: 'Software Setting',
						link: 'list({ id: "SoftwareSetting"})',
						title: 'Setting Software Setting',
						icon: ''
					},
					{
						menuItemCode: 'UserAccount',
						apiUrl: 'UserAccount',
						label: 'User Account',
						link: 'list({ id: "UserAccount"})',
						title: 'User Account',
						icon: ''
					},
					{
						menuItemCode: 'UserAccountType',
						apiUrl: 'UserAccountType',
						label: 'User Account Type',
						link: 'list({ id: "UserAccountType"})',
						title: 'User Account Type',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'Log',
				label: 'Log',
				link: 'placeholder',
				title: 'Log',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'LogChangeTracking',
						apiUrl: 'LogChangeTracking',
						label: 'Change Tracking',
						link: 'list({ id: "LogChangeTracking"})',
						title: 'Change Tracking',
						icon: ''
					}
				]
			},
			{
				menuItemCode: 'Procurement',
				label: 'Procurement',
				link: 'placeholder',
				title: 'Procurement',
				icon: '',
				subMenu: 
				[
					{
						menuItemCode: 'Donor',
						apiUrl: 'Donor',
						label: 'Donor',
						link: 'list({ id: "Donor"})',
						title: 'Donor',
						icon: ''
					},
					{
						menuItemCode: 'LocalAgent',
						apiUrl: 'LocalAgent',
						label: 'Local Agent',
						link: 'list({ id: "LocalAgent"})',
						title: 'Local Agent',
						icon: ''
					},
					{
						menuItemCode: 'Procurer',
						apiUrl: 'Procurer',
						label: 'Procurer',
						link: 'list({ id: "Procurer"})',
						title: 'Procurer',
						icon: ''
					},
					{
						menuItemCode: 'PurchaseOrderStatus',
						apiUrl: 'PurchaseOrderStatus',
						label: 'Purchase Order Status',
						link: 'list({ id: "PurchaseOrderStatus"})',
						title: 'Procurement Purchase Order Status',
						icon: ''
					},
					{
						menuItemCode: 'PurchaseOrderType',
						apiUrl: 'PurchaseOrderType',
						label: 'Purchase Order Type',
						link: 'list({ id: "PurchaseOrderType"})',
						title: 'Procurement Purchase Order Type',
						icon: ''
					},
					{
						menuItemCode: 'ShipmentType',
						apiUrl: 'ShipmentType',
						label: 'Shipment Type',
						link: 'list({ id: "ShipmentType"})',
						title: 'Shipment Type',
						icon: ''
					},
					{
						menuItemCode: 'TenderType',
						apiUrl: 'TenderType',
						label: 'Tender Type',
						link: 'list({ id: "TenderType"})',
						title: 'Tender Type',
						icon: ''
					},
					{
						menuItemCode: 'TenderStatus',
						apiUrl: 'TenderStatus',
						label: 'Tender Status',
						link: 'list({ id: "TenderStatus"})',
						title: 'Tender Status',
						icon: ''
					},
					{
						menuItemCode: 'UnsuccessfulReason',
						apiUrl: 'UnsuccessfulReason',
						label: 'Unsuccessful Reason',
						link: 'list({ id: "UnsuccessfulReason"})',
						title: 'Unsuccessful Reason',
						icon: ''
					},
					{
						menuItemCode: 'UnsuccessfulReasonDetail',
						apiUrl: 'UnsuccessfulReasonDetail',
						label: 'Unsuccessful Reason Detail',
						link: 'list({ id: "UnsuccessfulReasonDetail"})',
						title: 'Unsuccessful Reason Detail',
						icon: ''
					},
					{
						menuItemCode: 'ShipmentPort',
						apiUrl: 'ShipmentPort',
						label: 'Shipment Port',
						link: 'list({ id: "ShipmentPort"})',
						title: 'Shipment Port',
						icon: ''
					}
				]
			}
		]
    });
'use strict';

angular.module('pds')
	.constant('FeedBackConst', {
        Info: {
            NoConnection: {
				Message: "Can not connect to server.",
				Recommendation: "Please, check your internet connection or try again later."
            },
            PasswordChanged: "Password changed successfully!",
            PasswordResetSuccess: "Password resetted successfully!",
			UnderConstruction: {
				Message: "This page is under construction.",
				Recommendation: ""
            }
        },
        Error: {
            ItemUnitOfIssueHasAlternate: "this item has alternate.",
            PasswordChangedFailed: "Change password failed!",
            PasswordResetFailed: "Password reset failed!"
        },
        Warning: {
            EditMappedItem: "item is mapped. Activities, Suppliers and Manufacturers will be reflected to its new item."
        },
        Validation: {
            Institution: {
                BracketNotAllowed: "brackets are not allowed in institution name.",
                AmharicCharacterNotAllowed: "Amharic characters are not allowed in institution name.",
                NumberOnlyNotAllowed: "Numbers only can not be used as institution name",
                AllowedIntial: "Institution Name must start with number or letter",
                EmptyTinNo: "Please enter a valid tin number"
            },
            Item: {
                InvalidBasecode: "Please enter a valid basecode. Basecode should contain 4 letters or/and numbers intially followed by dash (-) and 2 or 3 numbers",
                DefaultRRFUnitNotSelected: "Please select default rrf unit for the item"
            }
        }
    });
'use strict';

angular.module('pds.services')
    .service('ItemService', function(ItemFactory, StorageService, AccountService) {
        var itemService = {};
        
		var userInfo = AccountService.userInfo();

        itemService.add = function(menuItem, columnInfo, entity, success, failure) {
            fixOverflowOnBlockingMode(true);
            var addResource = ItemFactory.itemResourceAll(menuItem.apiUrl);
            if(!entity){
                entity = StorageService.get("TempEntity");
            }

            if(columnInfo) { 
                switch (menuItem.menuItemCode) {
                    case "Item":      
                        mapItem(columnInfo, entity);
                        break;
                    case "MenuItemInfo":
                    case "Institution":
                    case "Accessory":
                    case "UserAccountType":
                    case "UserRole":
                    case "LocalAgent":
                    case "TermsAndCondtions":
                        mapCollectionProperties(columnInfo, entity, menuItem);
                        break;
                    case "Supplier":
                        addDefaultSupplierCountry(entity);
                        mapCollectionProperties(columnInfo, entity, menuItem);
                        validateSupplierCountry(entity);
                        break;
                    case "Manufacturer":
                        addDefaultManufacturerCountry(entity);
                        mapCollectionProperties(columnInfo, entity, menuItem);
                        break;
                    default:
                        mapItem(columnInfo, entity);
                        break;
                }
            }
			addResource.save(entity, success, failure);
        }

        itemService.itemCategoryChanged = function(entity) {
            var stockCodeInput = document.getElementById('StockCode');
            if(entity.Category.length == 0){
                entity.StockCode = "";
                stockCodeInput.placeholder = "Select Category to generate Stock Code...";
            }
            else {
                var Category = entity.Category[0];
                var resource = ItemFactory.getSingle("Item" + '/GenerateStockCode/:id', Category.ID);
                stockCodeInput.placeholder = "generating...";
                resource.get(Category.ID, success, failed);
            }

            function success(data){
                StorageService.set("CurrentStockCode", data.stockCode);
                entity.StockCode = data.stockCode;
            }

            function failed(error){
                resource.get(Category.ID, success, failed);
            }
        }

        itemService.edit = function(menuItem, columnInfo, entity, success, failure) {
            fixOverflowOnBlockingMode(true);
            var editResource = ItemFactory.itemResourceAll(menuItem.apiUrl);
            if(!entity){
                entity = StorageService.get("TempEntity");
            }
            
            switch (menuItem.menuItemCode) {
                case "Item":
                    mapItem(columnInfo, entity);
                    break;
                case "ItemUnitOfIssue":
                    mapItemUnitOfIssue(columnInfo, entity);
                    break;
                case "ItemUnitOfIssueMapping":
                    mapItemUnitOfIssueMapping(columnInfo, entity);
                case "MenuItemInfo":
                case "Institution":
                case "Accessory":
                case "UserAccountType":
                case "UserRole":
                case "Manufacturer":
                case "LocalAgent":
                case "TermsAndCondtions":
                    mapCollectionProperties(columnInfo, entity, menuItem);
                    break;
                case "Supplier":
                    mapCollectionProperties(columnInfo, entity, menuItem);
                    validateSupplierCountry(entity);
                    break;
                case "VolumeMetricsDataEntry":
                    mapVolumeMetrics(columnInfo, entity);
                    break;
                default:
                    mapItem(columnInfo, entity);
                    break;
            }
			editResource.update(entity, function(data){
                success(data);
            }, function(data){
                failure(data);
            });
        }

        itemService.validateItem = function(menuItem, entity, success, failure) {
            if(entity.CommodityType && entity.CommodityType.CommodityTypeCode == "MEDE") entity.ProductBasecodeID = -1;
            var resource = ItemFactory.itemResourceAll(menuItem.apiUrl + "/ValidateItem");
            resource.validateItem(entity, success, failure);
        }

        itemService.getSuggestedBasecode = function(menuItem, entity, success, failure) {
            var strengthID = entity.StrengthID ? entity.StrengthID : 0;
            var resource = ItemFactory.get(menuItem.apiUrl + "/GetSuggestedBasecode/:productID/:strengthId/", entity.ProductID, strengthID);
            resource.get(entity.ProductID, entity.StrengthID, success, failure);
        }

        itemService.validateEntity = function(menuItem, entity, success, failure) {
            switch (menuItem.menuItemCode) {
                case "ItemUnitOfIssueMapping":
                    mapItemUnitOfIssueMapping(null, entity)
                    var resource = ItemFactory.itemResourceAll(menuItem.apiUrl + "/ValidateEntity");
                    resource.validateEntity(entity, success, failure);
                    break;
            
                default:
                    success();
                    break;
            }
        }

        itemService.fixOverflowOnBlockingMode = fixOverflowOnBlockingMode;

        function mapItem(columnInfo, entity){
            if(entity.CommodityType && entity.CommodityType.CommodityTypeCode == "MEDE") entity.ProductBasecodeID = -1;
            facilityUserFix(entity);
            _.each(columnInfo, function(property){
                var dependency = property.Dependency;
                var propertyName = property.Name;
                if(dependency !== null && property.DataType !== "ICollection`1"){
                    entity[propertyName.replace("ID", "")] = null;
                }

                if(property.DataType === "ICollection`1" && property.IsVisible){		
                    var tempItemDepndency = [];
                    for (var i = 0; i < entity[dependency].length; ++i){
                        tempItemDepndency[i] = {};
                        
                        tempItemDepndency[i]["ID"] = entity[dependency][i]['Key'];
                        tempItemDepndency[i][dependency + "ID"] = entity[dependency][i]['ID'],
                        tempItemDepndency[i]["ItemID"] = entity.ID;
                        
                        if(dependency == 'UnitOfIssue') {
                            var quantity = entity[dependency][i]['Quantity'];
                            var isDefault = entity[dependency][i]['IsDefault'];
                            var isActive = entity[dependency][i]['IsActive'];
                            var isDefaultRRF = entity[dependency][i]['IsDefaultRRF'];
                            var isPPL = entity[dependency][i]['IsPPL'];

                            if(quantity === undefined){
                                quantity = 1;
                            }

                            tempItemDepndency[i]["Quantity"] = quantity;
                            tempItemDepndency[i]["IsDefault"] = isDefault;
                            tempItemDepndency[i]["IsActive"] = isActive;
                            tempItemDepndency[i]["IsDefaultRRF"] = isDefaultRRF;
                            tempItemDepndency[i]["IsPPL"] = isPPL && isActive;
                        }

                        if(dependency == 'Programt'){
                            var isDefault = entity[dependency][i]['IsDefault'];
                            tempItemDepndency[i]["IsDefault"] = isDefault;
                        }

                        if(dependency == 'RRGroup'){
                            var isActive = entity[dependency][i]['IsActive'];
                            tempItemDepndency[i]["IsActive"] = isActive;
                        }
                    }

                    entity["Item" + dependency] = tempItemDepndency;
                }
            })
        }

        function mapItemUnitOfIssue(columnInfo, entity){           
            entity.ItemUnitOfIssueIDs = [];
            _.each(entity.ItemUnitOfIssues, function(iu){
                entity.ItemUnitOfIssueIDs.push(iu.ID);
            });
            entity.ItemUnitOfIssues = null;
        }

        function mapItemUnitOfIssueMapping(columnInfo, entity){
            entity.ItemUnitOfIssueID = entity.OldItemUnitOfIssueID;
            entity.NewItemUnitOfIssueID = entity.NewItemUnitOfIssueID;
        }

        function mapVolumeMetrics(columnInfo, entity) {
            if(entity.LengthCM === null && entity.WidthCM === null && entity.HeightCM === null
                && entity.PalletLengthCM === null && entity.PalletWidthCM === null && entity.PalletHeightCM === null) {
                entity.LengthCM = entity.WidthCM = entity.HeightCM = 
                        entity.PalletLengthCM = entity.PalletWidthCM = entity.PalletHeightCM = 0;
            }
            
            entity.LengthMM = entity.LengthCM * 10;
            entity.HeightMM = entity.HeightCM * 10;
            entity.WidthMM = entity.WidthCM * 10;
            mapItem(columnInfo, entity);
        }

        function mapCollectionProperties(columnInfo, entity, menuItem) {
            _.each(columnInfo, function(property){
                var dependency = property.Dependency;
                if(dependency !== null && property.DataType !== "ICollection`1") {
                    entity[property.Name.replace("ID", "")] = null;
                }

                if(property.DataType === "ICollection`1" && property.IsVisible) {
                    var relatedEntityMetaData = StorageService.get("MetaData" + menuItem.menuItemCode + dependency);
                    var dependencyList = [];
                    for (var i = 0; i < entity[property.Name].length; ++i) {
                        if(!entity[property.Name][i][menuItem.menuItemCode + "ID"]) {
                            dependencyList[i] = {};
                            dependencyList[i][dependency + "ID"] = entity[property.Name][i]["ID"];
                            angular.extend(dependencyList[i], copySelectedProperties(entity[property.Name][i], getVisibleProperties(relatedEntityMetaData)));
                        }
                        else {
                            dependencyList[i] = entity[property.Name][i];
                            dependencyList[i][dependency] = null;
                        }
                    }
                    entity[property.Name] = dependencyList;
                }
            });
        }

        function fixOverflowOnBlockingMode(isBlockingMode) {
            $('#add-edit-entity-form-wrapper').scrollTop(0);
            var form_wrapper = document.getElementById('add-edit-entity-form-wrapper');
            
            if(form_wrapper != null) {
                if(isBlockingMode) {
                    form_wrapper.className = 'content-wrapper-in' + ' overflow-hidden';
                }
                else {
                    form_wrapper.className = 'content-wrapper-in';
                }
            }
        }

        function getVisibleProperties(metaData) { 
            try {
                var visibleProperties = [];
                _.each(metaData, function(property) {
                    if(property.IsVisible) {
                        visibleProperties.push(property.Name);
                    }
                });
                return visibleProperties;
            } catch (error) {
                return [ ];
            }
        }

        function copySelectedProperties(data, selectedProperties) {
            try {
                var subData = {};
                for (var key in data) {
                    if (data.hasOwnProperty(key) && selectedProperties.includes(key)) {
                        subData[key] = data[key];
                    }
                }
                return subData;
            } catch (error) {
                return {};
            }
        }

        function addDefaultSupplierCountry(entity) {
            var defaultExist = _.some(entity.SupplierCountry, function(sc) {
                return sc.ID ==  entity.CountryID;
            });
            if(!defaultExist) {
                var defaultSupplierCountry = { 
                        ID: entity.CountryID, 
                        Address: entity.Address, 
                        Telephone: entity.Telephone, 
                        Email: entity.Email }
                entity.SupplierCountry.push(defaultSupplierCountry);
            }
        }

        function validateSupplierCountry(entity) {
            try {
                var defaultSupplierCountry = _.find(entity.SupplierCountry, function(sc) {
                    return sc.CountryID == entity.CountryID;
                });

                if(!defaultSupplierCountry.Address) {
                    defaultSupplierCountry.Address = entity.Address;
                }

                if(!defaultSupplierCountry.Telephone) {
                    defaultSupplierCountry.Telephone = entity.Telephone;
                }

                if(!defaultSupplierCountry.Email) {
                    defaultSupplierCountry.Email = entity.Email;
                }
            } catch (error) {
                console.log(error);
            }
        }

        function addDefaultManufacturerCountry(entity) {
            var defaultExist = _.some(entity.ManufacturerCountry, function(mc) {
                return mc.ID ==  entity.CountryID;
            });
            if(!defaultExist) {
                var defaultManufacturerCountry = { ID: entity.CountryID }
                entity.ManufacturerCountry.push(defaultManufacturerCountry);
            }
        }

        function facilityUserFix(entity) {
            try {
                entity.UnitOfIssue.forEach(function(unitOfIssue) {
                    if (userInfo.userAccountTypeCode == "FCLTY" && unitOfIssue.CreatedDate) {
                        unitOfIssue.IsActive = false;
                    }
                });
            } catch (error) {
                
            }
        }

		return itemService;
	});
(function() {
	'use strict';

	angular
		.module('pds')
		.config(registrationRouterConfig);

	/** @ngInject */
	function registrationRouterConfig($stateProvider) {

		$stateProvider
			.state('add', {
				url: '/add/:id',
				parent: 'app',
				views: {
					'contentContainer@app': {
						templateUrl: 'app/item/add/add.html',
						controller: 'AddController',
						controllerAs: 'vm'
					}
				},
				params: {
					id: null
				}
			})
			.state('detail', {
				url: '/detail/:id/:objectId',
				parent: 'app',
				views: {
					'contentContainer@app': {
						templateUrl: 'app/item/detail/detail.html',
						controller: 'DetailController',
						controllerAs: 'vm'
					}
				},
				params: {
					id: null,
					name: null
				}
			})
			.state('edit', {
				url: '/edit/:id/:objectId',
				parent: 'app',
				views: {
					'contentContainer@app': {
						templateUrl: 'app/item/edit/edit.html',
						controller: 'EditController',
						controllerAs: 'vm'
					}
				},
				params: {
					id: null
				}
			})
			.state('list', {
				url: '/list/:id',
				parent: 'app',
				views: {
					'contentContainer@app': {
						templateUrl: 'app/item/list/list.html',
						controller: 'ListController',
						controllerAs: 'vm'
					}
				},
				params: {
					id: null
				}
			})
	}
})();

'use strict';

angular.module('pds.factories')
	.factory('ItemFactory', function(AppConst, CommonService, $resource) {
		var itemFactory = {};

		itemFactory.itemResourceAll = function(resourceApi, request) {
			return $resource(CommonService.buildUrl(resourceApi), request, AppConst.ResourceMethods.All);
		}

		itemFactory.cachedRequestWithTimeOut = function(resourceApi, request) {
			return $resource(CommonService.buildUrl(resourceApi), request, 
					AppConst.ResourceMethods.CachedRequestWithTimeOut);
		}

		itemFactory.getSingle = function(resourceApi, id) {
			return $resource(CommonService.buildUrl(resourceApi + '/:id', id), { id: "@id" }, AppConst.ResourceMethods.Readonly);
		}

		itemFactory.get = function(resourceApi, productID, strengthId) {
			var url = CommonService.buildUrl(resourceApi);
			return $resource(url, { productID: productID, strengthId: strengthId }, AppConst.ResourceMethods.Readonly);
		}

		itemFactory.columnInfo = function(resourceApi) {
			return $resource(CommonService.buildUrl(resourceApi  + "/Info"), {}, AppConst.ResourceMethods.CachedRequest);
		}

		itemFactory.columnInfoFlat = function(resourceApi) {
			return $resource(CommonService.buildUrl(resourceApi  + "/Info/Flat"), {}, AppConst.ResourceMethods.CachedRequest);
		}

		itemFactory.delete = function(resourceApi, id) {
			return $resource(CommonService.buildUrl(resourceApi + '/:id', id), { id: "@id" }, AppConst.ResourceMethods.Delete);
		}

		return itemFactory;
	});
'use strict';

angular.module('pds.services')
    .service('ErrorHandlingService', function(AppConst, StorageService, $location, $state, $window) {
        var errorHandlingService = {};
        
        errorHandlingService.requestFailed = function(error, returnUrl) {
            switch (error.status) {
                case 401:
                    resetStorage();
                    break;
            
                default:
                    break;
            }

            if(error.statusText  == "") {
                StorageService.set(AppConst.StorageKeys.ReturnUrl, returnUrl);
                $location.path("/error");
            }

            else if(error.statusText == "error") {
                StorageService.set(AppConst.StorageKeys.ReturnUrl, returnUrl);
                $state.go("error");
            }
        }

        function resetStorage() {
            StorageService.remove(AppConst.StorageKeys.UserInfo);
            StorageService.remove(AppConst.StorageKeys.Token);
            $window.location.reload();
        }

		return errorHandlingService;
	});
(function() {
	'use strict';

	angular
        .module('pds')
        .config(errorRouterConfig);

	/** @ngInject */
	function errorRouterConfig($stateProvider) {

		$stateProvider
			.state('error', {
				url: '/error/:type',
				parent: 'app',
				views: {
					'contentContainer@app': {
						templateUrl: 'app/error/error.html'
					}
				},
				params: {
					type: null
				}
			})
	}
})();

'use strict';

angular.module('pds.controllers')
    .controller('ErrorController', function(AppConst, FeedBackConst, StorageService, $location, $scope, $stateParams) {
        var vm = this;

        var errorIdentifier = $stateParams.type;

        // $location.path(StorageService.get(AppConst.StorageKeys.ReturnUrl));


        vm.reload = function () { 
            $location.path(StorageService.get(AppConst.StorageKeys.ReturnUrl)).replace();
        }

        vm.goToHome = function () { 
            $location.path('/Item/list');
        }

        getErrorMsg(errorIdentifier);

        function getErrorMsg(errorIdentifier) {
            switch (errorIdentifier) {
                case "UnderConstruction":
                    vm.errorMsg = FeedBackConst.Info.UnderConstruction.Message;
                    vm.recommendedAction = FeedBackConst.Info.UnderConstruction.Recommendation;
                    vm.actionIcon = 'fa fa-home fa-6';
                    vm.actionTitle = 'go to home';
                    vm.action = vm.goToHome;
                    break;
            
                default:
                    vm.errorMsg = FeedBackConst.Info.NoConnection.Message;
                    vm.recommendedAction = FeedBackConst.Info.NoConnection.Recommendation;
                    vm.actionIcon = 'fa fa-refresh fa-6';
                    vm.actionTitle = 'reload';
                    vm.action = vm.reload;
                    break;
            }
        }
    });
'use strict';

angular.module('pds.controllers')
    .controller('ResetPasswordController', function(AccountFactory, AppConst, FeedBackConst, NotificationService, 
                $stateParams, $state) {
        var vm = this;
        vm.resetPasswordModel = {};
        vm.resetPasswordModel.userName =  $stateParams.username;
        vm.successMessage =  $stateParams.message;

        vm.resetPassword = function() {
            vm.successMessage = vm.errorMessage = '';
            if (vm.resetPasswordForm.$valid) {
                vm.isLoading = true;
                var model = {
                    userName: vm.resetPasswordModel.userName,
                    resetCode: vm.resetPasswordModel.resetCode
                };

                AccountFactory.resetPassword.save(model, function(result) {
                    vm.isLoading = false;
                    if (result.Success) {
                        vm.successMessage = result.Info[0];
                    } else {
                        vm.errorMessage = result.Error[0];
                    }
                }, function(error) {
                    vm.errorMessage = "please check your connection and try again.";
                })
            }
        }

        vm.sendResetCode = function() {
            vm.successMessage = vm.errorMessage = '';
            if(vm.resetPasswordModel.userName) {
                vm.isLoading = true;
                AccountFactory.sendResetCode.save( { userName: vm.resetPasswordModel.userName }, function(result) {
                    vm.isLoading = false;
                    if (result.Success) {
                        $state.go('reset', { username: vm.resetPasswordModel.userName, message: result.Info[0]
                                }, { reload: false });
                    } 
                    else {
                        vm.errorMessage = result.Error[0];
                    }
                }, function(error) {
                    vm.errorMessage = "please check your connection and try again.";
                })
            }
        }
    });
'use strict';

angular.module('pds.controllers')
    .controller('LoginController', function(AccountService, AppConst, CommonService, StorageService, $log, $state, $location, deviceDetector) {
        if(AccountService.userInfo()){
            var defaultPage = CommonService.getUserDefaultPage(StorageService.get(AppConst.StorageKeys.UserInfo));
            $state.go('list', {id: defaultPage}, {reload: false});
        }
        var vm = this;
        vm.year = (new Date()).getFullYear();
        vm.company = "John Snow Inc | AIDSFree Project";


        //build logger
        vm.data = deviceDetector;
        //build the login Model
        vm.loginModel = {
            clientInfo: {
                os: vm.data.os,
                osVersion: vm.data.os_version,
                deviceType: vm.data.isDesktop() ? "Desktop" : vm.data.device,
                browser: vm.data.browser,
                browserVersion: vm.data.browser_version
            }
        };

        vm.loginModelValidation = {};


        vm.showError = false;
        vm.loginFailed = false;

        vm.Authenticate = function() {
            vm.showError = true;
            vm.isLoading = true;

            // Check for login model validity if custom form validation is used
            if (true) {
                AccountService.login(vm.loginModel)
                    .then(function(result) {
                        //redirect to main
                        if (result.token != undefined && result.token.access_token != undefined) {
                            var returnUrl = CommonService.getReturnUrl();
                            
                            //go to change password for unconfirmed account
                            if(!result.user.isConfirmed) {
                                $state.go('change');
                            }

                            else if(result.user.userAccountTypeCode == 'APR') {
                                $state.go('list', {id: 'ItemUnitofIssuePPL'}, {reload: true});
                            }

                            else {
                                var defaultPage = CommonService.getUserDefaultPage(result.user);
                                $state.go('list', {id: defaultPage}, {reload: true});
                            }

                        } else {
                            vm.loginFailed = true;
                            vm.isLoading = false;
                        }
                    }, function(error) {
                        //show alert or something
                        $log.log(error);
                    })
            }
        }

    });

'use strict';

angular.module('pds.controllers')
    .controller('ForgotController', function() {
        var vm = this;

        vm.submitEmail = function() {
        }

    });

'use strict';

angular.module('pds.controllers')
    .controller('ChangePasswordController', function(AccountFactory, AppConst, FeedBackConst, NotificationService, 
                $stateParams, $state) {
        var vm = this;
        vm.changePasswordModel = {};

        vm.changePassword = function() {
            if (vm.isValid && vm.changePasswordForm.$valid) {
                if (vm.changePasswordModel.newPassword === vm.changePasswordModel.Confirm) {
                    vm.isLoading = true;
                    var model = {
                        oldPassword: vm.changePasswordModel.oldPassword,
                        newPassword: vm.changePasswordModel.newPassword,
                        hasOldPassword: true
                    };
                    
                    AccountFactory.changePassword.save(model, function(result) {
                        vm.isLoading = false;
                        if (result.success) {
                            NotificationService.notify(FeedBackConst.Info.PasswordChanged, 'alert-success');
                            $state.go('list', {id: 'Item'}, {reload: false});
                        } else {
                            NotificationService.notify(FeedBackConst.Error.PasswordChangedFailed, 'alert-danger');
                        }

                    }, function(error) {})
                } else {
                    vm.isValid = false;
                    vm.errorMessage = AppConst.Password.DoNotMatch;
                }

            }
        }

        vm.validateForm = function() {   
            if (vm.changePasswordModel.newPassword.length < AppConst.Password.MinLength) {
                vm.isValid = false;
                vm.errorMessage = AppConst.Password.TooShort;
            }

            else {
                vm.isValid = true;
                vm.errorMessage = "";
            }
        }

    });
'use strict';

angular.module('pds.services')
    .service('AccountService', function(AppConst, AccountFactory, CommonService, StringConst, 
                StorageService, $http, $q) {
        var accountService = {};
        // var deferred = $q.defer();
        accountService.login = function(loginModel) {
            return $http.post(CommonService.buildUrl(AppConst.API_URL.Account.Autenticate, undefined), loginModel)
                .then(function(response) {
                    var data = response.data;
                    customizeUser(response.data.user);
                    StorageService.set(AppConst.StorageKeys.Token, response.data.token);
                    StorageService.set(AppConst.StorageKeys.UserInfo, response.data.user);
                    StorageService.set(AppConst.StorageKeys.Permissions, response.data.permissions);
                    return data;
                }, function(error) {
                    return error;
                });
        }

        accountService.logout = function(reason) {
            AccountFactory.logout.save({ userID: null }, { userID: this.userInfo().ID, reason:reason});

            StorageService.removeAll();
        }

        accountService.userInfo = function() {
            var userInfo = StorageService.get(AppConst.StorageKeys.UserInfo);
            return userInfo;
        };

        accountService.token = function() {
            var token = StorageService.get(AppConst.StorageKeys.Token);
            if (token != undefined) {
                return 'Bearer ' + token.access_token;
            }
            return null;
        }

        accountService.permissions = function() {
            var permissions = StorageService.get(AppConst.StorageKeys.Permissions);
            return permissions;
        }

        accountService.hasThisPermission = function(permission) {
            var permissions = this.permissions();
            var hasPermission = _.contains(permissions, permission);
            return hasPermission;
        }

        accountService.hasThesePermissions = function(permissions) {
            var hasPermission = false;
            _.each(permissions, function(permission) {
                //return true if user has access to one of the permissions
                hasPermission = hasPermission || accountService.hasThisPermission(permission);
            })
            return hasPermission;
        }

        function customizeUser(user) {
            if(user && StringConst.UserAccountType.Children.Editor.includes(user.userAccountTypeCode)) {
                user.userAccountType = "Editor";
                user.userAccountTypeCode = "ED";
                StorageService.set("CommodityType", undefined);
            }
        }

        return accountService;
    });

'use strict';

angular.module('pds.factories')
    .factory('AccountFactory', function($resource, AppConst, CommonService) {
        var accountFactory = {};
        accountFactory.users = $resource(CommonService.buildUrl(AppConst.API_URL.Account.Users, undefined, true), { id: "@id" }, AppConst.ResourceMethods.All);
        accountFactory.authenticate = $resource(CommonService.buildUrl(AppConst.API_URL.Account.Autenticate, undefined, true), {}, AppConst.ResourceMethods.Post);
        accountFactory.token = $resource(CommonService.buildUrl(AppConst.API_URL.Account.Token, undefined, true), {}, AppConst.ResourceMethods.Post);
        accountFactory.validateToken = $resource(CommonService.buildUrl(AppConst.API_URL.Account.ValidateToken, undefined, true), {}, AppConst.ResourceMethods.Readonly);
        accountFactory.changePassword = $resource(CommonService.buildUrl(AppConst.API_URL.Account.ChangePassword, undefined, true), {}, AppConst.ResourceMethods.save);
        accountFactory.resetPassword = $resource(CommonService.buildUrl(AppConst.API_URL.Account.ResetPassword, undefined, true), {}, AppConst.ResourceMethods.save);
        accountFactory.sendResetCode = $resource(CommonService.buildUrl(AppConst.API_URL.Account.SendResetCode, undefined, true), {}, AppConst.ResourceMethods.save);
        accountFactory.logout = $resource(CommonService.buildUrl(AppConst.API_URL.Account.Logout, undefined, true), { userID: "@userID" }, AppConst.ResourceMethods.save);

        return accountFactory;
    });
/*!
 SearchHighlight for DataTables v1.0.1
 2014 SpryMedia Ltd - datatables.net/license
*/
(function(h,g,a){function e(d,c){d.unhighlight();c.rows({filter:"applied"}).data().length&&(c.columns().every(function(){this.nodes().flatten().to$().unhighlight({className:"column_highlight"});this.nodes().flatten().to$().highlight(a.trim(this.search()).split(/\s+/),{className:"column_highlight"})}),d.highlight(a.trim(c.search()).split(/\s+/)))}a(g).on("init.dt.dth",function(d,c){if("dt"===d.namespace){var b=new a.fn.dataTable.Api(c),f=a(b.table().body());if(a(b.table().node()).hasClass("searchHighlight")||
c.oInit.searchHighlight||a.fn.dataTable.defaults.searchHighlight)b.on("draw.dt.dth column-visibility.dt.dth column-reorder.dt.dth",function(){e(f,b)}).on("destroy",function(){b.off("draw.dt.dth column-visibility.dt.dth column-reorder.dt.dth")}),b.search()&&e(f,b)}})})(window,document,jQuery);

/*
 * jQuery Highlight plugin
 *
 * Based on highlight v3 by Johann Burkard
 * http://johannburkard.de/blog/programming/javascript/highlight-javascript-text-higlighting-jquery-plugin.html
 *
 * Code a little bit refactored and cleaned (in my humble opinion).
 * Most important changes:
 *  - has an option to highlight only entire words (wordsOnly - false by default),
 *  - has an option to be case sensitive (caseSensitive - false by default)
 *  - highlight element tag and class names can be specified in options
 *
 * Usage:
 *   // wrap every occurrance of text 'lorem' in content
 *   // with <span class='highlight'> (default options)
 *   $('#content').highlight('lorem');
 *
 *   // search for and highlight more terms at once
 *   // so you can save some time on traversing DOM
 *   $('#content').highlight(['lorem', 'ipsum']);
 *   $('#content').highlight('lorem ipsum');
 *
 *   // search only for entire word 'lorem'
 *   $('#content').highlight('lorem', { wordsOnly: true });
 *
 *   // don't ignore case during search of term 'lorem'
 *   $('#content').highlight('lorem', { caseSensitive: true });
 *
 *   // wrap every occurrance of term 'ipsum' in content
 *   // with <em class='important'>
 *   $('#content').highlight('ipsum', { element: 'em', className: 'important' });
 *
 *   // remove default highlight
 *   $('#content').unhighlight();
 *
 *   // remove custom highlight
 *   $('#content').unhighlight({ element: 'em', className: 'important' });
 *
 *
 * Copyright (c) 2009 Bartek Szopka
 *
 * Licensed under MIT license.
 *
 */

jQuery.extend({
    highlight: function (node, re, nodeName, className) {
        if (node.nodeType === 3) {
            var match = node.data.match(re);
            if (match) {
                var highlight = document.createElement(nodeName || 'span');
                highlight.className = className || 'highlight';
                var wordNode = node.splitText(match.index);
                wordNode.splitText(match[0].length);
                var wordClone = wordNode.cloneNode(true);
                highlight.appendChild(wordClone);
                wordNode.parentNode.replaceChild(highlight, wordNode);
                return 1; //skip added node in parent
            }
        } else if ((node.nodeType === 1 && node.childNodes) && // only element nodes that have children
                !/(script|style)/i.test(node.tagName) && // ignore script and style nodes
                !(node.tagName === nodeName.toUpperCase() && node.className === className)) { // skip if already highlighted
            for (var i = 0; i < node.childNodes.length; i++) {
                i += jQuery.highlight(node.childNodes[i], re, nodeName, className);
            }
        }
        return 0;
    }
});

jQuery.fn.unhighlight = function (options) {
    var settings = { className: 'highlight', element: 'span' };
    jQuery.extend(settings, options);

    return this.find(settings.element + "." + settings.className).each(function () {
        var parent = this.parentNode;
        parent.replaceChild(this.firstChild, this);
        parent.normalize();
    }).end();
};

jQuery.fn.highlight = function (words, options) {
    var settings = { className: 'highlight', element: 'span', caseSensitive: false, wordsOnly: false };
    jQuery.extend(settings, options);
    
    if (words.constructor === String) {
        words = [words];
    }
    words = jQuery.grep(words, function(word, i){
      return word != '';
    });
    words = jQuery.map(words, function(word, i) {
      return word.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    });
    if (words.length == 0) { return this; };

    var flag = settings.caseSensitive ? "" : "i";
    var pattern = "(" + words.join("|") + ")";
    if (settings.wordsOnly) {
        pattern = "\\b" + pattern + "\\b";
    }
    var re = new RegExp(pattern, flag);
    
    return this.each(function () {
        jQuery.highlight(this, re, settings.element, settings.className);
    });
};


'use strict';

angular.module('pds.controllers')
	.controller('DynamicInputController', function(AppConst, DtRequestService, ItemFactory, StringConst, StorageService, 
				$filter, $scope) {
		var inputController = this;
		var api = $scope.inputProperty.Dependency;
		var menuItem = $scope.menuItem;
		var request = DtRequestService.buildDefaultPageRequestParam(menuItem.menuItemCode, 
				api, $scope.inputProperty);
		var pageIsLoading = false;

		var user = StorageService.get(AppConst.StorageKeys.UserInfo);
		var relatedMetaDataCodeList = AppConst.Entity.RelatedMetaData[menuItem.menuItemCode] || [];
		
		relatedMetaDataCodeList.forEach(function(relatedEntityCode) {
			inputController["MetaData" + relatedEntityCode] = $filter('orderBy')(StorageService.get("MetaData" + relatedEntityCode), 'Order');
		});

		inputController.preferedProperty = getPreferedProperty(menuItem.menuItemCode);

		function getPreferedProperty(entityIdentifier) {
			switch (entityIdentifier) {
				case "ItemUnitOfIssueMapping":
					return "MappingFullName";
				case "VolumeMetrics":
					if(api == "ItemManufacturer") {
						return "Manufacturer";
					}
					else if(api == "ItemUnitOfIssue") {
						return "UnitOfIssue";
					}	
					break;	
				default:
					return "FullName";
			}
		}

		inputController.dropDownData = {};

		inputController.totalRecords = 0;

		// check if the input is dropdown (ui-select)
		if($scope.inputProperty.Dependency !== null){		
			// load intial (first page) dropdown list data for ui-select-choices
			if(inputController.dropDownData[api] === undefined){
				fetchInputData();
			}
		}

		inputController.allPageLoaded = false;

		inputController.setDropDownData = function(api) {
			if(inputController.dropDownData[api] === undefined){
				ItemFactory.itemResourceAll(api).query(function(data){
					inputController.dropDownData[api] = data;
				});
			}
		};

		inputController.isInputDisabled = function(inputProperty) {		
			var isAutoGenerated = inputProperty.IsAutoGenerated;
			var inputIdentifier = inputProperty.Name;
			var conditioanallyEditable = inputProperty.ConditioanallyEditable;
			var filterDependency = inputProperty.FilterDependency;
			var entity = StorageService.get("currentEntityOnEdit");

			var isDisabled = false;
			var mode = StorageService.get('Mode');

			if(user.userAccountTypeCode != "ADM") {
				if(mode == 'Edit' && menuItem.menuItemCode == StringConst.MenuItemCode.Institution
							&& inputIdentifier == "InstitutionTypeID"
							) {
					return true;
				}
			}

			if(user.userAccountTypeCode == "INSTE" 
					&& inputIdentifier == "Name"
					&& menuItem.menuItemCode == StringConst.MenuItemCode.Institution) {
				return false;
			}

			if(isAutoGenerated) { 
				return true;
			}

			if(filterDependency && $scope.inputModel[filterDependency + 'ID'] == null) {
				return true;
			}

			if(user.userAccountTypeCode == "FCLTY") {
				if(AppConst.Entity.Item.FacilityAccessLimitedColumns.includes(inputIdentifier)) {
					return true;
				}
			}
			
			if(mode == 'Add') { 
				return false; 
			}

			if(mode == 'Edit') { 
				if(conditioanallyEditable) {
					return true;
				}
				
				if(inputIdentifier == 'IsDefault' 
						&& menuItem.menuItemCode == StringConst.MenuItemCode.Item) {
					return entity.IsDefault;
				}
			}

			if(AppConst.Entity.Item.NonEditableColumns 
					.includes(inputIdentifier.replace('ID', ''))) { 
				isDisabled = true; 
			}

			if($scope.inputModel.IsConfirmed || $scope.inputModel.IsReceived
					|| user.userAccountTypeCode == "ItmED") {
				if(AppConst.Entity.Item.NonEditableColumnsAfterReceive
						.includes(inputIdentifier.replace('ID', ''))) { 
					isDisabled = true; 
				}
			}

			return isDisabled;
		};

		inputController.isMultipleUISelectDisabled = function() {
			var isDisabled = false;
			if($scope.inputModel.ItemUnitOfIssueID != null) {
				isDisabled = true;
			}

			return isDisabled;
		}

		inputController.isMultipleUISelectRequired = function(inputIdentifier) {
			var isRequired = true;
			var mode = StorageService.get('Mode');
			
			switch (menuItem.menuItemCode) {
				case "Item":
					if(inputIdentifier == "Category" && mode == "Edit") {
						isRequired = false;
					}
					break;
			
				default:
					break;
			}

			return isRequired;
		}

		inputController.getLimit = function(inputProperty) {
			var inputIdentifier = inputProperty.Name;

			if(inputProperty.Name == "Category") {
				return 1;
			}
		}

		// show or hide input based on commodity type
		inputController.isInputVisible = function(inputIdentifier) {
			var isVisible = true;
			var mode = StorageService.get('Mode');
			var dynamicVisibility = $scope.inputProperty.DynamicVisibility;
			
			var PharmaceuticalColumns = mode == "Add" 
					? AppConst.Entity.Item.PharmaceuticalColumnsOnAdd
					: AppConst.Entity.Item.PharmaceuticalColumnsOnEdit;
			
			if(PharmaceuticalColumns.includes(inputIdentifier)){
				if($scope.inputModel.CommodityTypeID == undefined){ return false; }
				
				isVisible = false;
				$scope.inputModel.CommodityType = StorageService.get("CurrentCommodityType");
				if($scope.inputModel.CommodityType !== undefined 
						&& $scope.inputModel.CommodityType.CommodityTypeCode == "PHAR"){
					isVisible = true;
				}
			}

			if(dynamicVisibility !== null) {
				try {
					var currentValue = dynamicVisibility.Dependency !== null
							? $scope.inputModel[dynamicVisibility.Dependency][dynamicVisibility.PropertyName]
							:  $scope.inputModel[dynamicVisibility.PropertyName];
					isVisible = dynamicVisibility.InterstingValues.includes(currentValue);
				} catch (error) {
					isVisible = false;
				}
			}

			if($scope.inputProperty.Name == "Vvmrequired") {
				if(user.userAccountTypeCode != "ADM") {
					isVisible = false;
				}
			}
			
			if(user.userAccountTypeCode == "VMDE") {
				if(AppConst.Entity.VolumeMetrics.AccessLimitedColumns.includes(inputIdentifier)) {
					isVisible = false;
				}
			}
			
			return isVisible;
		};

		// event handler when ui-select-choice is scrolled 100%
		inputController.goToNextPage = function(element, searchKey){
			// check if another request(page) is being processed 
			// check if end of page is reached (all list data is loaded)
			// only then load for the next page
			if(!pageIsLoading && !inputController.allPageLoaded){
				pageIsLoading = true;
				request.start += AppConst.UIConfig.UISelect.ListPageSize;
				// Load all categories in order to perform local sort by ParentCategory Name
				// TODO move this logic to server side 
				if(api === "Category") { request.start += AppConst.UIConfig.UISelect.ListPageSize; }
				ItemFactory.itemResourceAll(api + '/List', DtRequestService.formatDtRequestParameter(request)).search(function(data){
					inputController.allPageLoaded = data.Data.length == 0;					
					data.Data = filterData(data.Data);
					data.Data = removeSelected(data.Data);
					inputController.dropDownData[api] = inputController.dropDownData[api].concat(data.Data);
					pageIsLoading = false;
					if(inputController.allPageLoaded){
						var loadingRows = document.querySelectorAll('.ui-select-choices-row-custom');
						_.each(loadingRows, function(row){
							row.parentNode.removeChild(row);
						});
					}
				});
			}
		}

		// event handler when ui-select-search value is changed
		inputController.filterChoices = function(searchKey) {
			inputController.allPageLoaded = false;
			request.start = 0;
			request.search.value = searchKey;

			if(StorageService.get("CurrentCommodityType") !== undefined && api == 'Product') 
				request.columns[1].search.value = StorageService.get("CurrentCommodityType").ID; 
			fetchInputData();
		}

		// enforce constraint an item can have only a single default(UnitOfIssue.IsDefault) unitOfIssue
		inputController.onIsDefaultChange = function(currentIndex, model) {
			_.each($scope.inputModel[model], function(element) {
				element.IsDefault = false;
			});

			$scope.inputModel[model][currentIndex].IsDefault = true;
		}

		// enforce constraint an item can have only a single default RRF unit(UnitOfIssue.IsDefaultRRF) unitOfIssue
		inputController.onIsDefaultRRFChange = function(currentIndex, model) {
			_.each($scope.inputModel[model], function(element) {
				element.IsDefaultRRF = false;
			});

			$scope.inputModel[model][currentIndex].IsDefaultRRF = true;
		}

		// enforce constraint an item can have only a single IsPPL unitOfIssue
		inputController.onIsPPLChange = function(currentIndex, model) {
			for (var index = 0; index < $scope.inputModel[model].length; index++) {
				if(currentIndex != index) {
					$scope.inputModel[model][index].IsPPL = false;
				}
			}
		}

		// reset input when it loss focus (onblur)
		inputController.resetInput = function(){
			request.start = 0;
			request.search.value = "";
			inputController.allPageLoaded = false;
			// inputController.dropDownData[api] = {};
			
			fetchInputData();
		}

		inputController.onSelectCallback = function() {
			inputController.resetInput();
		}

		inputController.showDynamicDependencyForm =  function(inputModel, inputProperty) { 
			try {
				var isNotEmpty = inputModel[inputProperty.Name].length > 0;
				var show = inputController["MetaData" + menuItem.menuItemCode + inputProperty.Dependency];
				return isNotEmpty && show;
			} catch (error) {
				return false;
			}
		}

		inputController.showDependencyForm = function(inputModel, inputProperty) {
			if (inputModel[inputProperty.Name] == null ) return false;
			var show = false;
			var isNotEmpty = inputModel[inputProperty.Name].length > 0;
			switch (inputProperty.Name) {
				case "UnitOfIssue":
					show = true;
					break;			
				case "Programt":				
					show = user.userAccountTypeCode == "ADM"
					break;			
				default:
					show = false;
					break;
			}

			return isNotEmpty && show;
		}

		inputController.showDependencyInput = function(inputProperty, dependentProperty) {
			var show = false;
			switch (dependentProperty) {
				case "IsActive":
					show = (inputProperty.Name == "UnitOfIssue") && !(user.userAccountTypeCode == "FCLTY");
					break;
				case "IsDefault":
					show = user.userAccountTypeCode == "ADM" || StorageService.get("Mode") == "Add";
					break;

				case "IsDefaultRRF":
					show = inputProperty.Name == "UnitOfIssue"; //&& user.userAccountTypeCode == "ADM"
					break;

				case "Quantity":
					show = inputProperty.Name == "UnitOfIssue";
					break;
			
				case "IsPPL":
					show = inputProperty.Name == "UnitOfIssue";
					break;
				default:
					show = false;
					break;
			}

			return show;
		}

		inputController.getNameFormat = function(entityCode) {
			switch (entityCode) {
				case "ItemUnitOfIssue":
					return AppConst.NameFormat.ItemUnitOfIssue;
				case "ItemUnitOfIssueMapping":
					return AppConst.NameFormat.ItemUnitOfIssueMapping;
				default:
					return "";
			}
		}

		function fetchInputData() {
			if(!$scope.inputProperty.ConditioanallyEditable || StorageService.get('Mode') == 'Add') {
				includeRelatedPropertyFilter();
				
				(function(currentSearchKey) {
					ItemFactory.itemResourceAll(api + '/List', 
							DtRequestService.formatDtRequestParameter(request)).search(function(data) {
						if(currentSearchKey == request.search.value) {
							data.Data = filterData(data.Data);
							inputController.dropDownData[api] = removeSelected(data.Data);
							if(api == 'ProductBasecode') {
								StorageService.set(StringConst.MenuItemCode.ProductBasecode, removeSelected(data.Data));
							}
						}
					});
				}(request.search.value));
			}
		}
		
		function includeRelatedPropertyFilter() {
			switch (api) {
				case "Product":
					request.columns[1].search.value = StorageService.get("CurrentCommodityType").ID;
					break;
				case "Category":
					request.columns[1].search.value = 3;
					break;
				case "ItemUnitOfIssue":
					if(menuItem.menuItemCode == "ItemUnitOfIssueMapping"){
						request.columns[1].search.value = $scope.inputModel.CommodityTypeID;
					}
					else if(menuItem.menuItemCode == "VolumeMetrics"){
						request.columns[1].search.value = $scope.inputModel.ItemID;
					}
					break;
				case "Environment":
					if(menuItem.menuItemCode == "LSI" || menuItem.menuItemCode == "EnvironmentDemographicEstimate"
							|| menuItem.menuItemCode == "Institution"){
						request.columns[1].search.value = "PFSA";
						break;
					}
				case "ProductBasecode":
					var showAllBasecodes = StorageService.get("ShowAllBasecodes");
					console.log(showAllBasecodes);
					if(request.columns[1] && !showAllBasecodes) {
						request.columns[1].data = "ProductID";
						request.columns[1].search.value = 
								$scope.inputModel[$scope.inputProperty.FilterDependency + 'ID'];
					}
					else {
						request.columns[1].data = "CommodityTypeID";
						request.columns[1].search.value = StorageService.get("CurrentCommodityType").ID;
					}
					break;
				default:
					if(request.columns[1]) {
						request.columns[1].search.value = 
								$scope.inputModel[$scope.inputProperty.FilterDependency + 'ID'];
					}
					break;
			}
		}

		// remove already select items from ui-select-choice list
		function removeSelected(array){
			if($scope.inputProperty.DataType == "ICollection`1"){
				var selected = $scope.inputModel[menuItem.menuItemCode + api] || 
						$scope.inputModel[api] || $scope.inputModel[api + 's'];
				if(selected != undefined){
					for (var index = 0; index < selected.length; ++index) {
						array = _.reject(array, function(mydata){
							var reject = selected[index][api + "ID"] ? mydata.ID == selected[index][api + "ID"]
								: mydata.ID == selected[index].ID;
							return reject;
						});
					}
				}
			}

			return array;
		}

		function filterData(array) {
			switch (api) {
				case StringConst.MenuItemCode.Period:			
					if(menuItem.menuItemCode == StringConst.MenuItemCode.LSI) {					
						return _.filter(array, function(period) {
							return _.includes(['Even', 'Odd'], period.PeriodType);
						});
					}
				
				case StringConst.MenuItemCode.Institution:			
					if(menuItem.menuItemCode == StringConst.MenuItemCode.Institution) {
						array.push({ ID: 0, Name: "- Issue Location Not Listed -" });
						return array;
					}
				
				case StringConst.MenuItemCode.ProductBasecode:			
					if(menuItem.menuItemCode == StringConst.MenuItemCode.Item) {
						array.push({ ID: -1, Name: "- Enter New Basecode -" });
						return array;
					}
				
				case StringConst.MenuItemCode.InstitutionType:
					if(menuItem.menuItemCode == StringConst.MenuItemCode.Institution) {
						if(user.userAccountTypeCode != "ADM") {
							return _.filter(array, function(institutionType) {
								return !_.includes(AppConst.Entity.Institution.AdminInstitutionTypes, institutionType.Code);
							});
						}
					}
				
				default:
					return array;
			}
		}
	});	

'use strict';

angular.module('pds')
	.constant('AppConst', {
		API_URL: {
            Account: {
                Users: "Users/:id",
                UserList: "Users/List",
                UserRole: "Users/ByRole/:roleID",
                Roles: "Roles/:id",
                Autenticate: "UserAccount/Authenticate",
                ChangePassword: "UserAccount/ChangePassword",
				ResetPassword: 'UserAccount/ResetPassword',
				SendResetCode: 'UserAccount/SendResetCode',
                ValidateToken: 'UserAccount/ValidateToken',
                Logout: 'UserAccount/Logout/:userID'
            }
		},
		Entity: {
			BlackListedColumnOnListPage: ["Description", "Level", "VolumeMetricsJoinedID"],
			FilterColumns: { 
				ItemUnitOfIssue: ['ID', 'ItemSn']
			},
			HasFilterInput: ['ItemUnitOfIssue', 'Product'],
			Item: {
				FacilityAccessLimitedColumns: [ "Activity", "Manufacturer", "Programt", "Supplier", 
						"RRGroup", "DemographicIndicator", "OwnershipType", "InstitutionType" ],
				PharmaceuticalColumnsOnAdd :  ['AbcID', 'DosageFormID', 'NearExpiryTrigger', 
						'NearExpiryTrigger_RDF', 'NeedBatch', 'NeedExpiry', 'VenID'],
				PharmaceuticalColumnsOnEdit :  ['DosageFormID'],
				DefaultItem: {
					Common: {
						Abccode: 'A',
						StorageTypeCode: 'OPEN'
					},
					Pharmaceutical: {
						NeedExpiry: true,
						NeedBatch: true,
						NearExpiry: 60,
						NearExpiryRDF: 15,
						Vencode: 'N'
					},
					NonPharmaceutical: {
						Vencode: 'V',
						NearExpiryRDF: 15
					}
				},
				DefaultItemData: ["ABC", "CommodityType", "StorageType", "VEN", "OwnershipType" ],
				ItemRelationshipData: ["ItemRRFGroup"],
				NonEditableColumns: ["CommodityType"],
				NonEditableColumnsAfterReceive: ["DosageForm", "Category", "CommodityType", 
						"NearExpiryTrigger", "Product", "ProductDescription", "ProductModel", "Strength" ],
				ValidationColumns: ["CommonName", "DosageForm", "ProductID", "StrengthID"],
				DependencyWithHeader: ["UnitOfIssue", "Programt", "GroupType"],
				DependencyAllowDelete: ["ItemCategory", "ItemProgramt"]
			},
			Institution: {
				AdminInstitutionTypes: [ "BYR", "CL", "CN", "ES", "HB", "IN", "MN" ] //"FM", "SU" //EFDA InstitutionType excluded
			},
			VolumeMetrics: {
				AccessLimitedColumns: [ "LengthCM", "WidthCM", "HeightCM", "PalletLengthCM", "PalletWidthCM", "PalletHeightCM", "WeightG", "PalletSectionHeader", "BlankLabel", "BlankLabel1", "BlankLabel2" ]
			},
			LevelInfo: {
				Category: [ 'Level One', 'Level Two', 'Level Three' ],
				StorageType: [ 'Parent Storage Type', 'Storage Type' ]
			},
			NonEditableEntities: [ "AnticancerItem", "PPLItemGroup", "DefaultAlternateItemUnitOfIssue", "DefaultItemUnitofIssuePPL", 
					"Mode", "Account", "SubAccount", "Activity", "Category", 
					"DosageForm", "MappedItem", "Product", "Strength", 
					"UnitOfIssue", "ABC", "VEN", "Country", "RRGroup", "SupplierType", 
					"ShippingContainerType", "CommodityType", "CommodityValue", "ItemUnitofIssuePPL", 
					"InstitutionEnhancement" ],
			HasNoDetailPage: [ "ItemUnitOfIssue", "ItemUnitOfIssueMapping", "VolumeMetricsDataEntry", "ItemUnitOfIssueFacility" ],
			HasNoAddPage: [  "AnticancerItem", "PPLItemGroup", "Category", "CommodityValue", "DefaultAlternateItemUnitOfIssue", 
					"DefaultItemUnitofIssuePPL", "ItemUnitOfIssue", "ItemUnitOfIssueMapping", 
					"MappedItem", "VolumeMetricsDataEntry", "ItemUnitofIssuePPL", "ItemUnitofIssueSOH", "LogChangeTracking", 
					"InstitutionEnhancement", "Basecode", "ItemUnitOfIssueFacility" ],
			RelatedMetaData: {
				Item: ["ItemRRGroup"],
				Accessory: [ "AccessoryManufacturer" ],
				UserAccountType: [ "UserAccountTypePDSPermissionMenuItem", "ItemUnitofIssueSOH" ],
				UserRole: [ "UserRoleOperation" ],
				Supplier: [ "SupplierCountry" ],
				LocalAgent: [ "LocalAgentSupplier" ],
				TermsAndCondtions: [ "TermsAndCondtionsPurchaseOrderType" ]
			},
			ReportPage: [ "AnticancerItem", "PPLItemGroup", "DefaultAlternateItemUnitOfIssue", "DefaultItemUnitofIssuePPL", 
					"MappedItem", "ItemUnitofIssuePPL", "ItemUnitofIssueSOH", "LogChangeTracking" ],
			PageWithFormatting: [ "AnticancerItem", "PPLItemGroup", "DefaultItemUnitofIssuePPL" ]
		},
		NgConfirm: {
			DefaultMessage: 'Are you sure to continue?',
			WarningMessage: {
				Deactivate: 'If an Item is inactive, HCMIS will block further receives.'
			}
		},
		NameFormat: {
			ItemUnitOfIssue: "ItemUnitOfIssueID - [ Item SN - Item Full Name ] - Unit",
			ItemUnitOfIssueMapping: "[ Item SN -  Item Full Name ] - Commodity Type Code - Unit"
		},
        UIConfig: {
            DataTable: {
                Language: {
                    "decimal": "",
                    "emptyTable": "No data available in table",
                    "info": "Showing _START_ to _END_ of _TOTAL_ entries",
                    "infoEmpty": "Showing 0 to 0 of 0 entries",
                    "infoFiltered": "(filtered from _MAX_ total entries)",
                    "infoPostFix": "",
                    "thousands": ",",
                    "lengthMenu": "Show _MENU_ entries",
                    "loadingRecords": "Loading...",
                    "processing": '<div class="sk-spinner sk-spinner-three-bounce"> <div class="sk-bounce1"></div> <div class="sk-bounce2"></div> <div class="sk-bounce3"></div> </div>',
                    "search": "",
                    "zeroRecords": "No matching records found",
                    "paginate": {
                        "first": "First",
                        "last": "Last",
                        "next": "Next",
                        "previous": "Previous"
                    },
                    "aria": {
                        "sortAscending": ": activate to sort column ascending",
                        "sortDescending": ": activate to sort column descending"
                    },
					"searchPlaceholder": '  Search ...',
					"columnDefs": [
						{ "width": "20%", "targets": 0 }
					]
                },
                DOM: {
                    All: "<'col-sm-6'l><'col-sm-6'f>rt<'col-sm-6'i><'col-sm-6'p>",
                    NoSearch: "<'col-sm-6'l><'pull-right'B>rt<'col-sm-6'i><'col-sm-6'p>"

				},
				SearchableColumns: [
					"Name", "FullItemName", "Sn"
				],
				NonSearchableColumns: [
					"LineNo"
				],
				PrimarySortColumn: [
					"Name", "FullItemName", "VolumeMetricsJoinedID"
				],
				XSmallWidthColumns: [
					"Code", "DurationSeconds", "DSource", "Sn", "LineNo", "IsActive", "IsConfirmed", "LCID", "IsSystemPaymentType", 
					"IsSystemReceiptType", "NSource", "Prefix", "ValidationCondition", "ItemSn", "LastReceive", "LastIssue", "SOH", 
					"Basecode"
				],
				SmallWidthColumns: [
					"ItemUnitofIssue", "UnitOfIssue"
				],
				MediumWidthColumns: [
					"CommodityType", "InstanceName", "DatabaseType", "Product", "ResourceType", "URL"
				]
			},
			UISelect: {
				ListPageSize: 100,
				LoadingRowTemplate: '<div ng-if="showLoadingRow"><span class="ui-select-choices-row-custom">Loading... Please wait</span></div>',
				PageRequestTemplate: {
					draw: 1,
					start: 0,
					length: 100,
					columns: [],
					order: [],
					additionalParameters: { }
				},
				DefaultSearch: {
					value: "",
					regex: true
				},
				DefaultSortColumn : {
					column: 0,
					dir: "asc"
				},
				DefaultSearchColumn: {
					data: "Name",
					searchable: true,
					orderable: true,
					search: {
						value: "",
						regex: false
					}
				}
			}
        },
        ResourceMethods: {
            All: {
                'query': { method: 'GET', isArray: true },
                'get': { method: 'GET' },
                'update': { method: 'PUT' },
                'save': { method: 'POST' },
                'delete': { method: 'DELETE' },
				'search': { method: 'POST' },
				'deactivate': { method: 'POST' },
				'generateStockCode': { method: 'GET' },
				'validateItem': { method: 'POST' },
				'validateEntity': { method: 'POST' },
				'export': { method: 'POST' }
			},
			CachedRequest: { 
				'query': { method: 'GET', isArray: true, cache: true }
			},
			CachedRequestWithTimeOut: { 
				'query': { method: 'GET', isArray: true, cache: true,  timeToLive: 15 * 60 * 1000 } // 15 minutes
			},
            Readonly: {
                'query': { method: 'GET', isArray: true },
                'get': { method: 'GET' }
            },
            Query: { method: 'GET', isArray: true },
            Get: { method: 'GET' },
            Update: { method: 'PUT' },
            Save: { method: 'POST' },
            Delete: { method: 'DELETE' },
            Search: { 'search': { method: 'POST', isArray: true } }
		},
		Password: {
			
			ChangeFail: "Password change failed!",
			ChangeSuccess: "passwords don't match.",
			DoNotMatch: "passwords don't match.",
			MinLength: 6,
			TooShort: "password too short. use at least 6 characters."
		},
		Permission: {
			Public: ['ProductAndItem', 'Item', 'Product', "PPLItemGroup", "DefaultAlternateItemUnitOfIssue", "DefaultItemUnitofIssuePPL", "AnticancerItem"],
			DC: ['ProductAndItem', 'Item', 'Product'],
			VMDE: ['ProductAndItem', 'VolumeMetricsDataEntry'],
			RD: ['ProductAndItem', 'Item', 'Product', 'ProductDescription', 'ProductModel', 'DosageForm', 'Manufacturer', 
					'Supplier', 'UnitOfIssue', 'Account', 'SubAccount', 'Activity'],
			ED: ['ProductAndItem', 'Item', 'ItemUnitOfIssueMapping', 'Product', 'ProductDescription', 'ProductModel', 'ProductSeries', 'DosageForm', 'Manufacturer', 
					'Supplier', 'UnitOfIssue', 'Strength', 'MappedItem', 'Account', 'SubAccount', 'Activity', 'VolumeMetricsDataEntry'],
			ItmED: ['ProductAndItem', 'Item', 'MappedItem', 'Manufacturer', 'Supplier', 'VolumeMetricsDataEntry'],
			Add: ['ED', 'ADM', 'DC', 'ItmED'],
			Edit: ['ED', 'ADM', 'DC', 'ItmED', 'VMDE'],
			Confirm: ['ADM', 'APR'],
			Deactivate: ['ED', 'APR', 'ADM']
		},
        StorageKeys: {
            UserInfo: true,
            Token: "Token",
            Permissions: "Permissions",
            ReturnUrl: "ReturnUrl"
		},
		Terms: {
			ItemDeactivate: {
				Template: 'ConfirmItemDeactivation',
				RequireFeedBack: true,
				Value: [
					"Block further receives. If an Item is inactive, HCMIS will block further receives.",
					"All ItemUnitOfIssues of this item will be deactivated."
				]
			},
			FacilityItemActivate: {
				Template: 'ConfirmItemDeactivation',
				RequireFeedBack: true,
				Value: [
					"Activate facility item."
				]
			},
			ItemActivate: {
				Template: 'ConfirmItemActivation',
				RequireFeedBack: true,
				Value: [
					"Item is mapped. Activating the item will unmap the item"
				]
			}
		}
	});
/**
 * INSPINIA - Responsive Admin Theme
 * 2.5
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeigh > wrapperHeigh){
      //angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if(navbarHeigh < wrapperHeigh){
      //angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        //angular.element('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
      } else {
        //angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
	'use strict';

	angular
		.module('pds')
		.run(runBlock)
		.config(config);

	/** @ngInject */
	function runBlock(AppConst, app_version, Idle, LocalDataService, PermissionService, StorageService, 
				$http, $location, $log, $rootScope, $state, $templateCache) {
		$rootScope.app_version = "1.0.0";
		$log.debug('runBlock end');
		$http.get('app/common/templates/layout/notify.html', {cache:$templateCache});
		$http.get('app/common/templates/error.html', {cache:$templateCache});
        $rootScope.$state = $state;

		var idleWaringModal = undefined;

		$rootScope.$on("$stateChangeStart",
			function(event, toState, toParams, fromState, fromParams) {
				// reset local storage if app version is changed
				resetLocalStorage();

				var token = StorageService.get(AppConst.StorageKeys.Token);
				var user = StorageService.get(AppConst.StorageKeys.UserInfo);
				if(toState.name !== 'login' && toState.name !== 'error') {
					if(token == undefined)
						$location.path('/login');
					else {
						var menuItem = LocalDataService.getMenuItemByLink(toParams.id);
						if(_.isUndefined(toParams.id)) {
							
						}
						else if(_.isUndefined(menuItem)) {
							$location.path('/login');
						}
						else {
							var isValid = PermissionService.checkPermission(user.userAccountTypeCode, 
									menuItem.menuItemCode);
							var action = toState.name.charAt(0).toUpperCase() + 
									toState.name.slice(1);
							var isAllowed = PermissionService.allowAction(action);
							if(!isValid || !isAllowed){
								$location.path('login');
							}
						}
					}
				}
			});

		function resetLocalStorage() {
			if(StorageService.get("app_version") === undefined 
					|| StorageService.get("app_version") !== app_version) {
				StorageService.removeAll();	
				StorageService.set("app_version", app_version);
				$state.go('login', { }, {reload: true});
			}
		}

		$rootScope.$on("$stateChangeError",
			function(event, toState, toParams, fromState, fromParams) {
				var x = toState.name;
			})

		$rootScope.$on("$locationChangeStart",
			function(event, next, current) {
				var x = next;
			})

		$rootScope.$on('IdleStart', function() {
			//Idle time count started
			idleWaringModal = $ngConfirm({
				title: 'Session Timeout',
				type: 'orange',
				content: "<div class='text-center'><span>You're being timed out due to inactivity</span><br/><span> You will be logged off until you start interacting with this page.</span></div>",
				backgroundDismiss: true

			});
		});

		$rootScope.$on('IdleTimeout', function() {
            //Time out ...so reroute to login
            idleWaringModal.close();
            Idle.unwatch();
            AccountService.logout("Timeout");
            $state.go('login');
            NotificationService.notify('You have been logged off because your session ended! \n Please login to continue.', 'alert-danger', 1000 * 3600 * 5);
            //display this for 5 hours.

        });


        $rootScope.$on('IdleWarn', function(e, countdown) {
            // follows after the IdleStart event, but includes a countdown until the user is considered timed out
            // the countdown arg is the number of seconds remaining until then.
            // you can change the title or display a warning dialog from here.
            // you can let them resume their session by calling Idle.watch
            idleWaringModal.setTitle('Session Timeout in ' + $filter('countDown')(countdown));
        });

        $rootScope.$on('IdleEnd', function() {
            // the user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
            idleWaringModal.close();
        });
	}

	function config(IdleProvider, KeepaliveProvider, $locationProvider){	
		$locationProvider.html5Mode(true);

        IdleProvider.idle(60); //10 minutes Idle time
        IdleProvider.timeout(30); //after 30 seconds of being idle, the timer starts
        KeepaliveProvider.interval(60 * 5); //5 minutes keep alive ping

        $locationProvider.html5Mode(true);
	}
})();

(function() {
  'use strict';

  angular
    .module('pds')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $httpProvider) {
    //http request and error interceptors
    $httpProvider.interceptors.push('httpInterceptor');

    //Anonymous routes
    $stateProvider
      .state('login', {
        url: '/login',
        parent: 'app',
        views: {
          'contentContainer@app': {
            templateUrl: 'app/account/login.html',
            controller: 'LoginController',
            controllerAs: 'vm'
          }
        }
      })
      .state('change', {
        url: '/change',
        parent: 'app',
        views: {
          'contentContainer@app': {
            templateUrl: 'app/account/changePassword.html',
            controller: 'ChangePasswordController',
            controllerAs: 'vm'
          }
        }
      })
      .state('reset', {
        url: '/reset/:username',
        parent: 'app',
        views: {
          'contentContainer@app': {
            templateUrl: 'app/account/resetPassword.html',
            controller: 'ResetPasswordController',
            controllerAs: 'vm'
          }
        },
				params: {
          username: null,
          message: null
				}
      })
      .state('reset_code', {
        url: '/reset_code',
        parent: 'app',
        views: {
          'contentContainer@app': {
            templateUrl: 'app/account/sendResetCode.html',
            controller: 'ResetPasswordController',
            controllerAs: 'vm'
          }
        },
      })
      .state('forgot', {
        url: '/forgot',
        parent: 'app',
        views: {
          'contentContainer@app': {
            templateUrl: 'app/account/forgot.html',
            controller: 'ForgotController',
            controllerAs: 'vm'
          }
        }
      })
      .state('index', {
        abstract: true,
        url: "/index",
        templateUrl: "app/common/templates/layout/content.html"
      })

      //Application States
      $stateProvider
        .state('app', {
          abstract: true,
          views: {
            'appContainer': {
                templateUrl: 'app/common/templates/layout/content.html'
            }
          },
          data: {
            RequireLogin: true
          }
        })

    $urlRouterProvider.otherwise('/list/Item');
  }

})();

angular.module("pds.config", [])
.constant("EnvironmentConfig", {"RootAPIURL":"https://pds-be.moh.gov.et/api/"})
.constant("app_version", "1.1.7");

angular.module("pds").run(["$templateCache", function($templateCache) {$templateCache.put("app/account/changePassword.html","<div class=\"ibox-title\"><div class=\"col-xs-12\"><h2>Change Password</h2></div></div><div class=\"ibox-content\"><div class=\"content-wrapper\"><div class=\"content-wrapper-in\"><div class=\"panel\"><div class=\"panel-body\"><processing is-content-loading=\"vm.isLoading\"></processing><form name=\"vm.changePasswordForm\" class=\"m-t\" role=\"form\" ng-submit=\"vm.changePassword()\"><div class=\"col-xs-6\"><div class=\"form-group\" ng-if=\"!vm.showPassword\"><input type=\"password\" name=\"oldPassword\" class=\"form-control\" placeholder=\"Old password\" ng-model=\"vm.changePasswordModel.oldPassword\" ng-blur=\"\" required=\"\"></div><div class=\"form-group\" ng-if=\"vm.showPassword\"><input type=\"text\" name=\"oldPassword\" class=\"form-control\" placeholder=\"Old password\" ng-model=\"vm.changePasswordModel.oldPassword\" ng-blur=\"\" required=\"\"></div><div class=\"form-group\" ng-if=\"!vm.showPassword\"><input type=\"password\" name=\"newPassword\" class=\"form-control\" placeholder=\"New password\" ng-model=\"vm.changePasswordModel.newPassword\" ng-blur=\"vm.validateForm()\" required=\"\"></div><div class=\"form-group\" ng-if=\"vm.showPassword\"><input type=\"text\" name=\"newPassword\" class=\"form-control\" placeholder=\"New password\" ng-model=\"vm.changePasswordModel.newPassword\" ng-blur=\"vm.validateForm()\" required=\"\"></div><div class=\"form-group\" ng-if=\"!vm.showPassword\"><input type=\"password\" name=\"Confirm\" class=\"form-control\" placeholder=\"Confirm new password\" ng-model=\"vm.changePasswordModel.Confirm\" ng-change=\"vm.validateForm()\" required=\"\"></div><div class=\"form-group\" ng-if=\"vm.showPassword\"><input type=\"text\" name=\"Confirm\" class=\"form-control\" placeholder=\"Confirm new password\" ng-model=\"vm.changePasswordModel.Confirm\" ng-change=\"vm.validateForm()\" required=\"\"></div><div class=\"form-group\"><p ng-show=\"!vm.isValid\" class=\"help-block text-danger\">{{ vm.errorMessage }}</p></div><div class=\"form-group\"><label><input type=\"checkbox\" ng-model=\"vm.showPassword\"> Show Password</label></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">Submit</button></div></form></div></div></div></div></div>");
$templateCache.put("app/account/change_password.html","<div class=\"row\"><form name=\"changeForm\" class=\"m-t\" role=\"form\" ng-validate-form=\"self.changeValidation\"><div class=\"form-group col-md-12\"><div class=\"col-xs-12\"><label>Old Password *</label><div><input type=\"password\" name=\"oldPassword\" class=\"form-control\" ng-model=\"self.changeModel.oldPassword\" ng-validate=\"self.changeValidation.oldPassword\"></div></div><div class=\"col-xs-12\"><span ng-if=\"!self.changeValidation.oldPassword && self.changeValidation.$showError\" class=\"help-block text-danger\">Old password is required</span></div></div><div class=\"form-group col-md-12\"><div class=\"col-xs-12\"><label>New Password *</label><div><input type=\"password\" name=\"newPassword\" class=\"form-control\" ng-model=\"self.changeModel.newPassword\" ng-validate=\"self.changeValidation.newPassword\"></div></div><div class=\"col-xs-12\"><span ng-if=\"!self.changeValidation.newPassword && self.changeValidation.$showError && self.passwordConfirmed\" class=\"help-block text-danger\">New password is required</span> <span ng-if=\"!self.passwordConfirmed && changeForm.newPassword.$touched\" class=\"help-block text-danger\">New password doesn\'t match</span></div></div><div class=\"form-group col-md-12\"><div class=\"col-xs-12\"><label>Confirm *</label><div><input type=\"password\" name=\"Confirm\" class=\"form-control\" ng-model=\"self.changeModel.Confirm\" ng-validate=\"self.changeValidation.confirm\"></div></div><div class=\"col-xs-12\"><span ng-if=\"!self.changeValidation.confirm && self.changeValidation.$showError && self.passwordConfirmed\" class=\"help-block text-danger\">Confirmation is required</span> <span ng-if=\"!self.passwordConfirmed && changeForm.Confirm.$touched\" class=\"help-block text-danger\">New password doesn\'t match</span></div></div></form></div>");
$templateCache.put("app/account/forgot.html","<div class=\"ibox-title\"><div class=\"col-xs-12\"><h2>Request password reset</h2></div></div><div class=\"ibox-content\"><div class=\"content-wrapper\"><div class=\"content-wrapper-in\"><div class=\"panel-body\"><div class=\"col-xs-6\"><form name=\"forgotForm\" class=\"m-t\" role=\"form\" ng-validate-form=\"vm.forgotValidation\" ng-submit=\"vm.submitEmail()\" novalidate=\"\"><div class=\"form-group\"><label>Please provide your username</label> <input type=\"text\" name=\"username\" class=\"form-control\" placeholder=\"Username\" ng-model=\"vm.forgotModel.username\" ng-validate=\"vm.forgotValidation.username\"><p ng-if=\"!vm.forgotValidation.username && vm.forgotValidation.$showError\" class=\"help-block text-danger\">Username is required</p></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">Submit</button></form><a ui-sref=\"login\"><small>Back to login</small></a></div></div></div></div></div>");
$templateCache.put("app/account/login.html","<div class=\"ibox-title\"><div class=\"col-xs-12\"><h2>Login</h2></div></div><div class=\"ibox-content\"><div class=\"content-wrapper\"><div class=\"content-wrapper-in\"><div class=\"panel\"><div class=\"panel-body\"><processing is-content-loading=\"vm.isLoading\"></processing><form name=\"loginForm\" class=\"m-t\" role=\"form\" ng-validate-form=\"vm.loginModelValidation\" ng-submit=\"vm.Authenticate()\"><div class=\"col-xs-6\"><div class=\"form-group\"><input type=\"text\" name=\"username\" class=\"form-control\" placeholder=\"Username\" ng-model=\"vm.loginModel.UserName\" required=\"\"></div><div class=\"form-group\" ng-if=\"!vm.showPassword\"><input type=\"password\" class=\"form-control\" placeholder=\"Password\" ng-model=\"vm.loginModel.Password\" required=\"\"></div><div class=\"form-group\" ng-if=\"vm.showPassword\"><input type=\"text\" class=\"form-control\" placeholder=\"Password\" ng-model=\"vm.loginModel.Password\" required=\"\"></div><div class=\"form-group\" ng-if=\"vm.loginModel.Password.length > 0\"><label><input type=\"checkbox\" ng-model=\"vm.showPassword\"> Show Password</label></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">Login</button><p ng-if=\"vm.loginFailed && vm.showError\" class=\"help-block text-danger\">Incorrect username or password</p><a ui-sref=\"reset_code\"><small>Forgot password?</small></a> <span></span><span class=\"badge badge-pill badge-secondary\">* new</span></div></form></div></div></div></div></div>");
$templateCache.put("app/account/resetPassword.html","<div class=\"ibox-title\"><div class=\"col-xs-12\"><h2>Reset Password</h2></div></div><div class=\"ibox-content\"><div class=\"content-wrapper\"><div class=\"content-wrapper-in\"><div class=\"panel\"><div class=\"panel-body\"><processing is-content-loading=\"vm.isLoading\"></processing><form name=\"vm.resetPasswordForm\" class=\"m-t\" role=\"form\" ng-submit=\"vm.resetPassword()\"><div class=\"col-xs-6\"><div class=\"form-group\"><input type=\"text\" name=\"userName\" class=\"form-control\" placeholder=\"User Name\" ng-model=\"vm.resetPasswordModel.userName\" ng-blur=\"\" required=\"\"></div><div class=\"form-group\"><input type=\"text\" name=\"resetCode\" class=\"form-control\" placeholder=\"Reset Code\" ng-model=\"vm.resetPasswordModel.resetCode\" ng-blur=\"vm.validateForm()\" required=\"\"></div><div class=\"form-group\"><p ng-show=\"!vm.isValid\" class=\"help-block text-danger\">{{ vm.errorMessage }}</p><p class=\"help-block text-success\">{{ vm.successMessage }}</p></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">Reset Password</button> <a ng-click=\"vm.sendResetCode()\" title=\"You have to enter user name\">send reset code again?</a></div></form></div></div></div></div></div>");
$templateCache.put("app/account/sendResetCode.html","<div class=\"ibox-title\"><div class=\"col-xs-12\"><h2>Get Reset Code</h2></div></div><div class=\"ibox-content\"><div class=\"content-wrapper\"><div class=\"content-wrapper-in\"><div class=\"panel\"><div class=\"panel-body\"><processing is-content-loading=\"vm.isLoading\"></processing><form class=\"m-t\" role=\"form\" ng-submit=\"vm.sendResetCode()\"><div class=\"col-xs-6\"><div class=\"form-group\"><input type=\"text\" name=\"userName\" class=\"form-control\" placeholder=\"User Name\" ng-model=\"vm.resetPasswordModel.userName\" ng-blur=\"\" required=\"\"></div><div class=\"form-group\"><p ng-show=\"!vm.isValid\" class=\"help-block text-danger\">{{ vm.errorMessage }}</p><p class=\"help-block text-success\">{{ vm.successMessage }}</p></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">Submit</button> <a ui-sref=\"reset\">click here if you already have reset code?</a></div></form></div></div></div></div></div>");
$templateCache.put("app/error/error.html","<div><div class=\"ibox-title\"><div class=\"col-xs-12\"><h2></h2></div></div></div><div class=\"ibox-content\"><div class=\"content-wrapper\"><div class=\"content-wrapper-in\"><error-template></error-template></div></div></div>");
$templateCache.put("app/common/templates/error.html","<div class=\"body-center-wrapper\"><div class=\"body-center\" style=\"display: block;\"><p class=\"body-center-text\">{{ errorController.errorMsg }}</p><p class=\"body-center-text\">{{ errorController.recommendedAction }}</p><p class=\"body-center-text body-center-text-2\" title=\"{{ errorController.actionTitle }}\"><a ng-click=\"errorController.action()\"><i class=\"{{ errorController.actionIcon }}\" aria-hidden=\"true\"></i></a></p></div></div>");
$templateCache.put("app/common/templates/processing.html","<div ng-if=\"isContentLoading\" class=\"processing-wrapper\"><div class=\"processing dataTables_processing\" style=\"display: block;\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div></div>");
$templateCache.put("app/item/add/add.html","<div class=\"ibox-title\"><div class=\"col-sm-8\"><a class=\"btn btn-primary btn-outline btn-xs left\" ui-sref=\"list({ id: vm.linkId })\"><i class=\"fa fa-arrow-left\"></i></a><div class=\"col-sm-10\"><h2>Add {{vm.menuItem.title}}</h2></div></div></div><div class=\"ibox-content\"><div class=\"content-wrapper\"><div id=\"add-edit-entity-form-wrapper\" class=\"content-wrapper-in\"><div class=\"panel-body\"><processing is-content-loading=\"vm.isLoading\"></processing><form name=\"vm.add\" ng-submit=\"vm.addItem()\"><div ng-class=\"{\'col-sm-6\': vm.menuItem.menuItemCode == \'Item\'}\"><div ng-if=\"columnInfo.IsVisible && (!columnInfo.IsAutoGenerated || columnInfo.Name == \'StockCode\') && (columnInfo.DataType != \'ICollection`1\' || columnInfo.Name == \'Category\')\" ng-repeat=\"columnInfo in vm.columnInfo | orderBy:\'Order\'\"><dynamic-input input-property=\"columnInfo\" input-model=\"vm.entity\" input-data=\"vm.dependency[columnInfo.Name]\" input-class=\"{\'col-sm-6\': vm.menuItem.menuItemCode != \'Item\'}\" menu-item=\"vm.menuItem\"></dynamic-input></div></div><div class=\"col-md-6\"><div ng-if=\"columnInfo.IsVisible && !columnInfo.IsAutoGenerated && (columnInfo.DataType == \'ICollection`1\' && columnInfo.Name != \'Category\')\" ng-repeat=\"columnInfo in vm.columnInfo | orderBy:\'Order\'\"><dynamic-input input-property=\"columnInfo\" input-model=\"vm.entity\" input-data=\"vm.dependency[columnInfo.Name]\" menu-item=\"vm.menuItem\"></dynamic-input></div></div><div class=\"form-group\" ng-if=\"vm.add.$valid\"><div class=\"col-sm-12\"><p class=\"text-danger\">{{vm.errors[0]}}</p></div></div><div class=\"form-group\" ng-if=\"vm.checkingError\"><div class=\"col-sm-12\"><p class=\"text-info\"><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i> validating...</p></div></div><div class=\"form-group\"><div class=\"button-margin-top page-ending col-sm-12\"><button class=\"btn btn-primary\" type=\"submit\" id=\"submit\">Add</button> <button class=\"btn btn-warning\" type=\"button\" id=\"reset\" ng-click=\"vm.resetForm()\">Reset</button></div></div></form></div></div></div></div>");
$templateCache.put("app/item/detail/detail.html","<div class=\"ibox-title\"><div class=\"col-sm-8\"><a class=\"btn btn-primary btn-outline btn-xs left\" ui-sref=\"list({ id: vm.linkId })\"><i class=\"fa fa-arrow-left\"></i></a><div class=\"col-sm-10\"><h2>{{vm.menuItem.title}} Detail</h2></div></div><div ibox-tools=\"\" class=\"pull-right\"><a class=\"btn btn-primary btn-outline btn-sm\" ng-if=\"vm.allowAction(\'Edit\')\" title=\"Edit {{vm.menuItem.title}}\" ui-sref=\"edit({ id: vm.linkId, objectId: vm.objectId})\">Edit</a> <a class=\"btn btn-warning btn-outline btn-sm\" ng-if=\"vm.allowAction(\'Confirm\')\" title=\"{{vm.confirmActionTitle}} {{vm.menuItem.title}}\" ng-click=\"vm.openConfirmationModal(\'Confirm\', vm.confirmActionTitle)\">{{vm.confirmActionTitle}}</a> <a class=\"btn btn-warning btn-outline btn-sm\" ng-if=\"vm.allowAction(\'Activate\')\" title=\"{{vm.activateActionTitle}} {{vm.menuItem.title}}\" ng-click=\"vm.openConfirmationModal(\'Activate\', vm.activateActionTitle)\">{{vm.activateActionTitle}}</a></div></div><div class=\"ibox-content\"><div class=\"content-wrapper\"><div class=\"content-wrapper-in\"><div class=\"panel-body\"><div class=\"panel-group\"><processing is-content-loading=\"vm.isLoading\"></processing><div ng-class=\"{\'col-sm-6\' : vm.isItemPage, \'col-sm-12\' : !vm.isItemPage}\" ng-if=\"vm.entity\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a ng-click=\"collapse = !collapse;\">General</a></h4></div><div class=\"panel-body\"><div ng-if=\"vm.entity.IsReceived\"><p class=\"text-danger\">This Item has been received by Center.</p></div><div ng-if=\"vm.showContent(columnInfo)\" ng-class=\"{\'col-sm-6\' : !vm.isItemPage}\" ng-repeat=\"columnInfo in vm.columnInfo | orderBy:\'Order\'\"><div><dl class=\"dl-horizontal\"><dt>{{columnInfo.DisplayName}} :</dt><dd>{{vm.entity[vm.getPropertyName(columnInfo)] | customFormat:columnInfo.DataType}}</dd></dl></div></div></div></div></div><div class=\"table-wrapper col-sm-6\" ng-if=\"vm.isItemPage\"><div class=\"table-wrapper-child row\"><div class=\"panel panel-default\" ng-repeat=\"dependency in vm.entityDependency | orderBy:\'order\'\" ng-if=\"dependency.isArray\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a ng-click=\"dependency.collapse = !dependency.collapse;\">{{dependency.name.replace(\'Programt\', \'Program\')}}</a></h4></div><div class=\"panel-body\" ng-if=\"!dependency.collapse\"><table ng-if=\"dependency.isArray || columnInfo.DataType == \'ICollection`1\'\" class=\"table table-condensed\"><thead ng-if=\"dependency.showHeader\"><tr><th>Name</th><th ng-if=\"dependency.data[0].Quantity != null\">Quantity</th><th ng-if=\"dependency.data[0].IsDefault != null\">Is Default</th><th ng-if=\"dependency.data[0].IsDefaultRRF != null\">Default RRF</th><th ng-if=\"dependency.data[0].IsActive != null\">Is Active</th><th ng-if=\"dependency.data[0].IsPPL != null\">Is PPL</th></tr></thead><tbody><tr ng-repeat=\"data in dependency.data | orderBy:\'Name\'\"><td>{{data[\"Name\"]}}</td><td ng-if=\"data.Country != undefined\">{{data.Country.Name | customFormat:\'String\'}}</td><td ng-if=\"data.Quantity != undefined\">{{data.Quantity | customFormat:\'Int32\'}}</td><td ng-if=\"data.IsDefault != undefined\" ng-class=\"{\'boolean booleanTrue\' : data.IsDefault, \'boolean booleanFalse\' : !data.IsDefault}\">{{data.IsDefault | customFormat:\'Boolean\'}}</td><td ng-if=\"data.IsDefaultRRF != undefined\" ng-class=\"{\'boolean booleanTrue\' : data.IsDefaultRRF, \'boolean booleanFalse\' : !data.IsDefaultRRF}\">{{data.IsDefaultRRF | customFormat:\'Boolean\'}}</td><td ng-if=\"data.IsActive != undefined\" ng-class=\"{\'boolean booleanTrue\' : data.IsActive, \'boolean booleanFalse\' : !data.IsActive}\">{{data.IsActive | customFormat:\'Boolean\'}}</td><td ng-if=\"data.IsPPL != undefined\" ng-class=\"{\'boolean booleanTrue\' : data.IsPPL, \'boolean booleanFalse\' : !data.IsPPL}\">{{data.IsPPL | customFormat:\'Boolean\'}}</td></tr></tbody><p ng-if=\"dependency.data.length == 0\">There is no data to display.</p></table></div></div></div></div><div class=\"table-wrapper col-sm-12\" ng-if=\"vm.menuItem.menuItemCode == \'Manufacturer\'\"><div class=\"table-wrapper-child\"><div class=\"panel panel-default\" ng-repeat=\"dependency in vm.entityDependency | orderBy:\'order\'\" ng-if=\"dependency.isArray\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a ng-click=\"dependency.collapse = !dependency.collapse;\">{{dependency.name}}</a></h4></div><div class=\"panel-body\" ng-if=\"dependency.collapse\"><table ng-if=\"dependency.isArray || columnInfo.DataType == \'ICollection`1\'\" class=\"table table-condensed\"><tbody><tr ng-repeat=\"data in dependency.data | orderBy:\'Name\'\"><td>{{data[\"Name\"]}}</td></tr></tbody><p ng-if=\"dependency.data.length == 0\">There is no data to display.</p></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/item/edit/edit.html","<div class=\"ibox-title\"><div class=\"col-sm-8\"><a ng-if=\"!vm.hasDetailPage\" class=\"btn btn-primary btn-outline btn-xs left\" ui-sref=\"detail({ id: vm.linkId, objectId: vm.objectId})\"><i class=\"fa fa-arrow-left\"></i></a> <a ng-if=\"vm.hasDetailPage\" class=\"btn btn-primary btn-outline btn-xs left\" ui-sref=\"list({ id: vm.linkId })\"><i class=\"fa fa-arrow-left\"></i></a><div class=\"col-sm-10\"><h2>Edit {{vm.menuItem.title}}</h2></div></div></div><div class=\"ibox-content\"><div class=\"content-wrapper\"><div id=\"add-edit-entity-form-wrapper\" class=\"content-wrapper-in\"><processing is-content-loading=\"vm.isLoading\"></processing><div class=\"panel-body\"><form name=\"vm.edit\" ng-submit=\"vm.editItem()\" ng-if=\"vm.entity\"><div class=\"col-md-12\" ng-if=\"vm.entity.IsReceived\"><p class=\"text-danger\">This Item has been received by Center.</p></div><div ng-class=\"{\'col-sm-6\': vm.menuItem.menuItemCode == \'Item\'}\"><div ng-if=\"vm.showInput(columnInfo)\" ng-repeat=\"columnInfo in vm.columnInfo | orderBy:\'Order\'\"><dynamic-input input-property=\"columnInfo\" input-model=\"vm.entity\" input-data=\"vm.dependency[columnInfo.Name]\" input-class=\"vm.inputClass\" menu-item=\"vm.menuItem\"></dynamic-input></div></div><div ng-class=\"vm.editClass\"><div ng-if=\"columnInfo.IsVisible && !columnInfo.IsAutoGenerated && (columnInfo.DataType == \'ICollection`1\' && columnInfo.Name != \'Category\')\" ng-repeat=\"columnInfo in vm.columnInfo | orderBy:\'Order\'\"><dynamic-input input-property=\"columnInfo\" input-model=\"vm.entity\" input-data=\"vm.dependency[columnInfo.Name]\" menu-item=\"vm.menuItem\"></dynamic-input></div></div><div class=\"col-sm-12\"><p class=\"text-success\">{{ vm.successMessage[0] }}</p><p class=\"text-danger\" ng-if=\"vm.successMessage.length == 0\">{{ vm.checkForError() || vm.errorMessage[0] }}</p><p class=\"text-warning\" ng-if=\"vm.entity.IsMapped\">{{ vm.editMappedItemWarning }}</p><p class=\"text-warning\" ng-if=\"vm.errorMessage.length == 0\">{{ vm.warningMessage[0] }}</p><p class=\"text-info\" ng-if=\"vm.checkingError\">validating...</p></div><div class=\"form-group\"><div class=\"button-margin-top page-ending col-sm-12\"><button class=\"btn btn-primary\" type=\"submit\" id=\"submit\">Save</button> <button class=\"btn btn-warning\" type=\"button\" id=\"reset\" ng-click=\"vm.resetForm()\">Reset</button> <button class=\"btn btn-default\" type=\"button\" id=\"generateStockCode\" ng-click=\"vm.generateStockCode()\" ng-if=\"vm.showGenerateStockCode()\">Generate Stockcode</button></div></div></form></div></div></div></div>");
$templateCache.put("app/item/list/list.html","<div class=\"ibox-title\"><div class=\"col-md-8\"><h2>{{vm.menuItem.title}}</h2></div><div ibox-tools=\"\" class=\"pull-right\"><a class=\"btn btn-primary btn-outline btn-sm\" type=\"button\" ui-sref=\"add({ id: vm.linkId})\" title=\"Add {{vm.menuItem.title}}\" ng-if=\"vm.allowAction(\'Add\')\">Add New</a> <a class=\"btn btn-primary btn-outline btn-sm btn-export\" type=\"button\" ng-click=\"vm.exportExcel()\" title=\"Export Excel\" ng-if=\"vm.allowAction(\'Export\')\"><i class=\"fa fa-file-excel-o\"></i></a></div></div><div class=\"ibox-content\"><div class=\"content-wrapper\"><div class=\"content-wrapper-in\"><div class=\"panel-body\"><div ng-if=\"vm.levelInfo\"><ul class=\"nav nav-pills\"><li ng-repeat=\"level in vm.levelInfo\" ng-class=\"{ active: vm.currentLevel == $index + 1 }\" ng-click=\"vm.setLevel($index + 1)\"><a href=\"#\">{{ level }}</a></li></ul></div><processing is-content-loading=\"vm.isLoading\"></processing><table ng-if=\"!vm.isLoading\" id=\"itemTableList\" class=\"table-responsive table-condensed table-striped row-border hover\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\"><tfoot style=\"display:table-header-group\"><tr><th><a class=\"btn btn-sm\" type=\"button\" ng-click=\"vm.clearColumnsSearchKey()\" title=\"clear\"><i class=\"fa fa-refresh fa-2x\"></i></a></th><th ng-if=\"column.IsVisible\" ng-repeat=\"column in vm.columnInfo\"><div class=\"form-group-sm\" ng-if=\"!column.Dependency\"><input ng-if=\"column.DataType != \'Boolean\'\" class=\"form-control input-sm search-input\" type=\"text\" ng-change=\"vm.search(vm.columnsSearchKey[$index])\" ng-model=\"vm.columnsSearchKey[$index]\" title=\"{{column.DisplayName.replace(\'Is \', \'\')}}\"></div><input ng-if=\"!column.Dependency && column.DataType == \'Boolean\'\" ng-model=\"vm.columnsSearchKey[$index]\" class=\"form-control input-sm search-input\" type=\"checkbox\" title=\"{{column.DisplayName.replace(\'Is \', \'\')}}\"><dynamic-ui-select ng-if=\"column.Dependency && vm.columnsSearchKey[$index] && column.Dependency != \'Item\'\" model=\"vm.columnsSearchKey\" index=\"$index\" choice-list=\"vm[\'ChoiceList\' + column.Dependency]\" choice-filter=\"vm[\'choiceFilter\' + column.FilterDependency]\"></dynamic-ui-select></th></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/common/templates/input/dynamic_input.html","<div><div ng-if=\"inputController.isInputVisible(inputProperty.Name)\"><legend ng-if=\"inputProperty.Name == \'StorageTypeID\' || inputProperty.Name == \'UnitOfIssue\'\"><p ng-if=\"inputProperty.Name == \'StorageTypeID\'\">Inventory Information</p><p style=\"padding-top:0.51em\" ng-if=\"inputProperty.Name == \'UnitOfIssue\'\">Relationship</p></legend><div ng-class=\"inputClass\"><div ng-if=\"!inputProperty.Dependency\"><div class=\"form-group-sm\" ng-if=\"inputProperty.DataType == \'Legend\'\"><label for=\"{{inputProperty.Name}}\"></label><legend><p>{{inputProperty.DisplayName}} &nbsp</p></legend></div><div class=\"form-group-sm\" ng-if=\"inputProperty.DataType == \'String\'\"><label for=\"{{inputProperty.Name}}\">{{inputProperty.DisplayName}} : <span class=\"text-danger\" ng-if=\"inputProperty.IsRequired && inputProperty.Name !== \'CommonName\'\">*</span> <span class=\"text-info name-format\" ng-if=\"inputProperty.DisplayName == \'Name\' || inputProperty.DisplayName == \'New Item\'\">{{ inputController.getNameFormat(menuItem.menuItemCode) }}</span></label> <input class=\"form-control input-sm\" ng-disabled=\"inputController.isInputDisabled(inputProperty)\" type=\"text\" id=\"{{inputProperty.Name}}\" ng-model=\"inputModel[inputProperty.Name]\" ng-required=\"inputProperty.IsRequired\" maxlength=\"{{ inputProperty.MaxLength }}\" title=\"{{ inputModel[inputProperty.Name] }}\" pattern=\"[\\S\\s]*\\S[\\S\\s]*\"></div><div class=\"form-group-sm\" ng-if=\"inputProperty.DataType == \'Int32\' || inputProperty.DataType == \'Int64\' || inputProperty.DataType == \'Int16\'\"><label for=\"{{inputProperty.Name}}\">{{inputProperty.DisplayName}} : <span class=\"text-danger\" ng-if=\"inputProperty.IsRequired\">*</span></label> <input class=\"form-control input-sm\" ng-disabled=\"inputProperty.IsAutoGenerated || inputController.isInputDisabled(inputProperty)\" type=\"Number\" min=\"0\" id=\"{{inputProperty.Name}}\" ng-model=\"inputModel[inputProperty.Name]\" ng-required=\"inputProperty.IsRequired\"></div><div class=\"form-group-sm\" ng-if=\"inputProperty.DataType == \'Double\' || inputProperty.DataType == \'Decimal\'\"><label for=\"{{inputProperty.Name}}\">{{inputProperty.DisplayName}} : <span class=\"text-danger\" ng-if=\"inputProperty.IsRequired\">*</span></label> <input class=\"form-control input-sm\" ng-disabled=\"inputController.isInputDisabled(inputProperty)\" type=\"Number\" step=\"any\" min=\"0\" id=\"{{inputProperty.Name}}\" ng-model=\"inputModel[inputProperty.Name]\" ng-required=\"inputProperty.IsRequired\"></div><div class=\"form-group-sm\" ng-if=\"inputProperty.DataType == \'DateTime\'\"><label for=\"{{inputProperty.Name}}\">{{inputProperty.DisplayName}} : <span class=\"text-danger\" ng-if=\"inputProperty.IsRequired\">*</span></label><p class=\"input-group\" style=\"margin:0px;\"><input id=\"{{inputProperty.Name}}\" ng-disabled=\"inputProperty.IsAutoGenerated || inputController.isInputDisabled(inputProperty)\" ng-model=\"inputModel[inputProperty.Name]\" type=\"text\" class=\"form-control\" ng-model-options=\"{timezone: \'utc\'}\" uib-datepicker-popup=\"\" is-open=\"inputProperty.isOpened\" close-text=\"Close\" ng-required=\"inputProperty.IsRequired\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"inputProperty.isOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group-sm\" ng-if=\"inputProperty.Dependency && inputProperty.DataType != \'ICollection`1\'\"><label>{{inputProperty.DisplayName}} : <span class=\"text-danger\" ng-if=\"inputProperty.IsRequired\">*</span></label><input style=\"position: absolute; width: 0%\" class=\"form-control\" type=\"text\" ng-model=\"inputModel[inputProperty.Name]\" ng-required=\"inputProperty.IsRequired\"><div class=\"input-group\" style=\"width: 100%\"><ui-select ui-select-custom-event-handler=\"\" on-select=\"inputController.onSelectCallback()\" ng-disabled=\"inputController.isInputDisabled(inputProperty)\" ng-model=\"inputModel[inputProperty.Name]\"><ui-select-match title=\"{{$select.selected[inputController.preferedProperty] || $select.selected[\'FullName\'] || inputModel[inputProperty.Name.replace(\'ID\',\'\')][inputController.preferedProperty] || inputModel[inputProperty.Name.replace(\'ID\',\'\')][\'Name\'] || inputModel[inputProperty.Name.replace(\'ID\',\'\')]}}\">{{$select.selected[inputController.preferedProperty] || $select.selected[\'Name\'] || inputModel[inputProperty.Name.replace(\'ID\',\'\')][inputController.preferedProperty] || inputModel[inputProperty.Name.replace(\'ID\',\'\')][\'Name\'] || inputModel[inputProperty.Name.replace(\'ID\',\'\')]}}</ui-select-match><ui-select-choices repeat=\"item.ID as item in inputController.dropDownData[inputProperty.Dependency] | filter : inputController.dropDownFilter\"><div ng-bind-html=\"item[inputController.preferedProperty] || item[\'Name\'] | highlight: $select.search\" title=\"{{ item[inputController.preferedProperty] || item[\'Name\'] }}\"></div></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12\" ng-if=\"inputProperty.DataType == \'Boolean\'\"><label><input ng-disabled=\"inputProperty.IsAutoGenerated || inputController.isInputDisabled(inputProperty)\" type=\"checkbox\" ng-model=\"inputModel[inputProperty.Name]\">{{inputProperty.DisplayName}} <span class=\"text-danger\" ng-if=\"inputProperty.IsRequired\">*</span></label></div><div class=\"form-group\" style=\"margin-bottom: 0;\" ng-if=\"inputProperty.DataType == \'ICollection`1\'\"><label>{{inputProperty.DisplayName.replace(\"Programt\", \"Program\")}} : <span class=\"text-danger\" ng-if=\"inputProperty.IsRequired && inputController.isMultipleUISelectRequired(inputProperty.Name)\">*</span></label><div class=\"input-group\" style=\"width: 100%\"><input style=\"position: absolute; width: 0%; height: 50%; z-index: -1\" class=\"form-control\" type=\"text\" ng-model=\"inputModel[inputProperty.Name]\" ng-required=\"inputProperty.IsRequired && inputController.isMultipleUISelectRequired(inputProperty.Name)\"><ui-select multiple=\"\" limit=\"{{ inputController.getLimit(inputProperty) }}\" ui-select-custom-event-handler=\"\" close-on-select=\"true\" sortable=\"true\" on-select=\"inputController.onSelectCallback()\" ng-model=\"inputModel[inputProperty.Name]\" ng-disabled=\"inputController.isMultipleUISelectDisabled() || inputController.isInputDisabled(inputProperty)\" id=\"{{ \'Item\' + inputProperty.Name }}\" reset-search-input=\"true\"><ui-select-match><span title=\"{{ $item[\'LongName\'] || $item[\'FullName\'] || $item[\'Name\'] }}\">{{ ($item[\'FullName\'] || $item[\'Name\']) | customizeString: 65 }}</span></ui-select-match><ui-select-choices repeat=\"item in inputController.dropDownData[inputProperty.Dependency] | orderBy:\'ParentCategory.Name\' | filter : inputController.dropDownFilter\"><span ng-bind-html=\"item[\'FullName\'] || item[\'Name\'] | highlight: $select.search\" title=\"{{ item[\'LongName\'] || item[\'FullName\'] || item[\'Name\'] }}\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"inputController.showDynamicDependencyForm(inputModel, inputProperty)\"><table class=\"table-responsive table-condensed table-stripedrow-border hover\"><tr><th class=\"col-sm-2\" ng-repeat=\"property in inputController[\'MetaData\' + menuItem.menuItemCode + inputProperty.Dependency]\" ng-if=\"property.IsVisible\">{{ property.DisplayName }}</th></tr><tr ng-repeat=\"model in inputModel[inputProperty.Name]\"><td class=\"col-sm-2\" ng-repeat=\"property in inputController[\'MetaData\' + menuItem.menuItemCode + inputProperty.Dependency]\" ng-if=\"property.IsVisible\"><span ng-if=\"$index == 0\">{{ model[property.Name] }}</span><div ng-if=\"$index != 0\"><simple-dynamic-input property-info=\"property\" model=\"model\"></simple-dynamic-input></div></td></tr></table></div><div class=\"form-group\" ng-if=\"inputController.showDependencyForm(inputModel, inputProperty)\"><table class=\"table-responsive table-condensed table-stripedrow-border hover\"><tr><th class=\"col-sm-2\">Name</th><th class=\"col-sm-2\" ng-if=\"inputController.showDependencyInput(inputProperty, \'Quantity\')\">Quantity</th><th class=\"col-sm-2\" ng-if=\"inputController.showDependencyInput(inputProperty, \'IsDefault\')\">Is Default</th><th class=\"col-sm-2\" ng-if=\"inputController.showDependencyInput(inputProperty, \'IsDefaultRRF\')\">Default RRF</th><th class=\"col-sm-2\" ng-if=\"inputController.showDependencyInput(inputProperty, \'IsActive\')\">Is Active</th><th class=\"col-sm-2\" ng-if=\"inputController.showDependencyInput(inputProperty, \'IsPPL\')\">Is PPL</th></tr><tr ng-repeat=\"unitOfIssue in inputModel[inputProperty.Name]\"><td class=\"col-sm-2\">{{ unitOfIssue.Name }}</td><td class=\"col-sm-1\" ng-if=\"inputController.showDependencyInput(inputProperty, \'Quantity\')\"><input type=\"Number\" min=\"0.0000001\" step=\"any\" placeholder=\"1\" ng-model=\"inputModel[\'UnitOfIssue\'][$index][\'Quantity\']\" required=\"\"></td><td ng-if=\"inputController.showDependencyInput(inputProperty, \'IsDefault\')\"><p class=\"col-sm-1\"></p><input class=\"col-sm-offset-1\" type=\"checkbox\" ng-model=\"inputModel[inputProperty.Name][$index][\'IsDefault\']\" ng-change=\"inputController.onIsDefaultChange($index, inputProperty.Name);\"></td><td class=\"col-sm-1\" ng-if=\"inputController.showDependencyInput(inputProperty, \'IsDefaultRRF\')\"><p class=\"col-sm-1\"></p><input type=\"checkbox\" ng-model=\"inputModel[\'UnitOfIssue\'][$index][\'IsDefaultRRF\']\" ng-change=\"inputController.onIsDefaultRRFChange($index, inputProperty.Name);\"></td><td class=\"col-sm-1\" ng-if=\"inputController.showDependencyInput(inputProperty, \'IsActive\')\"><p class=\"col-sm-1\"></p><input type=\"checkbox\" ng-disabled=\"!inputModel.IsActive\" ng-model=\"inputModel[\'UnitOfIssue\'][$index][\'IsActive\']\"></td><td class=\"col-sm-1\" ng-if=\"inputController.showDependencyInput(inputProperty, \'IsPPL\')\"><p class=\"col-sm-1\"></p><input type=\"checkbox\" ng-disabled=\"(!inputModel.IsActive) || (!inputModel[\'UnitOfIssue\'][$index][\'IsActive\'])\" ng-model=\"inputModel[\'UnitOfIssue\'][$index][\'IsPPL\']\" ng-change=\"inputController.onIsPPLChange($index, inputProperty.Name);\"></td></tr></table></div></div></div>");
$templateCache.put("app/common/templates/input/dynamic_ui_select.html","<div class=\"form-group-sm\"><ui-select ng-model=\"model[index]\" theme=\"bootstrap\"><ui-select-match title=\"{{ $select.selected.Name }}\">{{ $select.selected.Name }}</ui-select-match><ui-select-choices repeat=\"entity.ID + \'\' as entity in choiceList | orderBy:\'Name\' | filter: { Name: $select.search } | filter: choiceFilter\"><div><span ng-bind-html=\"entity.Name | highlight: $select.search\" title=\"{{ entity.Name }}\"></span></div></ui-select-choices></ui-select></div>");
$templateCache.put("app/common/templates/input/simple_dynamic_input.html","<span><span class=\"align-center\" ng-if=\"propertyInfo.DataType == \'Boolean\'\"><input type=\"checkbox\" ng-model=\"model[propertyInfo.Name]\"></span> <span ng-if=\"propertyInfo.DataType == \'Int32\' || propertyInfo.DataType == \'Int64\' || propertyInfo.DataType == \'Int16\'\"><input type=\"number\" min=\"0.0000001\" step=\"any\" placeholder=\"1\" required=\"\" ng-model=\"model[propertyInfo.Name]\"></span> <span ng-if=\"propertyInfo.DataType == \'String\'\"><input type=\"text\" ng-model=\"model[propertyInfo.Name]\"></span></span>");
$templateCache.put("app/common/templates/layout/content.html","<div id=\"wrapper\"><topbar></topbar><div class=\"main-content\"><div class=\"site-navigation\" ng-include=\"\'app/common/templates/layout/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div class=\"ui-view-body\" ui-view=\"contentContainer\"></div></div></div></div>");
$templateCache.put("app/common/templates/layout/footer.html","<div class=\"footer\"><div class=\"pull-right\"></div><div></div></div>");
$templateCache.put("app/common/templates/layout/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/common/templates/layout/navigation.html","<nav class=\"navbar-default navbar-static-side sidebar-collapse-wrapper\" role=\"navigation\" ng-controller=\"NavigationController as vm\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li id=\"iImport_min_max_button\"><span class=\"clear\" minimaliza-sidebar=\"\"></span></li><li ng-repeat=\"menuItem in vm.menuItems\" ng-if=\"vm.showMenuItem(menuItem.menuItemCode)\"><a ui-sref=\"{{menuItem.link}}\"><i class=\"{{menuItem.icon}}\"></i> <span class=\"nav-label\">{{menuItem.label}}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{ \'collapse in\': !vm.isUserLoggedOn }\"><li ui-sref-active=\"active\" ng-repeat=\"subMenu in menuItem.subMenu\" ng-if=\"vm.showMenuItem(subMenu.menuItemCode)\"><a ui-sref=\"{{subMenu.link}}\" title=\"{{subMenu.title}}\"><i class=\"{{subMenu.icon}}\"></i>{{subMenu.label}}</a></li></ul></li><li ng-if=\"vm.showLogin()\"><a ui-sref=\"login\" title=\"Login\"><i class=\"\"></i> <span class=\"nav-label\">Login</span></a></li></ul></div></nav>");
$templateCache.put("app/common/templates/layout/notify.html","<div class=\"cg-notify-message inspinia-notify cg-notify-message-right\" ng-class=\"$classes\" style=\"min-width: 250px\"><div class=\"p-md\"><div ng-show=\"!$messageTemplate\">{{$message}}</div><div ng-show=\"$messageTemplate\" class=\"cg-notify-message-template\"></div><button type=\"button\" class=\"cg-notify-close\" ng-click=\"$close()\"><span aria-hidden=\"true\">&times;</span> <span class=\"cg-notify-sr-only\">Close</span></button></div></div>");
$templateCache.put("app/common/templates/layout/topbarflex.html","<div class=\"site-header-flex\"><div class=\"site-header-right logo\"><img height=\"50px\" class=\"psa-logo\" ng-src=\"https://dl.dropboxusercontent.com/s/hnailv0i4jscxq2/logo.jpg?dl=0\" onerror=\"this.src=\'/assets/images/logo.jpg\'\"><div class=\"logo-text\"><img height=\"60px\" class=\"psa-logo\" ng-src=\"https://dl.dropboxusercontent.com/s/qrxal8k4dkgufx0/logo-text.JPG?dl=0\" onerror=\"this.src=\'/assets/images/logo-text.jpg\'\"></div></div><div class=\"site-header-left gradient-flex\" ng-controller=\"TopbarController as vm\"><div class=\"site-header-left-one\"><h2>Directory Service</h2><span ng-if=\"vm.version\">v {{ vm.version }}</span> <span ng-if=\"vm.apiVersion\">API v {{ vm.apiVersion }}</span></div><div class=\"site-header-left-two\"><div uib-dropdown=\"\" class=\"avatar-circle-wrapper\"><a uib-dropdown-toggle=\"\" href=\"\"><div class=\"avatar-circle\"><span class=\"initials\"><p ng-if=\"vm.isUserLoggedOn\">{{vm.userInfo.fullName.split(\" \")[0].charAt(0).toUpperCase()}}{{vm.userInfo.fullName.split(\" \")[1].charAt(0).toUpperCase()}}</p><p ng-if=\"!vm.isUserLoggedOn\"><i class=\"fa fa-cogs\"></i></p></span></div></a><div class=\"user-popup animated flipInX m-t-xs\" uib-dropdown-menu=\"\"><ul><li ng-if=\"vm.isUserLoggedOn\">{{vm.userInfo.fullName}}</li><li ng-if=\"vm.isUserLoggedOn\">({{vm.userInfo.userAccountType}})</li><li>Advanced Search<input type=\"checkbox\" style=\"float: right\" ng-model=\"vm.advancedSearch\" ng-click=\"vm.advancedSearchCheckboxClicked()\"></li><a ui-sref=\"change\" ng-if=\"vm.isUserLoggedOn\"><li>Change Password</li></a> <a ng-click=\"vm.logout()\" ng-if=\"vm.isUserLoggedOn\"><li>Log Out</li></a> <a ng-if=\"vm.showLogin()\" ui-sref=\"login\" title=\"Login\"><li>Login</li></a></ul></div></div></div></div></div>");
$templateCache.put("app/common/templates/layout/topnavbar.html","<div class=\"border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header site-header\"><div class=\"top-left\"><div class=\"logo-left\"></div></div><div class=\"title-logo gradient\" ng-controller=\"TopbarController as vm\"><div uib-dropdown=\"\" class=\"avatar-circle-wrapper\" ng-if=\"vm.isUserLoggedOn\"><a uib-dropdown-toggle=\"\" href=\"\"><div class=\"avatar-circle\"><span class=\"initials\">{{vm.userInfo.fullName.split(\" \")[0].charAt(0).toUpperCase()}}{{vm.userInfo.fullName.split(\" \")[1].charAt(0).toUpperCase()}}</span></div></a><div class=\"user-popup animated flipInX m-t-xs\" uib-dropdown-menu=\"\"><ul><li>{{vm.userInfo.fullName}}</li><li>({{vm.userInfo.userAccountType}})</li><a ui-sref=\"change\"><li>Change Password</li></a> <a ng-click=\"vm.logout()\"><li>Log Out</li></a></ul></div></div><div class=\"topbar-login\" ng-if=\"vm.showLogin()\"><a ui-sref=\"login\" title=\"Login\">Login</a></div><div class=\"logo-right\"><h2>Directory Service</h2></div></div></div></nav></div>");
$templateCache.put("app/common/templates/modal/activate_item.html","<div><br><form name=\"confirm-activate-item\"><div class=\"form-group-sm text-danger\" ng-repeat=\"term in vm.actionConfirmationTerms.Value\" ng-if=\"vm.actionConfirmationTerms.RequireFeedBack\"><input type=\"checkbox\" ng-model=\"vm.acceptTerms[$index]\"><span><span>{{term}}</span></span></div></form></div>");
$templateCache.put("app/common/templates/modal/deactivate_item.html","<div><br><form name=\"confirm-activate-item\"><div class=\"form-group-sm text-danger\" ng-repeat=\"term in vm.actionConfirmationTerms.Value\" ng-if=\"vm.actionConfirmationTerms.RequireFeedBack\"><input type=\"checkbox\" ng-model=\"vm.acceptTerms[$index]\"><span><span>{{term}}</span></span></div></form></div>");
$templateCache.put("app/common/templates/modal/modal_content.html","<div><div ng-if=\"vm.actionConfirmationTerms.Template == \'ConfirmItemDeactivation\'\"><deactivate-item></deactivate-item></div><div ng-if=\"vm.actionConfirmationTerms.Template == \'ConfirmItemActivation\'\"><activate-item></activate-item></div></div>");}]);